var Ai = { exports: {} }, Ur = {}, Bi = { exports: {} }, B = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var za;
function Ff() {
  if (za) return B;
  za = 1;
  var S = Symbol.for("react.element"), C = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), Y = Symbol.for("react.strict_mode"), le = Symbol.for("react.profiler"), pe = Symbol.for("react.provider"), X = Symbol.for("react.context"), ee = Symbol.for("react.forward_ref"), A = Symbol.for("react.suspense"), oe = Symbol.for("react.memo"), Q = Symbol.for("react.lazy"), V = Symbol.iterator;
  function b(c) {
    return c === null || typeof c != "object" ? null : (c = V && c[V] || c["@@iterator"], typeof c == "function" ? c : null);
  }
  var Ee = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, we = Object.assign, W = {};
  function te(c, v, F) {
    this.props = c, this.context = v, this.refs = W, this.updater = F || Ee;
  }
  te.prototype.isReactComponent = {}, te.prototype.setState = function(c, v) {
    if (typeof c != "object" && typeof c != "function" && c != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, c, v, "setState");
  }, te.prototype.forceUpdate = function(c) {
    this.updater.enqueueForceUpdate(this, c, "forceUpdate");
  };
  function ft() {
  }
  ft.prototype = te.prototype;
  function rt(c, v, F) {
    this.props = c, this.context = v, this.refs = W, this.updater = F || Ee;
  }
  var We = rt.prototype = new ft();
  We.constructor = rt, we(We, te.prototype), We.isPureReactComponent = !0;
  var ye = Array.isArray, Be = Object.prototype.hasOwnProperty, Pe = { current: null }, ze = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Ie(c, v, F) {
    var T, U = {}, $ = null, K = null;
    if (v != null) for (T in v.ref !== void 0 && (K = v.ref), v.key !== void 0 && ($ = "" + v.key), v) Be.call(v, T) && !ze.hasOwnProperty(T) && (U[T] = v[T]);
    var q = arguments.length - 2;
    if (q === 1) U.children = F;
    else if (1 < q) {
      for (var ie = Array(q), ge = 0; ge < q; ge++) ie[ge] = arguments[ge + 2];
      U.children = ie;
    }
    if (c && c.defaultProps) for (T in q = c.defaultProps, q) U[T] === void 0 && (U[T] = q[T]);
    return { $$typeof: S, type: c, key: $, ref: K, props: U, _owner: Pe.current };
  }
  function wt(c, v) {
    return { $$typeof: S, type: c.type, key: v, ref: c.ref, props: c.props, _owner: c._owner };
  }
  function lt(c) {
    return typeof c == "object" && c !== null && c.$$typeof === S;
  }
  function Ke(c) {
    var v = { "=": "=0", ":": "=2" };
    return "$" + c.replace(/[=:]/g, function(F) {
      return v[F];
    });
  }
  var Ve = /\/+/g;
  function Oe(c, v) {
    return typeof c == "object" && c !== null && c.key != null ? Ke("" + c.key) : v.toString(36);
  }
  function Re(c, v, F, T, U) {
    var $ = typeof c;
    ($ === "undefined" || $ === "boolean") && (c = null);
    var K = !1;
    if (c === null) K = !0;
    else switch ($) {
      case "string":
      case "number":
        K = !0;
        break;
      case "object":
        switch (c.$$typeof) {
          case S:
          case C:
            K = !0;
        }
    }
    if (K) return K = c, U = U(K), c = T === "" ? "." + Oe(K, 0) : T, ye(U) ? (F = "", c != null && (F = c.replace(Ve, "$&/") + "/"), Re(U, v, F, "", function(ge) {
      return ge;
    })) : U != null && (lt(U) && (U = wt(U, F + (!U.key || K && K.key === U.key ? "" : ("" + U.key).replace(Ve, "$&/") + "/") + c)), v.push(U)), 1;
    if (K = 0, T = T === "" ? "." : T + ":", ye(c)) for (var q = 0; q < c.length; q++) {
      $ = c[q];
      var ie = T + Oe($, q);
      K += Re($, v, F, ie, U);
    }
    else if (ie = b(c), typeof ie == "function") for (c = ie.call(c), q = 0; !($ = c.next()).done; ) $ = $.value, ie = T + Oe($, q++), K += Re($, v, F, ie, U);
    else if ($ === "object") throw v = String(c), Error("Objects are not valid as a React child (found: " + (v === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : v) + "). If you meant to render a collection of children, use an array instead.");
    return K;
  }
  function $e(c, v, F) {
    if (c == null) return c;
    var T = [], U = 0;
    return Re(c, T, "", "", function($) {
      return v.call(F, $, U++);
    }), T;
  }
  function Le(c) {
    if (c._status === -1) {
      var v = c._result;
      v = v(), v.then(function(F) {
        (c._status === 0 || c._status === -1) && (c._status = 1, c._result = F);
      }, function(F) {
        (c._status === 0 || c._status === -1) && (c._status = 2, c._result = F);
      }), c._status === -1 && (c._status = 0, c._result = v);
    }
    if (c._status === 1) return c._result.default;
    throw c._result;
  }
  var ne = { current: null }, N = { transition: null }, L = { ReactCurrentDispatcher: ne, ReactCurrentBatchConfig: N, ReactCurrentOwner: Pe };
  function g() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return B.Children = { map: $e, forEach: function(c, v, F) {
    $e(c, function() {
      v.apply(this, arguments);
    }, F);
  }, count: function(c) {
    var v = 0;
    return $e(c, function() {
      v++;
    }), v;
  }, toArray: function(c) {
    return $e(c, function(v) {
      return v;
    }) || [];
  }, only: function(c) {
    if (!lt(c)) throw Error("React.Children.only expected to receive a single React element child.");
    return c;
  } }, B.Component = te, B.Fragment = f, B.Profiler = le, B.PureComponent = rt, B.StrictMode = Y, B.Suspense = A, B.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = L, B.act = g, B.cloneElement = function(c, v, F) {
    if (c == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + c + ".");
    var T = we({}, c.props), U = c.key, $ = c.ref, K = c._owner;
    if (v != null) {
      if (v.ref !== void 0 && ($ = v.ref, K = Pe.current), v.key !== void 0 && (U = "" + v.key), c.type && c.type.defaultProps) var q = c.type.defaultProps;
      for (ie in v) Be.call(v, ie) && !ze.hasOwnProperty(ie) && (T[ie] = v[ie] === void 0 && q !== void 0 ? q[ie] : v[ie]);
    }
    var ie = arguments.length - 2;
    if (ie === 1) T.children = F;
    else if (1 < ie) {
      q = Array(ie);
      for (var ge = 0; ge < ie; ge++) q[ge] = arguments[ge + 2];
      T.children = q;
    }
    return { $$typeof: S, type: c.type, key: U, ref: $, props: T, _owner: K };
  }, B.createContext = function(c) {
    return c = { $$typeof: X, _currentValue: c, _currentValue2: c, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, c.Provider = { $$typeof: pe, _context: c }, c.Consumer = c;
  }, B.createElement = Ie, B.createFactory = function(c) {
    var v = Ie.bind(null, c);
    return v.type = c, v;
  }, B.createRef = function() {
    return { current: null };
  }, B.forwardRef = function(c) {
    return { $$typeof: ee, render: c };
  }, B.isValidElement = lt, B.lazy = function(c) {
    return { $$typeof: Q, _payload: { _status: -1, _result: c }, _init: Le };
  }, B.memo = function(c, v) {
    return { $$typeof: oe, type: c, compare: v === void 0 ? null : v };
  }, B.startTransition = function(c) {
    var v = N.transition;
    N.transition = {};
    try {
      c();
    } finally {
      N.transition = v;
    }
  }, B.unstable_act = g, B.useCallback = function(c, v) {
    return ne.current.useCallback(c, v);
  }, B.useContext = function(c) {
    return ne.current.useContext(c);
  }, B.useDebugValue = function() {
  }, B.useDeferredValue = function(c) {
    return ne.current.useDeferredValue(c);
  }, B.useEffect = function(c, v) {
    return ne.current.useEffect(c, v);
  }, B.useId = function() {
    return ne.current.useId();
  }, B.useImperativeHandle = function(c, v, F) {
    return ne.current.useImperativeHandle(c, v, F);
  }, B.useInsertionEffect = function(c, v) {
    return ne.current.useInsertionEffect(c, v);
  }, B.useLayoutEffect = function(c, v) {
    return ne.current.useLayoutEffect(c, v);
  }, B.useMemo = function(c, v) {
    return ne.current.useMemo(c, v);
  }, B.useReducer = function(c, v, F) {
    return ne.current.useReducer(c, v, F);
  }, B.useRef = function(c) {
    return ne.current.useRef(c);
  }, B.useState = function(c) {
    return ne.current.useState(c);
  }, B.useSyncExternalStore = function(c, v, F) {
    return ne.current.useSyncExternalStore(c, v, F);
  }, B.useTransition = function() {
    return ne.current.useTransition();
  }, B.version = "18.3.1", B;
}
var Ra;
function Qi() {
  return Ra || (Ra = 1, Bi.exports = Ff()), Bi.exports;
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var La;
function Uf() {
  if (La) return Ur;
  La = 1;
  var S = Qi(), C = Symbol.for("react.element"), f = Symbol.for("react.fragment"), Y = Object.prototype.hasOwnProperty, le = S.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, pe = { key: !0, ref: !0, __self: !0, __source: !0 };
  function X(ee, A, oe) {
    var Q, V = {}, b = null, Ee = null;
    oe !== void 0 && (b = "" + oe), A.key !== void 0 && (b = "" + A.key), A.ref !== void 0 && (Ee = A.ref);
    for (Q in A) Y.call(A, Q) && !pe.hasOwnProperty(Q) && (V[Q] = A[Q]);
    if (ee && ee.defaultProps) for (Q in A = ee.defaultProps, A) V[Q] === void 0 && (V[Q] = A[Q]);
    return { $$typeof: C, type: ee, key: b, ref: Ee, props: V, _owner: le.current };
  }
  return Ur.Fragment = f, Ur.jsx = X, Ur.jsxs = X, Ur;
}
var Ta;
function Af() {
  return Ta || (Ta = 1, Ai.exports = Uf()), Ai.exports;
}
var h = Af(), Xl = {}, Vi = { exports: {} }, qe = {}, $i = { exports: {} }, Hi = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ma;
function Bf() {
  return Ma || (Ma = 1, (function(S) {
    function C(N, L) {
      var g = N.length;
      N.push(L);
      e: for (; 0 < g; ) {
        var c = g - 1 >>> 1, v = N[c];
        if (0 < le(v, L)) N[c] = L, N[g] = v, g = c;
        else break e;
      }
    }
    function f(N) {
      return N.length === 0 ? null : N[0];
    }
    function Y(N) {
      if (N.length === 0) return null;
      var L = N[0], g = N.pop();
      if (g !== L) {
        N[0] = g;
        e: for (var c = 0, v = N.length, F = v >>> 1; c < F; ) {
          var T = 2 * (c + 1) - 1, U = N[T], $ = T + 1, K = N[$];
          if (0 > le(U, g)) $ < v && 0 > le(K, U) ? (N[c] = K, N[$] = g, c = $) : (N[c] = U, N[T] = g, c = T);
          else if ($ < v && 0 > le(K, g)) N[c] = K, N[$] = g, c = $;
          else break e;
        }
      }
      return L;
    }
    function le(N, L) {
      var g = N.sortIndex - L.sortIndex;
      return g !== 0 ? g : N.id - L.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var pe = performance;
      S.unstable_now = function() {
        return pe.now();
      };
    } else {
      var X = Date, ee = X.now();
      S.unstable_now = function() {
        return X.now() - ee;
      };
    }
    var A = [], oe = [], Q = 1, V = null, b = 3, Ee = !1, we = !1, W = !1, te = typeof setTimeout == "function" ? setTimeout : null, ft = typeof clearTimeout == "function" ? clearTimeout : null, rt = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function We(N) {
      for (var L = f(oe); L !== null; ) {
        if (L.callback === null) Y(oe);
        else if (L.startTime <= N) Y(oe), L.sortIndex = L.expirationTime, C(A, L);
        else break;
        L = f(oe);
      }
    }
    function ye(N) {
      if (W = !1, We(N), !we) if (f(A) !== null) we = !0, Le(Be);
      else {
        var L = f(oe);
        L !== null && ne(ye, L.startTime - N);
      }
    }
    function Be(N, L) {
      we = !1, W && (W = !1, ft(Ie), Ie = -1), Ee = !0;
      var g = b;
      try {
        for (We(L), V = f(A); V !== null && (!(V.expirationTime > L) || N && !Ke()); ) {
          var c = V.callback;
          if (typeof c == "function") {
            V.callback = null, b = V.priorityLevel;
            var v = c(V.expirationTime <= L);
            L = S.unstable_now(), typeof v == "function" ? V.callback = v : V === f(A) && Y(A), We(L);
          } else Y(A);
          V = f(A);
        }
        if (V !== null) var F = !0;
        else {
          var T = f(oe);
          T !== null && ne(ye, T.startTime - L), F = !1;
        }
        return F;
      } finally {
        V = null, b = g, Ee = !1;
      }
    }
    var Pe = !1, ze = null, Ie = -1, wt = 5, lt = -1;
    function Ke() {
      return !(S.unstable_now() - lt < wt);
    }
    function Ve() {
      if (ze !== null) {
        var N = S.unstable_now();
        lt = N;
        var L = !0;
        try {
          L = ze(!0, N);
        } finally {
          L ? Oe() : (Pe = !1, ze = null);
        }
      } else Pe = !1;
    }
    var Oe;
    if (typeof rt == "function") Oe = function() {
      rt(Ve);
    };
    else if (typeof MessageChannel < "u") {
      var Re = new MessageChannel(), $e = Re.port2;
      Re.port1.onmessage = Ve, Oe = function() {
        $e.postMessage(null);
      };
    } else Oe = function() {
      te(Ve, 0);
    };
    function Le(N) {
      ze = N, Pe || (Pe = !0, Oe());
    }
    function ne(N, L) {
      Ie = te(function() {
        N(S.unstable_now());
      }, L);
    }
    S.unstable_IdlePriority = 5, S.unstable_ImmediatePriority = 1, S.unstable_LowPriority = 4, S.unstable_NormalPriority = 3, S.unstable_Profiling = null, S.unstable_UserBlockingPriority = 2, S.unstable_cancelCallback = function(N) {
      N.callback = null;
    }, S.unstable_continueExecution = function() {
      we || Ee || (we = !0, Le(Be));
    }, S.unstable_forceFrameRate = function(N) {
      0 > N || 125 < N ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : wt = 0 < N ? Math.floor(1e3 / N) : 5;
    }, S.unstable_getCurrentPriorityLevel = function() {
      return b;
    }, S.unstable_getFirstCallbackNode = function() {
      return f(A);
    }, S.unstable_next = function(N) {
      switch (b) {
        case 1:
        case 2:
        case 3:
          var L = 3;
          break;
        default:
          L = b;
      }
      var g = b;
      b = L;
      try {
        return N();
      } finally {
        b = g;
      }
    }, S.unstable_pauseExecution = function() {
    }, S.unstable_requestPaint = function() {
    }, S.unstable_runWithPriority = function(N, L) {
      switch (N) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          N = 3;
      }
      var g = b;
      b = N;
      try {
        return L();
      } finally {
        b = g;
      }
    }, S.unstable_scheduleCallback = function(N, L, g) {
      var c = S.unstable_now();
      switch (typeof g == "object" && g !== null ? (g = g.delay, g = typeof g == "number" && 0 < g ? c + g : c) : g = c, N) {
        case 1:
          var v = -1;
          break;
        case 2:
          v = 250;
          break;
        case 5:
          v = 1073741823;
          break;
        case 4:
          v = 1e4;
          break;
        default:
          v = 5e3;
      }
      return v = g + v, N = { id: Q++, callback: L, priorityLevel: N, startTime: g, expirationTime: v, sortIndex: -1 }, g > c ? (N.sortIndex = g, C(oe, N), f(A) === null && N === f(oe) && (W ? (ft(Ie), Ie = -1) : W = !0, ne(ye, g - c))) : (N.sortIndex = v, C(A, N), we || Ee || (we = !0, Le(Be))), N;
    }, S.unstable_shouldYield = Ke, S.unstable_wrapCallback = function(N) {
      var L = b;
      return function() {
        var g = b;
        b = L;
        try {
          return N.apply(this, arguments);
        } finally {
          b = g;
        }
      };
    };
  })(Hi)), Hi;
}
var Ia;
function Vf() {
  return Ia || (Ia = 1, $i.exports = Bf()), $i.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oa;
function $f() {
  if (Oa) return qe;
  Oa = 1;
  var S = Qi(), C = Vf();
  function f(e) {
    for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var Y = /* @__PURE__ */ new Set(), le = {};
  function pe(e, t) {
    X(e, t), X(e + "Capture", t);
  }
  function X(e, t) {
    for (le[e] = t, e = 0; e < t.length; e++) Y.add(t[e]);
  }
  var ee = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), A = Object.prototype.hasOwnProperty, oe = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Q = {}, V = {};
  function b(e) {
    return A.call(V, e) ? !0 : A.call(Q, e) ? !1 : oe.test(e) ? V[e] = !0 : (Q[e] = !0, !1);
  }
  function Ee(e, t, n, r) {
    if (n !== null && n.type === 0) return !1;
    switch (typeof t) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
      default:
        return !1;
    }
  }
  function we(e, t, n, r) {
    if (t === null || typeof t > "u" || Ee(e, t, n, r)) return !0;
    if (r) return !1;
    if (n !== null) switch (n.type) {
      case 3:
        return !t;
      case 4:
        return t === !1;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
    return !1;
  }
  function W(e, t, n, r, l, o, i) {
    this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = l, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = i;
  }
  var te = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
    te[e] = new W(e, 0, !1, e, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
    var t = e[0];
    te[t] = new W(t, 1, !1, e[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
    te[e] = new W(e, 2, !1, e.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
    te[e] = new W(e, 2, !1, e, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
    te[e] = new W(e, 3, !1, e.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(e) {
    te[e] = new W(e, 3, !0, e, null, !1, !1);
  }), ["capture", "download"].forEach(function(e) {
    te[e] = new W(e, 4, !1, e, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(e) {
    te[e] = new W(e, 6, !1, e, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(e) {
    te[e] = new W(e, 5, !1, e.toLowerCase(), null, !1, !1);
  });
  var ft = /[\-:]([a-z])/g;
  function rt(e) {
    return e[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
    var t = e.replace(
      ft,
      rt
    );
    te[t] = new W(t, 1, !1, e, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
    var t = e.replace(ft, rt);
    te[t] = new W(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
    var t = e.replace(ft, rt);
    te[t] = new W(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(e) {
    te[e] = new W(e, 1, !1, e.toLowerCase(), null, !1, !1);
  }), te.xlinkHref = new W("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(e) {
    te[e] = new W(e, 1, !1, e.toLowerCase(), null, !0, !0);
  });
  function We(e, t, n, r) {
    var l = te.hasOwnProperty(t) ? te[t] : null;
    (l !== null ? l.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (we(t, n, l, r) && (n = null), r || l === null ? b(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : l.mustUseProperty ? e[l.propertyName] = n === null ? l.type === 3 ? !1 : "" : n : (t = l.attributeName, r = l.attributeNamespace, n === null ? e.removeAttribute(t) : (l = l.type, n = l === 3 || l === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
  }
  var ye = S.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Be = Symbol.for("react.element"), Pe = Symbol.for("react.portal"), ze = Symbol.for("react.fragment"), Ie = Symbol.for("react.strict_mode"), wt = Symbol.for("react.profiler"), lt = Symbol.for("react.provider"), Ke = Symbol.for("react.context"), Ve = Symbol.for("react.forward_ref"), Oe = Symbol.for("react.suspense"), Re = Symbol.for("react.suspense_list"), $e = Symbol.for("react.memo"), Le = Symbol.for("react.lazy"), ne = Symbol.for("react.offscreen"), N = Symbol.iterator;
  function L(e) {
    return e === null || typeof e != "object" ? null : (e = N && e[N] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var g = Object.assign, c;
  function v(e) {
    if (c === void 0) try {
      throw Error();
    } catch (n) {
      var t = n.stack.trim().match(/\n( *(at )?)/);
      c = t && t[1] || "";
    }
    return `
` + c + e;
  }
  var F = !1;
  function T(e, t) {
    if (!e || F) return "";
    F = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (t) if (t = function() {
        throw Error();
      }, Object.defineProperty(t.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(t, []);
        } catch (m) {
          var r = m;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (m) {
          r = m;
        }
        e.call(t.prototype);
      }
      else {
        try {
          throw Error();
        } catch (m) {
          r = m;
        }
        e();
      }
    } catch (m) {
      if (m && r && typeof m.stack == "string") {
        for (var l = m.stack.split(`
`), o = r.stack.split(`
`), i = l.length - 1, u = o.length - 1; 1 <= i && 0 <= u && l[i] !== o[u]; ) u--;
        for (; 1 <= i && 0 <= u; i--, u--) if (l[i] !== o[u]) {
          if (i !== 1 || u !== 1)
            do
              if (i--, u--, 0 > u || l[i] !== o[u]) {
                var s = `
` + l[i].replace(" at new ", " at ");
                return e.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e.displayName)), s;
              }
            while (1 <= i && 0 <= u);
          break;
        }
      }
    } finally {
      F = !1, Error.prepareStackTrace = n;
    }
    return (e = e ? e.displayName || e.name : "") ? v(e) : "";
  }
  function U(e) {
    switch (e.tag) {
      case 5:
        return v(e.type);
      case 16:
        return v("Lazy");
      case 13:
        return v("Suspense");
      case 19:
        return v("SuspenseList");
      case 0:
      case 2:
      case 15:
        return e = T(e.type, !1), e;
      case 11:
        return e = T(e.type.render, !1), e;
      case 1:
        return e = T(e.type, !0), e;
      default:
        return "";
    }
  }
  function $(e) {
    if (e == null) return null;
    if (typeof e == "function") return e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case ze:
        return "Fragment";
      case Pe:
        return "Portal";
      case wt:
        return "Profiler";
      case Ie:
        return "StrictMode";
      case Oe:
        return "Suspense";
      case Re:
        return "SuspenseList";
    }
    if (typeof e == "object") switch (e.$$typeof) {
      case Ke:
        return (e.displayName || "Context") + ".Consumer";
      case lt:
        return (e._context.displayName || "Context") + ".Provider";
      case Ve:
        var t = e.render;
        return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
      case $e:
        return t = e.displayName || null, t !== null ? t : $(e.type) || "Memo";
      case Le:
        t = e._payload, e = e._init;
        try {
          return $(e(t));
        } catch {
        }
    }
    return null;
  }
  function K(e) {
    var t = e.type;
    switch (e.tag) {
      case 24:
        return "Cache";
      case 9:
        return (t.displayName || "Context") + ".Consumer";
      case 10:
        return (t._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return t;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return $(t);
      case 8:
        return t === Ie ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof t == "function") return t.displayName || t.name || null;
        if (typeof t == "string") return t;
    }
    return null;
  }
  function q(e) {
    switch (typeof e) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function ie(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function ge(e) {
    var t = ie(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
    if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
      var l = n.get, o = n.set;
      return Object.defineProperty(e, t, { configurable: !0, get: function() {
        return l.call(this);
      }, set: function(i) {
        r = "" + i, o.call(this, i);
      } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
        return r;
      }, setValue: function(i) {
        r = "" + i;
      }, stopTracking: function() {
        e._valueTracker = null, delete e[t];
      } };
    }
  }
  function xn(e) {
    e._valueTracker || (e._valueTracker = ge(e));
  }
  function Ft(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var n = t.getValue(), r = "";
    return e && (r = ie(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
  }
  function on(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  function En(e, t) {
    var n = t.checked;
    return g({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
  }
  function Ut(e, t) {
    var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
    n = q(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
  }
  function Ar(e, t) {
    t = t.checked, t != null && We(e, "checked", t, !1);
  }
  function Jn(e, t) {
    Ar(e, t);
    var n = q(t.value), r = t.type;
    if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
    else if (r === "submit" || r === "reset") {
      e.removeAttribute("value");
      return;
    }
    t.hasOwnProperty("value") ? dt(e, t.type, n) : t.hasOwnProperty("defaultValue") && dt(e, t.type, q(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
  }
  function qn(e, t, n) {
    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
      var r = t.type;
      if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
      t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
    }
    n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
  }
  function dt(e, t, n) {
    (t !== "number" || on(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
  }
  var un = Array.isArray;
  function jt(e, t, n, r) {
    if (e = e.options, t) {
      t = {};
      for (var l = 0; l < n.length; l++) t["$" + n[l]] = !0;
      for (n = 0; n < e.length; n++) l = t.hasOwnProperty("$" + e[n].value), e[n].selected !== l && (e[n].selected = l), l && r && (e[n].defaultSelected = !0);
    } else {
      for (n = "" + q(n), t = null, l = 0; l < e.length; l++) {
        if (e[l].value === n) {
          e[l].selected = !0, r && (e[l].defaultSelected = !0);
          return;
        }
        t !== null || e[l].disabled || (t = e[l]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function At(e, t) {
    if (t.dangerouslySetInnerHTML != null) throw Error(f(91));
    return g({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
  }
  function bn(e, t) {
    var n = t.value;
    if (n == null) {
      if (n = t.children, t = t.defaultValue, n != null) {
        if (t != null) throw Error(f(92));
        if (un(n)) {
          if (1 < n.length) throw Error(f(93));
          n = n[0];
        }
        t = n;
      }
      t == null && (t = ""), n = t;
    }
    e._wrapperState = { initialValue: q(n) };
  }
  function Br(e, t) {
    var n = q(t.value), r = q(t.defaultValue);
    n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
  }
  function er(e) {
    var t = e.textContent;
    t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
  }
  function tr(e) {
    switch (e) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Cn(e, t) {
    return e == null || e === "http://www.w3.org/1999/xhtml" ? tr(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
  }
  var x, M = (function(e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, l) {
      MSApp.execUnsafeLocalFunction(function() {
        return e(t, n, r, l);
      });
    } : e;
  })(function(e, t) {
    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
    else {
      for (x = x || document.createElement("div"), x.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = x.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
      for (; t.firstChild; ) e.appendChild(t.firstChild);
    }
  });
  function G(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && n.nodeType === 3) {
        n.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var Ce = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, St = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ce).forEach(function(e) {
    St.forEach(function(t) {
      t = t + e.charAt(0).toUpperCase() + e.substring(1), Ce[t] = Ce[e];
    });
  });
  function sn(e, t, n) {
    return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || Ce.hasOwnProperty(e) && Ce[e] ? ("" + t).trim() : t + "px";
  }
  function Wi(e, t) {
    e = e.style;
    for (var n in t) if (t.hasOwnProperty(n)) {
      var r = n.indexOf("--") === 0, l = sn(n, t[n], r);
      n === "float" && (n = "cssFloat"), r ? e.setProperty(n, l) : e[n] = l;
    }
  }
  var Va = g({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Zl(e, t) {
    if (t) {
      if (Va[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(f(137, e));
      if (t.dangerouslySetInnerHTML != null) {
        if (t.children != null) throw Error(f(60));
        if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(f(61));
      }
      if (t.style != null && typeof t.style != "object") throw Error(f(62));
    }
  }
  function Jl(e, t) {
    if (e.indexOf("-") === -1) return typeof t.is == "string";
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var ql = null;
  function bl(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var eo = null, Nn = null, _n = null;
  function Ki(e) {
    if (e = Er(e)) {
      if (typeof eo != "function") throw Error(f(280));
      var t = e.stateNode;
      t && (t = al(t), eo(e.stateNode, e.type, t));
    }
  }
  function Yi(e) {
    Nn ? _n ? _n.push(e) : _n = [e] : Nn = e;
  }
  function Xi() {
    if (Nn) {
      var e = Nn, t = _n;
      if (_n = Nn = null, Ki(e), t) for (e = 0; e < t.length; e++) Ki(t[e]);
    }
  }
  function Gi(e, t) {
    return e(t);
  }
  function Zi() {
  }
  var to = !1;
  function Ji(e, t, n) {
    if (to) return e(t, n);
    to = !0;
    try {
      return Gi(e, t, n);
    } finally {
      to = !1, (Nn !== null || _n !== null) && (Zi(), Xi());
    }
  }
  function nr(e, t) {
    var n = e.stateNode;
    if (n === null) return null;
    var r = al(n);
    if (r === null) return null;
    n = r[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (n && typeof n != "function") throw Error(f(231, t, typeof n));
    return n;
  }
  var no = !1;
  if (ee) try {
    var rr = {};
    Object.defineProperty(rr, "passive", { get: function() {
      no = !0;
    } }), window.addEventListener("test", rr, rr), window.removeEventListener("test", rr, rr);
  } catch {
    no = !1;
  }
  function $a(e, t, n, r, l, o, i, u, s) {
    var m = Array.prototype.slice.call(arguments, 3);
    try {
      t.apply(n, m);
    } catch (k) {
      this.onError(k);
    }
  }
  var lr = !1, Vr = null, $r = !1, ro = null, Ha = { onError: function(e) {
    lr = !0, Vr = e;
  } };
  function Qa(e, t, n, r, l, o, i, u, s) {
    lr = !1, Vr = null, $a.apply(Ha, arguments);
  }
  function Wa(e, t, n, r, l, o, i, u, s) {
    if (Qa.apply(this, arguments), lr) {
      if (lr) {
        var m = Vr;
        lr = !1, Vr = null;
      } else throw Error(f(198));
      $r || ($r = !0, ro = m);
    }
  }
  function an(e) {
    var t = e, n = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else {
      e = t;
      do
        t = e, (t.flags & 4098) !== 0 && (n = t.return), e = t.return;
      while (e);
    }
    return t.tag === 3 ? n : null;
  }
  function qi(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function bi(e) {
    if (an(e) !== e) throw Error(f(188));
  }
  function Ka(e) {
    var t = e.alternate;
    if (!t) {
      if (t = an(e), t === null) throw Error(f(188));
      return t !== e ? null : e;
    }
    for (var n = e, r = t; ; ) {
      var l = n.return;
      if (l === null) break;
      var o = l.alternate;
      if (o === null) {
        if (r = l.return, r !== null) {
          n = r;
          continue;
        }
        break;
      }
      if (l.child === o.child) {
        for (o = l.child; o; ) {
          if (o === n) return bi(l), e;
          if (o === r) return bi(l), t;
          o = o.sibling;
        }
        throw Error(f(188));
      }
      if (n.return !== r.return) n = l, r = o;
      else {
        for (var i = !1, u = l.child; u; ) {
          if (u === n) {
            i = !0, n = l, r = o;
            break;
          }
          if (u === r) {
            i = !0, r = l, n = o;
            break;
          }
          u = u.sibling;
        }
        if (!i) {
          for (u = o.child; u; ) {
            if (u === n) {
              i = !0, n = o, r = l;
              break;
            }
            if (u === r) {
              i = !0, r = o, n = l;
              break;
            }
            u = u.sibling;
          }
          if (!i) throw Error(f(189));
        }
      }
      if (n.alternate !== r) throw Error(f(190));
    }
    if (n.tag !== 3) throw Error(f(188));
    return n.stateNode.current === n ? e : t;
  }
  function eu(e) {
    return e = Ka(e), e !== null ? tu(e) : null;
  }
  function tu(e) {
    if (e.tag === 5 || e.tag === 6) return e;
    for (e = e.child; e !== null; ) {
      var t = tu(e);
      if (t !== null) return t;
      e = e.sibling;
    }
    return null;
  }
  var nu = C.unstable_scheduleCallback, ru = C.unstable_cancelCallback, Ya = C.unstable_shouldYield, Xa = C.unstable_requestPaint, he = C.unstable_now, Ga = C.unstable_getCurrentPriorityLevel, lo = C.unstable_ImmediatePriority, lu = C.unstable_UserBlockingPriority, Hr = C.unstable_NormalPriority, Za = C.unstable_LowPriority, ou = C.unstable_IdlePriority, Qr = null, xt = null;
  function Ja(e) {
    if (xt && typeof xt.onCommitFiberRoot == "function") try {
      xt.onCommitFiberRoot(Qr, e, void 0, (e.current.flags & 128) === 128);
    } catch {
    }
  }
  var pt = Math.clz32 ? Math.clz32 : ec, qa = Math.log, ba = Math.LN2;
  function ec(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (qa(e) / ba | 0) | 0;
  }
  var Wr = 64, Kr = 4194304;
  function or(e) {
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return e & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return e;
    }
  }
  function Yr(e, t) {
    var n = e.pendingLanes;
    if (n === 0) return 0;
    var r = 0, l = e.suspendedLanes, o = e.pingedLanes, i = n & 268435455;
    if (i !== 0) {
      var u = i & ~l;
      u !== 0 ? r = or(u) : (o &= i, o !== 0 && (r = or(o)));
    } else i = n & ~l, i !== 0 ? r = or(i) : o !== 0 && (r = or(o));
    if (r === 0) return 0;
    if (t !== 0 && t !== r && (t & l) === 0 && (l = r & -r, o = t & -t, l >= o || l === 16 && (o & 4194240) !== 0)) return t;
    if ((r & 4) !== 0 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - pt(t), l = 1 << n, r |= e[n], t &= ~l;
    return r;
  }
  function tc(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
        return t + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function nc(e, t) {
    for (var n = e.suspendedLanes, r = e.pingedLanes, l = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
      var i = 31 - pt(o), u = 1 << i, s = l[i];
      s === -1 ? ((u & n) === 0 || (u & r) !== 0) && (l[i] = tc(u, t)) : s <= t && (e.expiredLanes |= u), o &= ~u;
    }
  }
  function oo(e) {
    return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
  }
  function iu() {
    var e = Wr;
    return Wr <<= 1, (Wr & 4194240) === 0 && (Wr = 64), e;
  }
  function io(e) {
    for (var t = [], n = 0; 31 > n; n++) t.push(e);
    return t;
  }
  function ir(e, t, n) {
    e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - pt(t), e[t] = n;
  }
  function rc(e, t) {
    var n = e.pendingLanes & ~t;
    e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
    var r = e.eventTimes;
    for (e = e.expirationTimes; 0 < n; ) {
      var l = 31 - pt(n), o = 1 << l;
      t[l] = 0, r[l] = -1, e[l] = -1, n &= ~o;
    }
  }
  function uo(e, t) {
    var n = e.entangledLanes |= t;
    for (e = e.entanglements; n; ) {
      var r = 31 - pt(n), l = 1 << r;
      l & t | e[r] & t && (e[r] |= t), n &= ~l;
    }
  }
  var re = 0;
  function uu(e) {
    return e &= -e, 1 < e ? 4 < e ? (e & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var su, so, au, cu, fu, ao = !1, Xr = [], Bt = null, Vt = null, $t = null, ur = /* @__PURE__ */ new Map(), sr = /* @__PURE__ */ new Map(), Ht = [], lc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function du(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        Bt = null;
        break;
      case "dragenter":
      case "dragleave":
        Vt = null;
        break;
      case "mouseover":
      case "mouseout":
        $t = null;
        break;
      case "pointerover":
      case "pointerout":
        ur.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        sr.delete(t.pointerId);
    }
  }
  function ar(e, t, n, r, l, o) {
    return e === null || e.nativeEvent !== o ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: o, targetContainers: [l] }, t !== null && (t = Er(t), t !== null && so(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, l !== null && t.indexOf(l) === -1 && t.push(l), e);
  }
  function oc(e, t, n, r, l) {
    switch (t) {
      case "focusin":
        return Bt = ar(Bt, e, t, n, r, l), !0;
      case "dragenter":
        return Vt = ar(Vt, e, t, n, r, l), !0;
      case "mouseover":
        return $t = ar($t, e, t, n, r, l), !0;
      case "pointerover":
        var o = l.pointerId;
        return ur.set(o, ar(ur.get(o) || null, e, t, n, r, l)), !0;
      case "gotpointercapture":
        return o = l.pointerId, sr.set(o, ar(sr.get(o) || null, e, t, n, r, l)), !0;
    }
    return !1;
  }
  function pu(e) {
    var t = cn(e.target);
    if (t !== null) {
      var n = an(t);
      if (n !== null) {
        if (t = n.tag, t === 13) {
          if (t = qi(n), t !== null) {
            e.blockedOn = t, fu(e.priority, function() {
              au(n);
            });
            return;
          }
        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function Gr(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var n = fo(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
      if (n === null) {
        n = e.nativeEvent;
        var r = new n.constructor(n.type, n);
        ql = r, n.target.dispatchEvent(r), ql = null;
      } else return t = Er(n), t !== null && so(t), e.blockedOn = n, !1;
      t.shift();
    }
    return !0;
  }
  function mu(e, t, n) {
    Gr(e) && n.delete(t);
  }
  function ic() {
    ao = !1, Bt !== null && Gr(Bt) && (Bt = null), Vt !== null && Gr(Vt) && (Vt = null), $t !== null && Gr($t) && ($t = null), ur.forEach(mu), sr.forEach(mu);
  }
  function cr(e, t) {
    e.blockedOn === t && (e.blockedOn = null, ao || (ao = !0, C.unstable_scheduleCallback(C.unstable_NormalPriority, ic)));
  }
  function fr(e) {
    function t(l) {
      return cr(l, e);
    }
    if (0 < Xr.length) {
      cr(Xr[0], e);
      for (var n = 1; n < Xr.length; n++) {
        var r = Xr[n];
        r.blockedOn === e && (r.blockedOn = null);
      }
    }
    for (Bt !== null && cr(Bt, e), Vt !== null && cr(Vt, e), $t !== null && cr($t, e), ur.forEach(t), sr.forEach(t), n = 0; n < Ht.length; n++) r = Ht[n], r.blockedOn === e && (r.blockedOn = null);
    for (; 0 < Ht.length && (n = Ht[0], n.blockedOn === null); ) pu(n), n.blockedOn === null && Ht.shift();
  }
  var jn = ye.ReactCurrentBatchConfig, Zr = !0;
  function uc(e, t, n, r) {
    var l = re, o = jn.transition;
    jn.transition = null;
    try {
      re = 1, co(e, t, n, r);
    } finally {
      re = l, jn.transition = o;
    }
  }
  function sc(e, t, n, r) {
    var l = re, o = jn.transition;
    jn.transition = null;
    try {
      re = 4, co(e, t, n, r);
    } finally {
      re = l, jn.transition = o;
    }
  }
  function co(e, t, n, r) {
    if (Zr) {
      var l = fo(e, t, n, r);
      if (l === null) zo(e, t, r, Jr, n), du(e, r);
      else if (oc(l, e, t, n, r)) r.stopPropagation();
      else if (du(e, r), t & 4 && -1 < lc.indexOf(e)) {
        for (; l !== null; ) {
          var o = Er(l);
          if (o !== null && su(o), o = fo(e, t, n, r), o === null && zo(e, t, r, Jr, n), o === l) break;
          l = o;
        }
        l !== null && r.stopPropagation();
      } else zo(e, t, r, null, n);
    }
  }
  var Jr = null;
  function fo(e, t, n, r) {
    if (Jr = null, e = bl(r), e = cn(e), e !== null) if (t = an(e), t === null) e = null;
    else if (n = t.tag, n === 13) {
      if (e = qi(t), e !== null) return e;
      e = null;
    } else if (n === 3) {
      if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
      e = null;
    } else t !== e && (e = null);
    return Jr = e, null;
  }
  function hu(e) {
    switch (e) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Ga()) {
          case lo:
            return 1;
          case lu:
            return 4;
          case Hr:
          case Za:
            return 16;
          case ou:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Qt = null, po = null, qr = null;
  function vu() {
    if (qr) return qr;
    var e, t = po, n = t.length, r, l = "value" in Qt ? Qt.value : Qt.textContent, o = l.length;
    for (e = 0; e < n && t[e] === l[e]; e++) ;
    var i = n - e;
    for (r = 1; r <= i && t[n - r] === l[o - r]; r++) ;
    return qr = l.slice(e, 1 < r ? 1 - r : void 0);
  }
  function br(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function el() {
    return !0;
  }
  function yu() {
    return !1;
  }
  function be(e) {
    function t(n, r, l, o, i) {
      this._reactName = n, this._targetInst = l, this.type = r, this.nativeEvent = o, this.target = i, this.currentTarget = null;
      for (var u in e) e.hasOwnProperty(u) && (n = e[u], this[u] = n ? n(o) : o[u]);
      return this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? el : yu, this.isPropagationStopped = yu, this;
    }
    return g(t.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var n = this.nativeEvent;
      n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = el);
    }, stopPropagation: function() {
      var n = this.nativeEvent;
      n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = el);
    }, persist: function() {
    }, isPersistent: el }), t;
  }
  var Pn = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
    return e.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, mo = be(Pn), dr = g({}, Pn, { view: 0, detail: 0 }), ac = be(dr), ho, vo, pr, tl = g({}, dr, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: go, button: 0, buttons: 0, relatedTarget: function(e) {
    return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
  }, movementX: function(e) {
    return "movementX" in e ? e.movementX : (e !== pr && (pr && e.type === "mousemove" ? (ho = e.screenX - pr.screenX, vo = e.screenY - pr.screenY) : vo = ho = 0, pr = e), ho);
  }, movementY: function(e) {
    return "movementY" in e ? e.movementY : vo;
  } }), gu = be(tl), cc = g({}, tl, { dataTransfer: 0 }), fc = be(cc), dc = g({}, dr, { relatedTarget: 0 }), yo = be(dc), pc = g({}, Pn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), mc = be(pc), hc = g({}, Pn, { clipboardData: function(e) {
    return "clipboardData" in e ? e.clipboardData : window.clipboardData;
  } }), vc = be(hc), yc = g({}, Pn, { data: 0 }), ku = be(yc), gc = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, kc = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, wc = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Sc(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = wc[e]) ? !!t[e] : !1;
  }
  function go() {
    return Sc;
  }
  var xc = g({}, dr, { key: function(e) {
    if (e.key) {
      var t = gc[e.key] || e.key;
      if (t !== "Unidentified") return t;
    }
    return e.type === "keypress" ? (e = br(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? kc[e.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: go, charCode: function(e) {
    return e.type === "keypress" ? br(e) : 0;
  }, keyCode: function(e) {
    return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
  }, which: function(e) {
    return e.type === "keypress" ? br(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
  } }), Ec = be(xc), Cc = g({}, tl, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), wu = be(Cc), Nc = g({}, dr, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: go }), _c = be(Nc), jc = g({}, Pn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Pc = be(jc), zc = g({}, tl, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Rc = be(zc), Lc = [9, 13, 27, 32], ko = ee && "CompositionEvent" in window, mr = null;
  ee && "documentMode" in document && (mr = document.documentMode);
  var Tc = ee && "TextEvent" in window && !mr, Su = ee && (!ko || mr && 8 < mr && 11 >= mr), xu = " ", Eu = !1;
  function Cu(e, t) {
    switch (e) {
      case "keyup":
        return Lc.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Nu(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var zn = !1;
  function Mc(e, t) {
    switch (e) {
      case "compositionend":
        return Nu(t);
      case "keypress":
        return t.which !== 32 ? null : (Eu = !0, xu);
      case "textInput":
        return e = t.data, e === xu && Eu ? null : e;
      default:
        return null;
    }
  }
  function Ic(e, t) {
    if (zn) return e === "compositionend" || !ko && Cu(e, t) ? (e = vu(), qr = po = Qt = null, zn = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length) return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return Su && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Oc = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function _u(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!Oc[e.type] : t === "textarea";
  }
  function ju(e, t, n, r) {
    Yi(r), t = il(t, "onChange"), 0 < t.length && (n = new mo("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
  }
  var hr = null, vr = null;
  function Dc(e) {
    Wu(e, 0);
  }
  function nl(e) {
    var t = In(e);
    if (Ft(t)) return e;
  }
  function Fc(e, t) {
    if (e === "change") return t;
  }
  var Pu = !1;
  if (ee) {
    var wo;
    if (ee) {
      var So = "oninput" in document;
      if (!So) {
        var zu = document.createElement("div");
        zu.setAttribute("oninput", "return;"), So = typeof zu.oninput == "function";
      }
      wo = So;
    } else wo = !1;
    Pu = wo && (!document.documentMode || 9 < document.documentMode);
  }
  function Ru() {
    hr && (hr.detachEvent("onpropertychange", Lu), vr = hr = null);
  }
  function Lu(e) {
    if (e.propertyName === "value" && nl(vr)) {
      var t = [];
      ju(t, vr, e, bl(e)), Ji(Dc, t);
    }
  }
  function Uc(e, t, n) {
    e === "focusin" ? (Ru(), hr = t, vr = n, hr.attachEvent("onpropertychange", Lu)) : e === "focusout" && Ru();
  }
  function Ac(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown") return nl(vr);
  }
  function Bc(e, t) {
    if (e === "click") return nl(t);
  }
  function Vc(e, t) {
    if (e === "input" || e === "change") return nl(t);
  }
  function $c(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var mt = typeof Object.is == "function" ? Object.is : $c;
  function yr(e, t) {
    if (mt(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
    var n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length) return !1;
    for (r = 0; r < n.length; r++) {
      var l = n[r];
      if (!A.call(t, l) || !mt(e[l], t[l])) return !1;
    }
    return !0;
  }
  function Tu(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function Mu(e, t) {
    var n = Tu(e);
    e = 0;
    for (var r; n; ) {
      if (n.nodeType === 3) {
        if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
        e = r;
      }
      e: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break e;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = Tu(n);
    }
  }
  function Iu(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Iu(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function Ou() {
    for (var e = window, t = on(); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = typeof t.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) e = t.contentWindow;
      else break;
      t = on(e.document);
    }
    return t;
  }
  function xo(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  function Hc(e) {
    var t = Ou(), n = e.focusedElem, r = e.selectionRange;
    if (t !== n && n && n.ownerDocument && Iu(n.ownerDocument.documentElement, n)) {
      if (r !== null && xo(n)) {
        if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
        else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
          e = e.getSelection();
          var l = n.textContent.length, o = Math.min(r.start, l);
          r = r.end === void 0 ? o : Math.min(r.end, l), !e.extend && o > r && (l = r, r = o, o = l), l = Mu(n, o);
          var i = Mu(
            n,
            r
          );
          l && i && (e.rangeCount !== 1 || e.anchorNode !== l.node || e.anchorOffset !== l.offset || e.focusNode !== i.node || e.focusOffset !== i.offset) && (t = t.createRange(), t.setStart(l.node, l.offset), e.removeAllRanges(), o > r ? (e.addRange(t), e.extend(i.node, i.offset)) : (t.setEnd(i.node, i.offset), e.addRange(t)));
        }
      }
      for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
      for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
    }
  }
  var Qc = ee && "documentMode" in document && 11 >= document.documentMode, Rn = null, Eo = null, gr = null, Co = !1;
  function Du(e, t, n) {
    var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    Co || Rn == null || Rn !== on(r) || (r = Rn, "selectionStart" in r && xo(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), gr && yr(gr, r) || (gr = r, r = il(Eo, "onSelect"), 0 < r.length && (t = new mo("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = Rn)));
  }
  function rl(e, t) {
    var n = {};
    return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
  }
  var Ln = { animationend: rl("Animation", "AnimationEnd"), animationiteration: rl("Animation", "AnimationIteration"), animationstart: rl("Animation", "AnimationStart"), transitionend: rl("Transition", "TransitionEnd") }, No = {}, Fu = {};
  ee && (Fu = document.createElement("div").style, "AnimationEvent" in window || (delete Ln.animationend.animation, delete Ln.animationiteration.animation, delete Ln.animationstart.animation), "TransitionEvent" in window || delete Ln.transitionend.transition);
  function ll(e) {
    if (No[e]) return No[e];
    if (!Ln[e]) return e;
    var t = Ln[e], n;
    for (n in t) if (t.hasOwnProperty(n) && n in Fu) return No[e] = t[n];
    return e;
  }
  var Uu = ll("animationend"), Au = ll("animationiteration"), Bu = ll("animationstart"), Vu = ll("transitionend"), $u = /* @__PURE__ */ new Map(), Hu = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Wt(e, t) {
    $u.set(e, t), pe(t, [e]);
  }
  for (var _o = 0; _o < Hu.length; _o++) {
    var jo = Hu[_o], Wc = jo.toLowerCase(), Kc = jo[0].toUpperCase() + jo.slice(1);
    Wt(Wc, "on" + Kc);
  }
  Wt(Uu, "onAnimationEnd"), Wt(Au, "onAnimationIteration"), Wt(Bu, "onAnimationStart"), Wt("dblclick", "onDoubleClick"), Wt("focusin", "onFocus"), Wt("focusout", "onBlur"), Wt(Vu, "onTransitionEnd"), X("onMouseEnter", ["mouseout", "mouseover"]), X("onMouseLeave", ["mouseout", "mouseover"]), X("onPointerEnter", ["pointerout", "pointerover"]), X("onPointerLeave", ["pointerout", "pointerover"]), pe("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), pe("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), pe("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), pe("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), pe("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), pe("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var kr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Yc = new Set("cancel close invalid load scroll toggle".split(" ").concat(kr));
  function Qu(e, t, n) {
    var r = e.type || "unknown-event";
    e.currentTarget = n, Wa(r, t, void 0, e), e.currentTarget = null;
  }
  function Wu(e, t) {
    t = (t & 4) !== 0;
    for (var n = 0; n < e.length; n++) {
      var r = e[n], l = r.event;
      r = r.listeners;
      e: {
        var o = void 0;
        if (t) for (var i = r.length - 1; 0 <= i; i--) {
          var u = r[i], s = u.instance, m = u.currentTarget;
          if (u = u.listener, s !== o && l.isPropagationStopped()) break e;
          Qu(l, u, m), o = s;
        }
        else for (i = 0; i < r.length; i++) {
          if (u = r[i], s = u.instance, m = u.currentTarget, u = u.listener, s !== o && l.isPropagationStopped()) break e;
          Qu(l, u, m), o = s;
        }
      }
    }
    if ($r) throw e = ro, $r = !1, ro = null, e;
  }
  function se(e, t) {
    var n = t[Oo];
    n === void 0 && (n = t[Oo] = /* @__PURE__ */ new Set());
    var r = e + "__bubble";
    n.has(r) || (Ku(t, e, 2, !1), n.add(r));
  }
  function Po(e, t, n) {
    var r = 0;
    t && (r |= 4), Ku(n, e, r, t);
  }
  var ol = "_reactListening" + Math.random().toString(36).slice(2);
  function wr(e) {
    if (!e[ol]) {
      e[ol] = !0, Y.forEach(function(n) {
        n !== "selectionchange" && (Yc.has(n) || Po(n, !1, e), Po(n, !0, e));
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[ol] || (t[ol] = !0, Po("selectionchange", !1, t));
    }
  }
  function Ku(e, t, n, r) {
    switch (hu(t)) {
      case 1:
        var l = uc;
        break;
      case 4:
        l = sc;
        break;
      default:
        l = co;
    }
    n = l.bind(null, t, n, e), l = void 0, !no || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (l = !0), r ? l !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: l }) : e.addEventListener(t, n, !0) : l !== void 0 ? e.addEventListener(t, n, { passive: l }) : e.addEventListener(t, n, !1);
  }
  function zo(e, t, n, r, l) {
    var o = r;
    if ((t & 1) === 0 && (t & 2) === 0 && r !== null) e: for (; ; ) {
      if (r === null) return;
      var i = r.tag;
      if (i === 3 || i === 4) {
        var u = r.stateNode.containerInfo;
        if (u === l || u.nodeType === 8 && u.parentNode === l) break;
        if (i === 4) for (i = r.return; i !== null; ) {
          var s = i.tag;
          if ((s === 3 || s === 4) && (s = i.stateNode.containerInfo, s === l || s.nodeType === 8 && s.parentNode === l)) return;
          i = i.return;
        }
        for (; u !== null; ) {
          if (i = cn(u), i === null) return;
          if (s = i.tag, s === 5 || s === 6) {
            r = o = i;
            continue e;
          }
          u = u.parentNode;
        }
      }
      r = r.return;
    }
    Ji(function() {
      var m = o, k = bl(n), w = [];
      e: {
        var y = $u.get(e);
        if (y !== void 0) {
          var _ = mo, P = e;
          switch (e) {
            case "keypress":
              if (br(n) === 0) break e;
            case "keydown":
            case "keyup":
              _ = Ec;
              break;
            case "focusin":
              P = "focus", _ = yo;
              break;
            case "focusout":
              P = "blur", _ = yo;
              break;
            case "beforeblur":
            case "afterblur":
              _ = yo;
              break;
            case "click":
              if (n.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              _ = gu;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              _ = fc;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              _ = _c;
              break;
            case Uu:
            case Au:
            case Bu:
              _ = mc;
              break;
            case Vu:
              _ = Pc;
              break;
            case "scroll":
              _ = ac;
              break;
            case "wheel":
              _ = Rc;
              break;
            case "copy":
            case "cut":
            case "paste":
              _ = vc;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              _ = wu;
          }
          var z = (t & 4) !== 0, ve = !z && e === "scroll", d = z ? y !== null ? y + "Capture" : null : y;
          z = [];
          for (var a = m, p; a !== null; ) {
            p = a;
            var E = p.stateNode;
            if (p.tag === 5 && E !== null && (p = E, d !== null && (E = nr(a, d), E != null && z.push(Sr(a, E, p)))), ve) break;
            a = a.return;
          }
          0 < z.length && (y = new _(y, P, null, n, k), w.push({ event: y, listeners: z }));
        }
      }
      if ((t & 7) === 0) {
        e: {
          if (y = e === "mouseover" || e === "pointerover", _ = e === "mouseout" || e === "pointerout", y && n !== ql && (P = n.relatedTarget || n.fromElement) && (cn(P) || P[Pt])) break e;
          if ((_ || y) && (y = k.window === k ? k : (y = k.ownerDocument) ? y.defaultView || y.parentWindow : window, _ ? (P = n.relatedTarget || n.toElement, _ = m, P = P ? cn(P) : null, P !== null && (ve = an(P), P !== ve || P.tag !== 5 && P.tag !== 6) && (P = null)) : (_ = null, P = m), _ !== P)) {
            if (z = gu, E = "onMouseLeave", d = "onMouseEnter", a = "mouse", (e === "pointerout" || e === "pointerover") && (z = wu, E = "onPointerLeave", d = "onPointerEnter", a = "pointer"), ve = _ == null ? y : In(_), p = P == null ? y : In(P), y = new z(E, a + "leave", _, n, k), y.target = ve, y.relatedTarget = p, E = null, cn(k) === m && (z = new z(d, a + "enter", P, n, k), z.target = p, z.relatedTarget = ve, E = z), ve = E, _ && P) t: {
              for (z = _, d = P, a = 0, p = z; p; p = Tn(p)) a++;
              for (p = 0, E = d; E; E = Tn(E)) p++;
              for (; 0 < a - p; ) z = Tn(z), a--;
              for (; 0 < p - a; ) d = Tn(d), p--;
              for (; a--; ) {
                if (z === d || d !== null && z === d.alternate) break t;
                z = Tn(z), d = Tn(d);
              }
              z = null;
            }
            else z = null;
            _ !== null && Yu(w, y, _, z, !1), P !== null && ve !== null && Yu(w, ve, P, z, !0);
          }
        }
        e: {
          if (y = m ? In(m) : window, _ = y.nodeName && y.nodeName.toLowerCase(), _ === "select" || _ === "input" && y.type === "file") var R = Fc;
          else if (_u(y)) if (Pu) R = Vc;
          else {
            R = Ac;
            var I = Uc;
          }
          else (_ = y.nodeName) && _.toLowerCase() === "input" && (y.type === "checkbox" || y.type === "radio") && (R = Bc);
          if (R && (R = R(e, m))) {
            ju(w, R, n, k);
            break e;
          }
          I && I(e, y, m), e === "focusout" && (I = y._wrapperState) && I.controlled && y.type === "number" && dt(y, "number", y.value);
        }
        switch (I = m ? In(m) : window, e) {
          case "focusin":
            (_u(I) || I.contentEditable === "true") && (Rn = I, Eo = m, gr = null);
            break;
          case "focusout":
            gr = Eo = Rn = null;
            break;
          case "mousedown":
            Co = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Co = !1, Du(w, n, k);
            break;
          case "selectionchange":
            if (Qc) break;
          case "keydown":
          case "keyup":
            Du(w, n, k);
        }
        var O;
        if (ko) e: {
          switch (e) {
            case "compositionstart":
              var D = "onCompositionStart";
              break e;
            case "compositionend":
              D = "onCompositionEnd";
              break e;
            case "compositionupdate":
              D = "onCompositionUpdate";
              break e;
          }
          D = void 0;
        }
        else zn ? Cu(e, n) && (D = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (D = "onCompositionStart");
        D && (Su && n.locale !== "ko" && (zn || D !== "onCompositionStart" ? D === "onCompositionEnd" && zn && (O = vu()) : (Qt = k, po = "value" in Qt ? Qt.value : Qt.textContent, zn = !0)), I = il(m, D), 0 < I.length && (D = new ku(D, e, null, n, k), w.push({ event: D, listeners: I }), O ? D.data = O : (O = Nu(n), O !== null && (D.data = O)))), (O = Tc ? Mc(e, n) : Ic(e, n)) && (m = il(m, "onBeforeInput"), 0 < m.length && (k = new ku("onBeforeInput", "beforeinput", null, n, k), w.push({ event: k, listeners: m }), k.data = O));
      }
      Wu(w, t);
    });
  }
  function Sr(e, t, n) {
    return { instance: e, listener: t, currentTarget: n };
  }
  function il(e, t) {
    for (var n = t + "Capture", r = []; e !== null; ) {
      var l = e, o = l.stateNode;
      l.tag === 5 && o !== null && (l = o, o = nr(e, n), o != null && r.unshift(Sr(e, o, l)), o = nr(e, t), o != null && r.push(Sr(e, o, l))), e = e.return;
    }
    return r;
  }
  function Tn(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5);
    return e || null;
  }
  function Yu(e, t, n, r, l) {
    for (var o = t._reactName, i = []; n !== null && n !== r; ) {
      var u = n, s = u.alternate, m = u.stateNode;
      if (s !== null && s === r) break;
      u.tag === 5 && m !== null && (u = m, l ? (s = nr(n, o), s != null && i.unshift(Sr(n, s, u))) : l || (s = nr(n, o), s != null && i.push(Sr(n, s, u)))), n = n.return;
    }
    i.length !== 0 && e.push({ event: t, listeners: i });
  }
  var Xc = /\r\n?/g, Gc = /\u0000|\uFFFD/g;
  function Xu(e) {
    return (typeof e == "string" ? e : "" + e).replace(Xc, `
`).replace(Gc, "");
  }
  function ul(e, t, n) {
    if (t = Xu(t), Xu(e) !== t && n) throw Error(f(425));
  }
  function sl() {
  }
  var Ro = null, Lo = null;
  function To(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Mo = typeof setTimeout == "function" ? setTimeout : void 0, Zc = typeof clearTimeout == "function" ? clearTimeout : void 0, Gu = typeof Promise == "function" ? Promise : void 0, Jc = typeof queueMicrotask == "function" ? queueMicrotask : typeof Gu < "u" ? function(e) {
    return Gu.resolve(null).then(e).catch(qc);
  } : Mo;
  function qc(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function Io(e, t) {
    var n = t, r = 0;
    do {
      var l = n.nextSibling;
      if (e.removeChild(n), l && l.nodeType === 8) if (n = l.data, n === "/$") {
        if (r === 0) {
          e.removeChild(l), fr(t);
          return;
        }
        r--;
      } else n !== "$" && n !== "$?" && n !== "$!" || r++;
      n = l;
    } while (n);
    fr(t);
  }
  function Kt(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
        if (t === "/$") return null;
      }
    }
    return e;
  }
  function Zu(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === "$" || n === "$!" || n === "$?") {
          if (t === 0) return e;
          t--;
        } else n === "/$" && t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  var Mn = Math.random().toString(36).slice(2), Et = "__reactFiber$" + Mn, xr = "__reactProps$" + Mn, Pt = "__reactContainer$" + Mn, Oo = "__reactEvents$" + Mn, bc = "__reactListeners$" + Mn, ef = "__reactHandles$" + Mn;
  function cn(e) {
    var t = e[Et];
    if (t) return t;
    for (var n = e.parentNode; n; ) {
      if (t = n[Pt] || n[Et]) {
        if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = Zu(e); e !== null; ) {
          if (n = e[Et]) return n;
          e = Zu(e);
        }
        return t;
      }
      e = n, n = e.parentNode;
    }
    return null;
  }
  function Er(e) {
    return e = e[Et] || e[Pt], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
  }
  function In(e) {
    if (e.tag === 5 || e.tag === 6) return e.stateNode;
    throw Error(f(33));
  }
  function al(e) {
    return e[xr] || null;
  }
  var Do = [], On = -1;
  function Yt(e) {
    return { current: e };
  }
  function ae(e) {
    0 > On || (e.current = Do[On], Do[On] = null, On--);
  }
  function ue(e, t) {
    On++, Do[On] = e.current, e.current = t;
  }
  var Xt = {}, De = Yt(Xt), Ye = Yt(!1), fn = Xt;
  function Dn(e, t) {
    var n = e.type.contextTypes;
    if (!n) return Xt;
    var r = e.stateNode;
    if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
    var l = {}, o;
    for (o in n) l[o] = t[o];
    return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = l), l;
  }
  function Xe(e) {
    return e = e.childContextTypes, e != null;
  }
  function cl() {
    ae(Ye), ae(De);
  }
  function Ju(e, t, n) {
    if (De.current !== Xt) throw Error(f(168));
    ue(De, t), ue(Ye, n);
  }
  function qu(e, t, n) {
    var r = e.stateNode;
    if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
    r = r.getChildContext();
    for (var l in r) if (!(l in t)) throw Error(f(108, K(e) || "Unknown", l));
    return g({}, n, r);
  }
  function fl(e) {
    return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Xt, fn = De.current, ue(De, e), ue(Ye, Ye.current), !0;
  }
  function bu(e, t, n) {
    var r = e.stateNode;
    if (!r) throw Error(f(169));
    n ? (e = qu(e, t, fn), r.__reactInternalMemoizedMergedChildContext = e, ae(Ye), ae(De), ue(De, e)) : ae(Ye), ue(Ye, n);
  }
  var zt = null, dl = !1, Fo = !1;
  function es(e) {
    zt === null ? zt = [e] : zt.push(e);
  }
  function tf(e) {
    dl = !0, es(e);
  }
  function Gt() {
    if (!Fo && zt !== null) {
      Fo = !0;
      var e = 0, t = re;
      try {
        var n = zt;
        for (re = 1; e < n.length; e++) {
          var r = n[e];
          do
            r = r(!0);
          while (r !== null);
        }
        zt = null, dl = !1;
      } catch (l) {
        throw zt !== null && (zt = zt.slice(e + 1)), nu(lo, Gt), l;
      } finally {
        re = t, Fo = !1;
      }
    }
    return null;
  }
  var Fn = [], Un = 0, pl = null, ml = 0, ot = [], it = 0, dn = null, Rt = 1, Lt = "";
  function pn(e, t) {
    Fn[Un++] = ml, Fn[Un++] = pl, pl = e, ml = t;
  }
  function ts(e, t, n) {
    ot[it++] = Rt, ot[it++] = Lt, ot[it++] = dn, dn = e;
    var r = Rt;
    e = Lt;
    var l = 32 - pt(r) - 1;
    r &= ~(1 << l), n += 1;
    var o = 32 - pt(t) + l;
    if (30 < o) {
      var i = l - l % 5;
      o = (r & (1 << i) - 1).toString(32), r >>= i, l -= i, Rt = 1 << 32 - pt(t) + l | n << l | r, Lt = o + e;
    } else Rt = 1 << o | n << l | r, Lt = e;
  }
  function Uo(e) {
    e.return !== null && (pn(e, 1), ts(e, 1, 0));
  }
  function Ao(e) {
    for (; e === pl; ) pl = Fn[--Un], Fn[Un] = null, ml = Fn[--Un], Fn[Un] = null;
    for (; e === dn; ) dn = ot[--it], ot[it] = null, Lt = ot[--it], ot[it] = null, Rt = ot[--it], ot[it] = null;
  }
  var et = null, tt = null, ce = !1, ht = null;
  function ns(e, t) {
    var n = ct(5, null, null, 0);
    n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
  }
  function rs(e, t) {
    switch (e.tag) {
      case 5:
        var n = e.type;
        return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, et = e, tt = Kt(t.firstChild), !0) : !1;
      case 6:
        return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, et = e, tt = null, !0) : !1;
      case 13:
        return t = t.nodeType !== 8 ? null : t, t !== null ? (n = dn !== null ? { id: Rt, overflow: Lt } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = ct(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, et = e, tt = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Bo(e) {
    return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
  }
  function Vo(e) {
    if (ce) {
      var t = tt;
      if (t) {
        var n = t;
        if (!rs(e, t)) {
          if (Bo(e)) throw Error(f(418));
          t = Kt(n.nextSibling);
          var r = et;
          t && rs(e, t) ? ns(r, n) : (e.flags = e.flags & -4097 | 2, ce = !1, et = e);
        }
      } else {
        if (Bo(e)) throw Error(f(418));
        e.flags = e.flags & -4097 | 2, ce = !1, et = e;
      }
    }
  }
  function ls(e) {
    for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
    et = e;
  }
  function hl(e) {
    if (e !== et) return !1;
    if (!ce) return ls(e), ce = !0, !1;
    var t;
    if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !To(e.type, e.memoizedProps)), t && (t = tt)) {
      if (Bo(e)) throw os(), Error(f(418));
      for (; t; ) ns(e, t), t = Kt(t.nextSibling);
    }
    if (ls(e), e.tag === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(f(317));
      e: {
        for (e = e.nextSibling, t = 0; e; ) {
          if (e.nodeType === 8) {
            var n = e.data;
            if (n === "/$") {
              if (t === 0) {
                tt = Kt(e.nextSibling);
                break e;
              }
              t--;
            } else n !== "$" && n !== "$!" && n !== "$?" || t++;
          }
          e = e.nextSibling;
        }
        tt = null;
      }
    } else tt = et ? Kt(e.stateNode.nextSibling) : null;
    return !0;
  }
  function os() {
    for (var e = tt; e; ) e = Kt(e.nextSibling);
  }
  function An() {
    tt = et = null, ce = !1;
  }
  function $o(e) {
    ht === null ? ht = [e] : ht.push(e);
  }
  var nf = ye.ReactCurrentBatchConfig;
  function Cr(e, t, n) {
    if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
      if (n._owner) {
        if (n = n._owner, n) {
          if (n.tag !== 1) throw Error(f(309));
          var r = n.stateNode;
        }
        if (!r) throw Error(f(147, e));
        var l = r, o = "" + e;
        return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === o ? t.ref : (t = function(i) {
          var u = l.refs;
          i === null ? delete u[o] : u[o] = i;
        }, t._stringRef = o, t);
      }
      if (typeof e != "string") throw Error(f(284));
      if (!n._owner) throw Error(f(290, e));
    }
    return e;
  }
  function vl(e, t) {
    throw e = Object.prototype.toString.call(t), Error(f(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
  }
  function is(e) {
    var t = e._init;
    return t(e._payload);
  }
  function us(e) {
    function t(d, a) {
      if (e) {
        var p = d.deletions;
        p === null ? (d.deletions = [a], d.flags |= 16) : p.push(a);
      }
    }
    function n(d, a) {
      if (!e) return null;
      for (; a !== null; ) t(d, a), a = a.sibling;
      return null;
    }
    function r(d, a) {
      for (d = /* @__PURE__ */ new Map(); a !== null; ) a.key !== null ? d.set(a.key, a) : d.set(a.index, a), a = a.sibling;
      return d;
    }
    function l(d, a) {
      return d = rn(d, a), d.index = 0, d.sibling = null, d;
    }
    function o(d, a, p) {
      return d.index = p, e ? (p = d.alternate, p !== null ? (p = p.index, p < a ? (d.flags |= 2, a) : p) : (d.flags |= 2, a)) : (d.flags |= 1048576, a);
    }
    function i(d) {
      return e && d.alternate === null && (d.flags |= 2), d;
    }
    function u(d, a, p, E) {
      return a === null || a.tag !== 6 ? (a = Mi(p, d.mode, E), a.return = d, a) : (a = l(a, p), a.return = d, a);
    }
    function s(d, a, p, E) {
      var R = p.type;
      return R === ze ? k(d, a, p.props.children, E, p.key) : a !== null && (a.elementType === R || typeof R == "object" && R !== null && R.$$typeof === Le && is(R) === a.type) ? (E = l(a, p.props), E.ref = Cr(d, a, p), E.return = d, E) : (E = Bl(p.type, p.key, p.props, null, d.mode, E), E.ref = Cr(d, a, p), E.return = d, E);
    }
    function m(d, a, p, E) {
      return a === null || a.tag !== 4 || a.stateNode.containerInfo !== p.containerInfo || a.stateNode.implementation !== p.implementation ? (a = Ii(p, d.mode, E), a.return = d, a) : (a = l(a, p.children || []), a.return = d, a);
    }
    function k(d, a, p, E, R) {
      return a === null || a.tag !== 7 ? (a = Sn(p, d.mode, E, R), a.return = d, a) : (a = l(a, p), a.return = d, a);
    }
    function w(d, a, p) {
      if (typeof a == "string" && a !== "" || typeof a == "number") return a = Mi("" + a, d.mode, p), a.return = d, a;
      if (typeof a == "object" && a !== null) {
        switch (a.$$typeof) {
          case Be:
            return p = Bl(a.type, a.key, a.props, null, d.mode, p), p.ref = Cr(d, null, a), p.return = d, p;
          case Pe:
            return a = Ii(a, d.mode, p), a.return = d, a;
          case Le:
            var E = a._init;
            return w(d, E(a._payload), p);
        }
        if (un(a) || L(a)) return a = Sn(a, d.mode, p, null), a.return = d, a;
        vl(d, a);
      }
      return null;
    }
    function y(d, a, p, E) {
      var R = a !== null ? a.key : null;
      if (typeof p == "string" && p !== "" || typeof p == "number") return R !== null ? null : u(d, a, "" + p, E);
      if (typeof p == "object" && p !== null) {
        switch (p.$$typeof) {
          case Be:
            return p.key === R ? s(d, a, p, E) : null;
          case Pe:
            return p.key === R ? m(d, a, p, E) : null;
          case Le:
            return R = p._init, y(
              d,
              a,
              R(p._payload),
              E
            );
        }
        if (un(p) || L(p)) return R !== null ? null : k(d, a, p, E, null);
        vl(d, p);
      }
      return null;
    }
    function _(d, a, p, E, R) {
      if (typeof E == "string" && E !== "" || typeof E == "number") return d = d.get(p) || null, u(a, d, "" + E, R);
      if (typeof E == "object" && E !== null) {
        switch (E.$$typeof) {
          case Be:
            return d = d.get(E.key === null ? p : E.key) || null, s(a, d, E, R);
          case Pe:
            return d = d.get(E.key === null ? p : E.key) || null, m(a, d, E, R);
          case Le:
            var I = E._init;
            return _(d, a, p, I(E._payload), R);
        }
        if (un(E) || L(E)) return d = d.get(p) || null, k(a, d, E, R, null);
        vl(a, E);
      }
      return null;
    }
    function P(d, a, p, E) {
      for (var R = null, I = null, O = a, D = a = 0, je = null; O !== null && D < p.length; D++) {
        O.index > D ? (je = O, O = null) : je = O.sibling;
        var J = y(d, O, p[D], E);
        if (J === null) {
          O === null && (O = je);
          break;
        }
        e && O && J.alternate === null && t(d, O), a = o(J, a, D), I === null ? R = J : I.sibling = J, I = J, O = je;
      }
      if (D === p.length) return n(d, O), ce && pn(d, D), R;
      if (O === null) {
        for (; D < p.length; D++) O = w(d, p[D], E), O !== null && (a = o(O, a, D), I === null ? R = O : I.sibling = O, I = O);
        return ce && pn(d, D), R;
      }
      for (O = r(d, O); D < p.length; D++) je = _(O, d, D, p[D], E), je !== null && (e && je.alternate !== null && O.delete(je.key === null ? D : je.key), a = o(je, a, D), I === null ? R = je : I.sibling = je, I = je);
      return e && O.forEach(function(ln) {
        return t(d, ln);
      }), ce && pn(d, D), R;
    }
    function z(d, a, p, E) {
      var R = L(p);
      if (typeof R != "function") throw Error(f(150));
      if (p = R.call(p), p == null) throw Error(f(151));
      for (var I = R = null, O = a, D = a = 0, je = null, J = p.next(); O !== null && !J.done; D++, J = p.next()) {
        O.index > D ? (je = O, O = null) : je = O.sibling;
        var ln = y(d, O, J.value, E);
        if (ln === null) {
          O === null && (O = je);
          break;
        }
        e && O && ln.alternate === null && t(d, O), a = o(ln, a, D), I === null ? R = ln : I.sibling = ln, I = ln, O = je;
      }
      if (J.done) return n(
        d,
        O
      ), ce && pn(d, D), R;
      if (O === null) {
        for (; !J.done; D++, J = p.next()) J = w(d, J.value, E), J !== null && (a = o(J, a, D), I === null ? R = J : I.sibling = J, I = J);
        return ce && pn(d, D), R;
      }
      for (O = r(d, O); !J.done; D++, J = p.next()) J = _(O, d, D, J.value, E), J !== null && (e && J.alternate !== null && O.delete(J.key === null ? D : J.key), a = o(J, a, D), I === null ? R = J : I.sibling = J, I = J);
      return e && O.forEach(function(Df) {
        return t(d, Df);
      }), ce && pn(d, D), R;
    }
    function ve(d, a, p, E) {
      if (typeof p == "object" && p !== null && p.type === ze && p.key === null && (p = p.props.children), typeof p == "object" && p !== null) {
        switch (p.$$typeof) {
          case Be:
            e: {
              for (var R = p.key, I = a; I !== null; ) {
                if (I.key === R) {
                  if (R = p.type, R === ze) {
                    if (I.tag === 7) {
                      n(d, I.sibling), a = l(I, p.props.children), a.return = d, d = a;
                      break e;
                    }
                  } else if (I.elementType === R || typeof R == "object" && R !== null && R.$$typeof === Le && is(R) === I.type) {
                    n(d, I.sibling), a = l(I, p.props), a.ref = Cr(d, I, p), a.return = d, d = a;
                    break e;
                  }
                  n(d, I);
                  break;
                } else t(d, I);
                I = I.sibling;
              }
              p.type === ze ? (a = Sn(p.props.children, d.mode, E, p.key), a.return = d, d = a) : (E = Bl(p.type, p.key, p.props, null, d.mode, E), E.ref = Cr(d, a, p), E.return = d, d = E);
            }
            return i(d);
          case Pe:
            e: {
              for (I = p.key; a !== null; ) {
                if (a.key === I) if (a.tag === 4 && a.stateNode.containerInfo === p.containerInfo && a.stateNode.implementation === p.implementation) {
                  n(d, a.sibling), a = l(a, p.children || []), a.return = d, d = a;
                  break e;
                } else {
                  n(d, a);
                  break;
                }
                else t(d, a);
                a = a.sibling;
              }
              a = Ii(p, d.mode, E), a.return = d, d = a;
            }
            return i(d);
          case Le:
            return I = p._init, ve(d, a, I(p._payload), E);
        }
        if (un(p)) return P(d, a, p, E);
        if (L(p)) return z(d, a, p, E);
        vl(d, p);
      }
      return typeof p == "string" && p !== "" || typeof p == "number" ? (p = "" + p, a !== null && a.tag === 6 ? (n(d, a.sibling), a = l(a, p), a.return = d, d = a) : (n(d, a), a = Mi(p, d.mode, E), a.return = d, d = a), i(d)) : n(d, a);
    }
    return ve;
  }
  var Bn = us(!0), ss = us(!1), yl = Yt(null), gl = null, Vn = null, Ho = null;
  function Qo() {
    Ho = Vn = gl = null;
  }
  function Wo(e) {
    var t = yl.current;
    ae(yl), e._currentValue = t;
  }
  function Ko(e, t, n) {
    for (; e !== null; ) {
      var r = e.alternate;
      if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
      e = e.return;
    }
  }
  function $n(e, t) {
    gl = e, Ho = Vn = null, e = e.dependencies, e !== null && e.firstContext !== null && ((e.lanes & t) !== 0 && (Ge = !0), e.firstContext = null);
  }
  function ut(e) {
    var t = e._currentValue;
    if (Ho !== e) if (e = { context: e, memoizedValue: t, next: null }, Vn === null) {
      if (gl === null) throw Error(f(308));
      Vn = e, gl.dependencies = { lanes: 0, firstContext: e };
    } else Vn = Vn.next = e;
    return t;
  }
  var mn = null;
  function Yo(e) {
    mn === null ? mn = [e] : mn.push(e);
  }
  function as(e, t, n, r) {
    var l = t.interleaved;
    return l === null ? (n.next = n, Yo(t)) : (n.next = l.next, l.next = n), t.interleaved = n, Tt(e, r);
  }
  function Tt(e, t) {
    e.lanes |= t;
    var n = e.alternate;
    for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
    return n.tag === 3 ? n.stateNode : null;
  }
  var Zt = !1;
  function Xo(e) {
    e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function cs(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
  }
  function Mt(e, t) {
    return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function Jt(e, t, n) {
    var r = e.updateQueue;
    if (r === null) return null;
    if (r = r.shared, (Z & 2) !== 0) {
      var l = r.pending;
      return l === null ? t.next = t : (t.next = l.next, l.next = t), r.pending = t, Tt(e, n);
    }
    return l = r.interleaved, l === null ? (t.next = t, Yo(r)) : (t.next = l.next, l.next = t), r.interleaved = t, Tt(e, n);
  }
  function kl(e, t, n) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
      var r = t.lanes;
      r &= e.pendingLanes, n |= r, t.lanes = n, uo(e, n);
    }
  }
  function fs(e, t) {
    var n = e.updateQueue, r = e.alternate;
    if (r !== null && (r = r.updateQueue, n === r)) {
      var l = null, o = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var i = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
          o === null ? l = o = i : o = o.next = i, n = n.next;
        } while (n !== null);
        o === null ? l = o = t : o = o.next = t;
      } else l = o = t;
      n = { baseState: r.baseState, firstBaseUpdate: l, lastBaseUpdate: o, shared: r.shared, effects: r.effects }, e.updateQueue = n;
      return;
    }
    e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
  }
  function wl(e, t, n, r) {
    var l = e.updateQueue;
    Zt = !1;
    var o = l.firstBaseUpdate, i = l.lastBaseUpdate, u = l.shared.pending;
    if (u !== null) {
      l.shared.pending = null;
      var s = u, m = s.next;
      s.next = null, i === null ? o = m : i.next = m, i = s;
      var k = e.alternate;
      k !== null && (k = k.updateQueue, u = k.lastBaseUpdate, u !== i && (u === null ? k.firstBaseUpdate = m : u.next = m, k.lastBaseUpdate = s));
    }
    if (o !== null) {
      var w = l.baseState;
      i = 0, k = m = s = null, u = o;
      do {
        var y = u.lane, _ = u.eventTime;
        if ((r & y) === y) {
          k !== null && (k = k.next = {
            eventTime: _,
            lane: 0,
            tag: u.tag,
            payload: u.payload,
            callback: u.callback,
            next: null
          });
          e: {
            var P = e, z = u;
            switch (y = t, _ = n, z.tag) {
              case 1:
                if (P = z.payload, typeof P == "function") {
                  w = P.call(_, w, y);
                  break e;
                }
                w = P;
                break e;
              case 3:
                P.flags = P.flags & -65537 | 128;
              case 0:
                if (P = z.payload, y = typeof P == "function" ? P.call(_, w, y) : P, y == null) break e;
                w = g({}, w, y);
                break e;
              case 2:
                Zt = !0;
            }
          }
          u.callback !== null && u.lane !== 0 && (e.flags |= 64, y = l.effects, y === null ? l.effects = [u] : y.push(u));
        } else _ = { eventTime: _, lane: y, tag: u.tag, payload: u.payload, callback: u.callback, next: null }, k === null ? (m = k = _, s = w) : k = k.next = _, i |= y;
        if (u = u.next, u === null) {
          if (u = l.shared.pending, u === null) break;
          y = u, u = y.next, y.next = null, l.lastBaseUpdate = y, l.shared.pending = null;
        }
      } while (!0);
      if (k === null && (s = w), l.baseState = s, l.firstBaseUpdate = m, l.lastBaseUpdate = k, t = l.shared.interleaved, t !== null) {
        l = t;
        do
          i |= l.lane, l = l.next;
        while (l !== t);
      } else o === null && (l.shared.lanes = 0);
      yn |= i, e.lanes = i, e.memoizedState = w;
    }
  }
  function ds(e, t, n) {
    if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
      var r = e[t], l = r.callback;
      if (l !== null) {
        if (r.callback = null, r = n, typeof l != "function") throw Error(f(191, l));
        l.call(r);
      }
    }
  }
  var Nr = {}, Ct = Yt(Nr), _r = Yt(Nr), jr = Yt(Nr);
  function hn(e) {
    if (e === Nr) throw Error(f(174));
    return e;
  }
  function Go(e, t) {
    switch (ue(jr, t), ue(_r, e), ue(Ct, Nr), e = t.nodeType, e) {
      case 9:
      case 11:
        t = (t = t.documentElement) ? t.namespaceURI : Cn(null, "");
        break;
      default:
        e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = Cn(t, e);
    }
    ae(Ct), ue(Ct, t);
  }
  function Hn() {
    ae(Ct), ae(_r), ae(jr);
  }
  function ps(e) {
    hn(jr.current);
    var t = hn(Ct.current), n = Cn(t, e.type);
    t !== n && (ue(_r, e), ue(Ct, n));
  }
  function Zo(e) {
    _r.current === e && (ae(Ct), ae(_r));
  }
  var fe = Yt(0);
  function Sl(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var n = t.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
      } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var Jo = [];
  function qo() {
    for (var e = 0; e < Jo.length; e++) Jo[e]._workInProgressVersionPrimary = null;
    Jo.length = 0;
  }
  var xl = ye.ReactCurrentDispatcher, bo = ye.ReactCurrentBatchConfig, vn = 0, de = null, Se = null, Ne = null, El = !1, Pr = !1, zr = 0, rf = 0;
  function Fe() {
    throw Error(f(321));
  }
  function ei(e, t) {
    if (t === null) return !1;
    for (var n = 0; n < t.length && n < e.length; n++) if (!mt(e[n], t[n])) return !1;
    return !0;
  }
  function ti(e, t, n, r, l, o) {
    if (vn = o, de = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, xl.current = e === null || e.memoizedState === null ? sf : af, e = n(r, l), Pr) {
      o = 0;
      do {
        if (Pr = !1, zr = 0, 25 <= o) throw Error(f(301));
        o += 1, Ne = Se = null, t.updateQueue = null, xl.current = cf, e = n(r, l);
      } while (Pr);
    }
    if (xl.current = _l, t = Se !== null && Se.next !== null, vn = 0, Ne = Se = de = null, El = !1, t) throw Error(f(300));
    return e;
  }
  function ni() {
    var e = zr !== 0;
    return zr = 0, e;
  }
  function Nt() {
    var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Ne === null ? de.memoizedState = Ne = e : Ne = Ne.next = e, Ne;
  }
  function st() {
    if (Se === null) {
      var e = de.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = Se.next;
    var t = Ne === null ? de.memoizedState : Ne.next;
    if (t !== null) Ne = t, Se = e;
    else {
      if (e === null) throw Error(f(310));
      Se = e, e = { memoizedState: Se.memoizedState, baseState: Se.baseState, baseQueue: Se.baseQueue, queue: Se.queue, next: null }, Ne === null ? de.memoizedState = Ne = e : Ne = Ne.next = e;
    }
    return Ne;
  }
  function Rr(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function ri(e) {
    var t = st(), n = t.queue;
    if (n === null) throw Error(f(311));
    n.lastRenderedReducer = e;
    var r = Se, l = r.baseQueue, o = n.pending;
    if (o !== null) {
      if (l !== null) {
        var i = l.next;
        l.next = o.next, o.next = i;
      }
      r.baseQueue = l = o, n.pending = null;
    }
    if (l !== null) {
      o = l.next, r = r.baseState;
      var u = i = null, s = null, m = o;
      do {
        var k = m.lane;
        if ((vn & k) === k) s !== null && (s = s.next = { lane: 0, action: m.action, hasEagerState: m.hasEagerState, eagerState: m.eagerState, next: null }), r = m.hasEagerState ? m.eagerState : e(r, m.action);
        else {
          var w = {
            lane: k,
            action: m.action,
            hasEagerState: m.hasEagerState,
            eagerState: m.eagerState,
            next: null
          };
          s === null ? (u = s = w, i = r) : s = s.next = w, de.lanes |= k, yn |= k;
        }
        m = m.next;
      } while (m !== null && m !== o);
      s === null ? i = r : s.next = u, mt(r, t.memoizedState) || (Ge = !0), t.memoizedState = r, t.baseState = i, t.baseQueue = s, n.lastRenderedState = r;
    }
    if (e = n.interleaved, e !== null) {
      l = e;
      do
        o = l.lane, de.lanes |= o, yn |= o, l = l.next;
      while (l !== e);
    } else l === null && (n.lanes = 0);
    return [t.memoizedState, n.dispatch];
  }
  function li(e) {
    var t = st(), n = t.queue;
    if (n === null) throw Error(f(311));
    n.lastRenderedReducer = e;
    var r = n.dispatch, l = n.pending, o = t.memoizedState;
    if (l !== null) {
      n.pending = null;
      var i = l = l.next;
      do
        o = e(o, i.action), i = i.next;
      while (i !== l);
      mt(o, t.memoizedState) || (Ge = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
    }
    return [o, r];
  }
  function ms() {
  }
  function hs(e, t) {
    var n = de, r = st(), l = t(), o = !mt(r.memoizedState, l);
    if (o && (r.memoizedState = l, Ge = !0), r = r.queue, oi(gs.bind(null, n, r, e), [e]), r.getSnapshot !== t || o || Ne !== null && Ne.memoizedState.tag & 1) {
      if (n.flags |= 2048, Lr(9, ys.bind(null, n, r, l, t), void 0, null), _e === null) throw Error(f(349));
      (vn & 30) !== 0 || vs(n, t, l);
    }
    return l;
  }
  function vs(e, t, n) {
    e.flags |= 16384, e = { getSnapshot: t, value: n }, t = de.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, de.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
  }
  function ys(e, t, n, r) {
    t.value = n, t.getSnapshot = r, ks(t) && ws(e);
  }
  function gs(e, t, n) {
    return n(function() {
      ks(t) && ws(e);
    });
  }
  function ks(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var n = t();
      return !mt(e, n);
    } catch {
      return !0;
    }
  }
  function ws(e) {
    var t = Tt(e, 1);
    t !== null && kt(t, e, 1, -1);
  }
  function Ss(e) {
    var t = Nt();
    return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Rr, lastRenderedState: e }, t.queue = e, e = e.dispatch = uf.bind(null, de, e), [t.memoizedState, e];
  }
  function Lr(e, t, n, r) {
    return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = de.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, de.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
  }
  function xs() {
    return st().memoizedState;
  }
  function Cl(e, t, n, r) {
    var l = Nt();
    de.flags |= e, l.memoizedState = Lr(1 | t, n, void 0, r === void 0 ? null : r);
  }
  function Nl(e, t, n, r) {
    var l = st();
    r = r === void 0 ? null : r;
    var o = void 0;
    if (Se !== null) {
      var i = Se.memoizedState;
      if (o = i.destroy, r !== null && ei(r, i.deps)) {
        l.memoizedState = Lr(t, n, o, r);
        return;
      }
    }
    de.flags |= e, l.memoizedState = Lr(1 | t, n, o, r);
  }
  function Es(e, t) {
    return Cl(8390656, 8, e, t);
  }
  function oi(e, t) {
    return Nl(2048, 8, e, t);
  }
  function Cs(e, t) {
    return Nl(4, 2, e, t);
  }
  function Ns(e, t) {
    return Nl(4, 4, e, t);
  }
  function _s(e, t) {
    if (typeof t == "function") return e = e(), t(e), function() {
      t(null);
    };
    if (t != null) return e = e(), t.current = e, function() {
      t.current = null;
    };
  }
  function js(e, t, n) {
    return n = n != null ? n.concat([e]) : null, Nl(4, 4, _s.bind(null, t, e), n);
  }
  function ii() {
  }
  function Ps(e, t) {
    var n = st();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return r !== null && t !== null && ei(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
  }
  function zs(e, t) {
    var n = st();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return r !== null && t !== null && ei(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
  }
  function Rs(e, t, n) {
    return (vn & 21) === 0 ? (e.baseState && (e.baseState = !1, Ge = !0), e.memoizedState = n) : (mt(n, t) || (n = iu(), de.lanes |= n, yn |= n, e.baseState = !0), t);
  }
  function lf(e, t) {
    var n = re;
    re = n !== 0 && 4 > n ? n : 4, e(!0);
    var r = bo.transition;
    bo.transition = {};
    try {
      e(!1), t();
    } finally {
      re = n, bo.transition = r;
    }
  }
  function Ls() {
    return st().memoizedState;
  }
  function of(e, t, n) {
    var r = tn(e);
    if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, Ts(e)) Ms(t, n);
    else if (n = as(e, t, n, r), n !== null) {
      var l = Qe();
      kt(n, e, r, l), Is(n, t, r);
    }
  }
  function uf(e, t, n) {
    var r = tn(e), l = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
    if (Ts(e)) Ms(t, l);
    else {
      var o = e.alternate;
      if (e.lanes === 0 && (o === null || o.lanes === 0) && (o = t.lastRenderedReducer, o !== null)) try {
        var i = t.lastRenderedState, u = o(i, n);
        if (l.hasEagerState = !0, l.eagerState = u, mt(u, i)) {
          var s = t.interleaved;
          s === null ? (l.next = l, Yo(t)) : (l.next = s.next, s.next = l), t.interleaved = l;
          return;
        }
      } catch {
      } finally {
      }
      n = as(e, t, l, r), n !== null && (l = Qe(), kt(n, e, r, l), Is(n, t, r));
    }
  }
  function Ts(e) {
    var t = e.alternate;
    return e === de || t !== null && t === de;
  }
  function Ms(e, t) {
    Pr = El = !0;
    var n = e.pending;
    n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
  }
  function Is(e, t, n) {
    if ((n & 4194240) !== 0) {
      var r = t.lanes;
      r &= e.pendingLanes, n |= r, t.lanes = n, uo(e, n);
    }
  }
  var _l = { readContext: ut, useCallback: Fe, useContext: Fe, useEffect: Fe, useImperativeHandle: Fe, useInsertionEffect: Fe, useLayoutEffect: Fe, useMemo: Fe, useReducer: Fe, useRef: Fe, useState: Fe, useDebugValue: Fe, useDeferredValue: Fe, useTransition: Fe, useMutableSource: Fe, useSyncExternalStore: Fe, useId: Fe, unstable_isNewReconciler: !1 }, sf = { readContext: ut, useCallback: function(e, t) {
    return Nt().memoizedState = [e, t === void 0 ? null : t], e;
  }, useContext: ut, useEffect: Es, useImperativeHandle: function(e, t, n) {
    return n = n != null ? n.concat([e]) : null, Cl(
      4194308,
      4,
      _s.bind(null, t, e),
      n
    );
  }, useLayoutEffect: function(e, t) {
    return Cl(4194308, 4, e, t);
  }, useInsertionEffect: function(e, t) {
    return Cl(4, 2, e, t);
  }, useMemo: function(e, t) {
    var n = Nt();
    return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
  }, useReducer: function(e, t, n) {
    var r = Nt();
    return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = of.bind(null, de, e), [r.memoizedState, e];
  }, useRef: function(e) {
    var t = Nt();
    return e = { current: e }, t.memoizedState = e;
  }, useState: Ss, useDebugValue: ii, useDeferredValue: function(e) {
    return Nt().memoizedState = e;
  }, useTransition: function() {
    var e = Ss(!1), t = e[0];
    return e = lf.bind(null, e[1]), Nt().memoizedState = e, [t, e];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(e, t, n) {
    var r = de, l = Nt();
    if (ce) {
      if (n === void 0) throw Error(f(407));
      n = n();
    } else {
      if (n = t(), _e === null) throw Error(f(349));
      (vn & 30) !== 0 || vs(r, t, n);
    }
    l.memoizedState = n;
    var o = { value: n, getSnapshot: t };
    return l.queue = o, Es(gs.bind(
      null,
      r,
      o,
      e
    ), [e]), r.flags |= 2048, Lr(9, ys.bind(null, r, o, n, t), void 0, null), n;
  }, useId: function() {
    var e = Nt(), t = _e.identifierPrefix;
    if (ce) {
      var n = Lt, r = Rt;
      n = (r & ~(1 << 32 - pt(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = zr++, 0 < n && (t += "H" + n.toString(32)), t += ":";
    } else n = rf++, t = ":" + t + "r" + n.toString(32) + ":";
    return e.memoizedState = t;
  }, unstable_isNewReconciler: !1 }, af = {
    readContext: ut,
    useCallback: Ps,
    useContext: ut,
    useEffect: oi,
    useImperativeHandle: js,
    useInsertionEffect: Cs,
    useLayoutEffect: Ns,
    useMemo: zs,
    useReducer: ri,
    useRef: xs,
    useState: function() {
      return ri(Rr);
    },
    useDebugValue: ii,
    useDeferredValue: function(e) {
      var t = st();
      return Rs(t, Se.memoizedState, e);
    },
    useTransition: function() {
      var e = ri(Rr)[0], t = st().memoizedState;
      return [e, t];
    },
    useMutableSource: ms,
    useSyncExternalStore: hs,
    useId: Ls,
    unstable_isNewReconciler: !1
  }, cf = { readContext: ut, useCallback: Ps, useContext: ut, useEffect: oi, useImperativeHandle: js, useInsertionEffect: Cs, useLayoutEffect: Ns, useMemo: zs, useReducer: li, useRef: xs, useState: function() {
    return li(Rr);
  }, useDebugValue: ii, useDeferredValue: function(e) {
    var t = st();
    return Se === null ? t.memoizedState = e : Rs(t, Se.memoizedState, e);
  }, useTransition: function() {
    var e = li(Rr)[0], t = st().memoizedState;
    return [e, t];
  }, useMutableSource: ms, useSyncExternalStore: hs, useId: Ls, unstable_isNewReconciler: !1 };
  function vt(e, t) {
    if (e && e.defaultProps) {
      t = g({}, t), e = e.defaultProps;
      for (var n in e) t[n] === void 0 && (t[n] = e[n]);
      return t;
    }
    return t;
  }
  function ui(e, t, n, r) {
    t = e.memoizedState, n = n(r, t), n = n == null ? t : g({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
  }
  var jl = { isMounted: function(e) {
    return (e = e._reactInternals) ? an(e) === e : !1;
  }, enqueueSetState: function(e, t, n) {
    e = e._reactInternals;
    var r = Qe(), l = tn(e), o = Mt(r, l);
    o.payload = t, n != null && (o.callback = n), t = Jt(e, o, l), t !== null && (kt(t, e, l, r), kl(t, e, l));
  }, enqueueReplaceState: function(e, t, n) {
    e = e._reactInternals;
    var r = Qe(), l = tn(e), o = Mt(r, l);
    o.tag = 1, o.payload = t, n != null && (o.callback = n), t = Jt(e, o, l), t !== null && (kt(t, e, l, r), kl(t, e, l));
  }, enqueueForceUpdate: function(e, t) {
    e = e._reactInternals;
    var n = Qe(), r = tn(e), l = Mt(n, r);
    l.tag = 2, t != null && (l.callback = t), t = Jt(e, l, r), t !== null && (kt(t, e, r, n), kl(t, e, r));
  } };
  function Os(e, t, n, r, l, o, i) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, o, i) : t.prototype && t.prototype.isPureReactComponent ? !yr(n, r) || !yr(l, o) : !0;
  }
  function Ds(e, t, n) {
    var r = !1, l = Xt, o = t.contextType;
    return typeof o == "object" && o !== null ? o = ut(o) : (l = Xe(t) ? fn : De.current, r = t.contextTypes, o = (r = r != null) ? Dn(e, l) : Xt), t = new t(n, o), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = jl, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = l, e.__reactInternalMemoizedMaskedChildContext = o), t;
  }
  function Fs(e, t, n, r) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && jl.enqueueReplaceState(t, t.state, null);
  }
  function si(e, t, n, r) {
    var l = e.stateNode;
    l.props = n, l.state = e.memoizedState, l.refs = {}, Xo(e);
    var o = t.contextType;
    typeof o == "object" && o !== null ? l.context = ut(o) : (o = Xe(t) ? fn : De.current, l.context = Dn(e, o)), l.state = e.memoizedState, o = t.getDerivedStateFromProps, typeof o == "function" && (ui(e, t, o, n), l.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof l.getSnapshotBeforeUpdate == "function" || typeof l.UNSAFE_componentWillMount != "function" && typeof l.componentWillMount != "function" || (t = l.state, typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), t !== l.state && jl.enqueueReplaceState(l, l.state, null), wl(e, n, l, r), l.state = e.memoizedState), typeof l.componentDidMount == "function" && (e.flags |= 4194308);
  }
  function Qn(e, t) {
    try {
      var n = "", r = t;
      do
        n += U(r), r = r.return;
      while (r);
      var l = n;
    } catch (o) {
      l = `
Error generating stack: ` + o.message + `
` + o.stack;
    }
    return { value: e, source: t, stack: l, digest: null };
  }
  function ai(e, t, n) {
    return { value: e, source: null, stack: n ?? null, digest: t ?? null };
  }
  function ci(e, t) {
    try {
      console.error(t.value);
    } catch (n) {
      setTimeout(function() {
        throw n;
      });
    }
  }
  var ff = typeof WeakMap == "function" ? WeakMap : Map;
  function Us(e, t, n) {
    n = Mt(-1, n), n.tag = 3, n.payload = { element: null };
    var r = t.value;
    return n.callback = function() {
      Il || (Il = !0, Ni = r), ci(e, t);
    }, n;
  }
  function As(e, t, n) {
    n = Mt(-1, n), n.tag = 3;
    var r = e.type.getDerivedStateFromError;
    if (typeof r == "function") {
      var l = t.value;
      n.payload = function() {
        return r(l);
      }, n.callback = function() {
        ci(e, t);
      };
    }
    var o = e.stateNode;
    return o !== null && typeof o.componentDidCatch == "function" && (n.callback = function() {
      ci(e, t), typeof r != "function" && (bt === null ? bt = /* @__PURE__ */ new Set([this]) : bt.add(this));
      var i = t.stack;
      this.componentDidCatch(t.value, { componentStack: i !== null ? i : "" });
    }), n;
  }
  function Bs(e, t, n) {
    var r = e.pingCache;
    if (r === null) {
      r = e.pingCache = new ff();
      var l = /* @__PURE__ */ new Set();
      r.set(t, l);
    } else l = r.get(t), l === void 0 && (l = /* @__PURE__ */ new Set(), r.set(t, l));
    l.has(n) || (l.add(n), e = Nf.bind(null, e, t, n), t.then(e, e));
  }
  function Vs(e) {
    do {
      var t;
      if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
      e = e.return;
    } while (e !== null);
    return null;
  }
  function $s(e, t, n, r, l) {
    return (e.mode & 1) === 0 ? (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = Mt(-1, 1), t.tag = 2, Jt(n, t, 1))), n.lanes |= 1), e) : (e.flags |= 65536, e.lanes = l, e);
  }
  var df = ye.ReactCurrentOwner, Ge = !1;
  function He(e, t, n, r) {
    t.child = e === null ? ss(t, null, n, r) : Bn(t, e.child, n, r);
  }
  function Hs(e, t, n, r, l) {
    n = n.render;
    var o = t.ref;
    return $n(t, l), r = ti(e, t, n, r, o, l), n = ni(), e !== null && !Ge ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, It(e, t, l)) : (ce && n && Uo(t), t.flags |= 1, He(e, t, r, l), t.child);
  }
  function Qs(e, t, n, r, l) {
    if (e === null) {
      var o = n.type;
      return typeof o == "function" && !Ti(o) && o.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = o, Ws(e, t, o, r, l)) : (e = Bl(n.type, null, r, t, t.mode, l), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (o = e.child, (e.lanes & l) === 0) {
      var i = o.memoizedProps;
      if (n = n.compare, n = n !== null ? n : yr, n(i, r) && e.ref === t.ref) return It(e, t, l);
    }
    return t.flags |= 1, e = rn(o, r), e.ref = t.ref, e.return = t, t.child = e;
  }
  function Ws(e, t, n, r, l) {
    if (e !== null) {
      var o = e.memoizedProps;
      if (yr(o, r) && e.ref === t.ref) if (Ge = !1, t.pendingProps = r = o, (e.lanes & l) !== 0) (e.flags & 131072) !== 0 && (Ge = !0);
      else return t.lanes = e.lanes, It(e, t, l);
    }
    return fi(e, t, n, r, l);
  }
  function Ks(e, t, n) {
    var r = t.pendingProps, l = r.children, o = e !== null ? e.memoizedState : null;
    if (r.mode === "hidden") if ((t.mode & 1) === 0) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, ue(Kn, nt), nt |= n;
    else {
      if ((n & 1073741824) === 0) return e = o !== null ? o.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, ue(Kn, nt), nt |= e, null;
      t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = o !== null ? o.baseLanes : n, ue(Kn, nt), nt |= r;
    }
    else o !== null ? (r = o.baseLanes | n, t.memoizedState = null) : r = n, ue(Kn, nt), nt |= r;
    return He(e, t, l, n), t.child;
  }
  function Ys(e, t) {
    var n = t.ref;
    (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
  }
  function fi(e, t, n, r, l) {
    var o = Xe(n) ? fn : De.current;
    return o = Dn(t, o), $n(t, l), n = ti(e, t, n, r, o, l), r = ni(), e !== null && !Ge ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, It(e, t, l)) : (ce && r && Uo(t), t.flags |= 1, He(e, t, n, l), t.child);
  }
  function Xs(e, t, n, r, l) {
    if (Xe(n)) {
      var o = !0;
      fl(t);
    } else o = !1;
    if ($n(t, l), t.stateNode === null) zl(e, t), Ds(t, n, r), si(t, n, r, l), r = !0;
    else if (e === null) {
      var i = t.stateNode, u = t.memoizedProps;
      i.props = u;
      var s = i.context, m = n.contextType;
      typeof m == "object" && m !== null ? m = ut(m) : (m = Xe(n) ? fn : De.current, m = Dn(t, m));
      var k = n.getDerivedStateFromProps, w = typeof k == "function" || typeof i.getSnapshotBeforeUpdate == "function";
      w || typeof i.UNSAFE_componentWillReceiveProps != "function" && typeof i.componentWillReceiveProps != "function" || (u !== r || s !== m) && Fs(t, i, r, m), Zt = !1;
      var y = t.memoizedState;
      i.state = y, wl(t, r, i, l), s = t.memoizedState, u !== r || y !== s || Ye.current || Zt ? (typeof k == "function" && (ui(t, n, k, r), s = t.memoizedState), (u = Zt || Os(t, n, u, r, y, s, m)) ? (w || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount()), typeof i.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof i.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = s), i.props = r, i.state = s, i.context = m, r = u) : (typeof i.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
    } else {
      i = t.stateNode, cs(e, t), u = t.memoizedProps, m = t.type === t.elementType ? u : vt(t.type, u), i.props = m, w = t.pendingProps, y = i.context, s = n.contextType, typeof s == "object" && s !== null ? s = ut(s) : (s = Xe(n) ? fn : De.current, s = Dn(t, s));
      var _ = n.getDerivedStateFromProps;
      (k = typeof _ == "function" || typeof i.getSnapshotBeforeUpdate == "function") || typeof i.UNSAFE_componentWillReceiveProps != "function" && typeof i.componentWillReceiveProps != "function" || (u !== w || y !== s) && Fs(t, i, r, s), Zt = !1, y = t.memoizedState, i.state = y, wl(t, r, i, l);
      var P = t.memoizedState;
      u !== w || y !== P || Ye.current || Zt ? (typeof _ == "function" && (ui(t, n, _, r), P = t.memoizedState), (m = Zt || Os(t, n, m, r, y, P, s) || !1) ? (k || typeof i.UNSAFE_componentWillUpdate != "function" && typeof i.componentWillUpdate != "function" || (typeof i.componentWillUpdate == "function" && i.componentWillUpdate(r, P, s), typeof i.UNSAFE_componentWillUpdate == "function" && i.UNSAFE_componentWillUpdate(r, P, s)), typeof i.componentDidUpdate == "function" && (t.flags |= 4), typeof i.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof i.componentDidUpdate != "function" || u === e.memoizedProps && y === e.memoizedState || (t.flags |= 4), typeof i.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && y === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = P), i.props = r, i.state = P, i.context = s, r = m) : (typeof i.componentDidUpdate != "function" || u === e.memoizedProps && y === e.memoizedState || (t.flags |= 4), typeof i.getSnapshotBeforeUpdate != "function" || u === e.memoizedProps && y === e.memoizedState || (t.flags |= 1024), r = !1);
    }
    return di(e, t, n, r, o, l);
  }
  function di(e, t, n, r, l, o) {
    Ys(e, t);
    var i = (t.flags & 128) !== 0;
    if (!r && !i) return l && bu(t, n, !1), It(e, t, o);
    r = t.stateNode, df.current = t;
    var u = i && typeof n.getDerivedStateFromError != "function" ? null : r.render();
    return t.flags |= 1, e !== null && i ? (t.child = Bn(t, e.child, null, o), t.child = Bn(t, null, u, o)) : He(e, t, u, o), t.memoizedState = r.state, l && bu(t, n, !0), t.child;
  }
  function Gs(e) {
    var t = e.stateNode;
    t.pendingContext ? Ju(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Ju(e, t.context, !1), Go(e, t.containerInfo);
  }
  function Zs(e, t, n, r, l) {
    return An(), $o(l), t.flags |= 256, He(e, t, n, r), t.child;
  }
  var pi = { dehydrated: null, treeContext: null, retryLane: 0 };
  function mi(e) {
    return { baseLanes: e, cachePool: null, transitions: null };
  }
  function Js(e, t, n) {
    var r = t.pendingProps, l = fe.current, o = !1, i = (t.flags & 128) !== 0, u;
    if ((u = i) || (u = e !== null && e.memoizedState === null ? !1 : (l & 2) !== 0), u ? (o = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (l |= 1), ue(fe, l & 1), e === null)
      return Vo(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? ((t.mode & 1) === 0 ? t.lanes = 1 : e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824, null) : (i = r.children, e = r.fallback, o ? (r = t.mode, o = t.child, i = { mode: "hidden", children: i }, (r & 1) === 0 && o !== null ? (o.childLanes = 0, o.pendingProps = i) : o = Vl(i, r, 0, null), e = Sn(e, r, n, null), o.return = t, e.return = t, o.sibling = e, t.child = o, t.child.memoizedState = mi(n), t.memoizedState = pi, e) : hi(t, i));
    if (l = e.memoizedState, l !== null && (u = l.dehydrated, u !== null)) return pf(e, t, i, r, u, l, n);
    if (o) {
      o = r.fallback, i = t.mode, l = e.child, u = l.sibling;
      var s = { mode: "hidden", children: r.children };
      return (i & 1) === 0 && t.child !== l ? (r = t.child, r.childLanes = 0, r.pendingProps = s, t.deletions = null) : (r = rn(l, s), r.subtreeFlags = l.subtreeFlags & 14680064), u !== null ? o = rn(u, o) : (o = Sn(o, i, n, null), o.flags |= 2), o.return = t, r.return = t, r.sibling = o, t.child = r, r = o, o = t.child, i = e.child.memoizedState, i = i === null ? mi(n) : { baseLanes: i.baseLanes | n, cachePool: null, transitions: i.transitions }, o.memoizedState = i, o.childLanes = e.childLanes & ~n, t.memoizedState = pi, r;
    }
    return o = e.child, e = o.sibling, r = rn(o, { mode: "visible", children: r.children }), (t.mode & 1) === 0 && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
  }
  function hi(e, t) {
    return t = Vl({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
  }
  function Pl(e, t, n, r) {
    return r !== null && $o(r), Bn(t, e.child, null, n), e = hi(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
  }
  function pf(e, t, n, r, l, o, i) {
    if (n)
      return t.flags & 256 ? (t.flags &= -257, r = ai(Error(f(422))), Pl(e, t, i, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (o = r.fallback, l = t.mode, r = Vl({ mode: "visible", children: r.children }, l, 0, null), o = Sn(o, l, i, null), o.flags |= 2, r.return = t, o.return = t, r.sibling = o, t.child = r, (t.mode & 1) !== 0 && Bn(t, e.child, null, i), t.child.memoizedState = mi(i), t.memoizedState = pi, o);
    if ((t.mode & 1) === 0) return Pl(e, t, i, null);
    if (l.data === "$!") {
      if (r = l.nextSibling && l.nextSibling.dataset, r) var u = r.dgst;
      return r = u, o = Error(f(419)), r = ai(o, r, void 0), Pl(e, t, i, r);
    }
    if (u = (i & e.childLanes) !== 0, Ge || u) {
      if (r = _e, r !== null) {
        switch (i & -i) {
          case 4:
            l = 2;
            break;
          case 16:
            l = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            l = 32;
            break;
          case 536870912:
            l = 268435456;
            break;
          default:
            l = 0;
        }
        l = (l & (r.suspendedLanes | i)) !== 0 ? 0 : l, l !== 0 && l !== o.retryLane && (o.retryLane = l, Tt(e, l), kt(r, e, l, -1));
      }
      return Li(), r = ai(Error(f(421))), Pl(e, t, i, r);
    }
    return l.data === "$?" ? (t.flags |= 128, t.child = e.child, t = _f.bind(null, e), l._reactRetry = t, null) : (e = o.treeContext, tt = Kt(l.nextSibling), et = t, ce = !0, ht = null, e !== null && (ot[it++] = Rt, ot[it++] = Lt, ot[it++] = dn, Rt = e.id, Lt = e.overflow, dn = t), t = hi(t, r.children), t.flags |= 4096, t);
  }
  function qs(e, t, n) {
    e.lanes |= t;
    var r = e.alternate;
    r !== null && (r.lanes |= t), Ko(e.return, t, n);
  }
  function vi(e, t, n, r, l) {
    var o = e.memoizedState;
    o === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: l } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = l);
  }
  function bs(e, t, n) {
    var r = t.pendingProps, l = r.revealOrder, o = r.tail;
    if (He(e, t, r.children, n), r = fe.current, (r & 2) !== 0) r = r & 1 | 2, t.flags |= 128;
    else {
      if (e !== null && (e.flags & 128) !== 0) e: for (e = t.child; e !== null; ) {
        if (e.tag === 13) e.memoizedState !== null && qs(e, n, t);
        else if (e.tag === 19) qs(e, n, t);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
      r &= 1;
    }
    if (ue(fe, r), (t.mode & 1) === 0) t.memoizedState = null;
    else switch (l) {
      case "forwards":
        for (n = t.child, l = null; n !== null; ) e = n.alternate, e !== null && Sl(e) === null && (l = n), n = n.sibling;
        n = l, n === null ? (l = t.child, t.child = null) : (l = n.sibling, n.sibling = null), vi(t, !1, l, n, o);
        break;
      case "backwards":
        for (n = null, l = t.child, t.child = null; l !== null; ) {
          if (e = l.alternate, e !== null && Sl(e) === null) {
            t.child = l;
            break;
          }
          e = l.sibling, l.sibling = n, n = l, l = e;
        }
        vi(t, !0, n, null, o);
        break;
      case "together":
        vi(t, !1, null, null, void 0);
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function zl(e, t) {
    (t.mode & 1) === 0 && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
  }
  function It(e, t, n) {
    if (e !== null && (t.dependencies = e.dependencies), yn |= t.lanes, (n & t.childLanes) === 0) return null;
    if (e !== null && t.child !== e.child) throw Error(f(153));
    if (t.child !== null) {
      for (e = t.child, n = rn(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = rn(e, e.pendingProps), n.return = t;
      n.sibling = null;
    }
    return t.child;
  }
  function mf(e, t, n) {
    switch (t.tag) {
      case 3:
        Gs(t), An();
        break;
      case 5:
        ps(t);
        break;
      case 1:
        Xe(t.type) && fl(t);
        break;
      case 4:
        Go(t, t.stateNode.containerInfo);
        break;
      case 10:
        var r = t.type._context, l = t.memoizedProps.value;
        ue(yl, r._currentValue), r._currentValue = l;
        break;
      case 13:
        if (r = t.memoizedState, r !== null)
          return r.dehydrated !== null ? (ue(fe, fe.current & 1), t.flags |= 128, null) : (n & t.child.childLanes) !== 0 ? Js(e, t, n) : (ue(fe, fe.current & 1), e = It(e, t, n), e !== null ? e.sibling : null);
        ue(fe, fe.current & 1);
        break;
      case 19:
        if (r = (n & t.childLanes) !== 0, (e.flags & 128) !== 0) {
          if (r) return bs(e, t, n);
          t.flags |= 128;
        }
        if (l = t.memoizedState, l !== null && (l.rendering = null, l.tail = null, l.lastEffect = null), ue(fe, fe.current), r) break;
        return null;
      case 22:
      case 23:
        return t.lanes = 0, Ks(e, t, n);
    }
    return It(e, t, n);
  }
  var ea, yi, ta, na;
  ea = function(e, t) {
    for (var n = t.child; n !== null; ) {
      if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
      else if (n.tag !== 4 && n.child !== null) {
        n.child.return = n, n = n.child;
        continue;
      }
      if (n === t) break;
      for (; n.sibling === null; ) {
        if (n.return === null || n.return === t) return;
        n = n.return;
      }
      n.sibling.return = n.return, n = n.sibling;
    }
  }, yi = function() {
  }, ta = function(e, t, n, r) {
    var l = e.memoizedProps;
    if (l !== r) {
      e = t.stateNode, hn(Ct.current);
      var o = null;
      switch (n) {
        case "input":
          l = En(e, l), r = En(e, r), o = [];
          break;
        case "select":
          l = g({}, l, { value: void 0 }), r = g({}, r, { value: void 0 }), o = [];
          break;
        case "textarea":
          l = At(e, l), r = At(e, r), o = [];
          break;
        default:
          typeof l.onClick != "function" && typeof r.onClick == "function" && (e.onclick = sl);
      }
      Zl(n, r);
      var i;
      n = null;
      for (m in l) if (!r.hasOwnProperty(m) && l.hasOwnProperty(m) && l[m] != null) if (m === "style") {
        var u = l[m];
        for (i in u) u.hasOwnProperty(i) && (n || (n = {}), n[i] = "");
      } else m !== "dangerouslySetInnerHTML" && m !== "children" && m !== "suppressContentEditableWarning" && m !== "suppressHydrationWarning" && m !== "autoFocus" && (le.hasOwnProperty(m) ? o || (o = []) : (o = o || []).push(m, null));
      for (m in r) {
        var s = r[m];
        if (u = l != null ? l[m] : void 0, r.hasOwnProperty(m) && s !== u && (s != null || u != null)) if (m === "style") if (u) {
          for (i in u) !u.hasOwnProperty(i) || s && s.hasOwnProperty(i) || (n || (n = {}), n[i] = "");
          for (i in s) s.hasOwnProperty(i) && u[i] !== s[i] && (n || (n = {}), n[i] = s[i]);
        } else n || (o || (o = []), o.push(
          m,
          n
        )), n = s;
        else m === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, u = u ? u.__html : void 0, s != null && u !== s && (o = o || []).push(m, s)) : m === "children" ? typeof s != "string" && typeof s != "number" || (o = o || []).push(m, "" + s) : m !== "suppressContentEditableWarning" && m !== "suppressHydrationWarning" && (le.hasOwnProperty(m) ? (s != null && m === "onScroll" && se("scroll", e), o || u === s || (o = [])) : (o = o || []).push(m, s));
      }
      n && (o = o || []).push("style", n);
      var m = o;
      (t.updateQueue = m) && (t.flags |= 4);
    }
  }, na = function(e, t, n, r) {
    n !== r && (t.flags |= 4);
  };
  function Tr(e, t) {
    if (!ce) switch (e.tailMode) {
      case "hidden":
        t = e.tail;
        for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
        n === null ? e.tail = null : n.sibling = null;
        break;
      case "collapsed":
        n = e.tail;
        for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
        r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
    }
  }
  function Ue(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
    if (t) for (var l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags & 14680064, r |= l.flags & 14680064, l.return = e, l = l.sibling;
    else for (l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags, r |= l.flags, l.return = e, l = l.sibling;
    return e.subtreeFlags |= r, e.childLanes = n, t;
  }
  function hf(e, t, n) {
    var r = t.pendingProps;
    switch (Ao(t), t.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ue(t), null;
      case 1:
        return Xe(t.type) && cl(), Ue(t), null;
      case 3:
        return r = t.stateNode, Hn(), ae(Ye), ae(De), qo(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (hl(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, ht !== null && (Pi(ht), ht = null))), yi(e, t), Ue(t), null;
      case 5:
        Zo(t);
        var l = hn(jr.current);
        if (n = t.type, e !== null && t.stateNode != null) ta(e, t, n, r, l), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
        else {
          if (!r) {
            if (t.stateNode === null) throw Error(f(166));
            return Ue(t), null;
          }
          if (e = hn(Ct.current), hl(t)) {
            r = t.stateNode, n = t.type;
            var o = t.memoizedProps;
            switch (r[Et] = t, r[xr] = o, e = (t.mode & 1) !== 0, n) {
              case "dialog":
                se("cancel", r), se("close", r);
                break;
              case "iframe":
              case "object":
              case "embed":
                se("load", r);
                break;
              case "video":
              case "audio":
                for (l = 0; l < kr.length; l++) se(kr[l], r);
                break;
              case "source":
                se("error", r);
                break;
              case "img":
              case "image":
              case "link":
                se(
                  "error",
                  r
                ), se("load", r);
                break;
              case "details":
                se("toggle", r);
                break;
              case "input":
                Ut(r, o), se("invalid", r);
                break;
              case "select":
                r._wrapperState = { wasMultiple: !!o.multiple }, se("invalid", r);
                break;
              case "textarea":
                bn(r, o), se("invalid", r);
            }
            Zl(n, o), l = null;
            for (var i in o) if (o.hasOwnProperty(i)) {
              var u = o[i];
              i === "children" ? typeof u == "string" ? r.textContent !== u && (o.suppressHydrationWarning !== !0 && ul(r.textContent, u, e), l = ["children", u]) : typeof u == "number" && r.textContent !== "" + u && (o.suppressHydrationWarning !== !0 && ul(
                r.textContent,
                u,
                e
              ), l = ["children", "" + u]) : le.hasOwnProperty(i) && u != null && i === "onScroll" && se("scroll", r);
            }
            switch (n) {
              case "input":
                xn(r), qn(r, o, !0);
                break;
              case "textarea":
                xn(r), er(r);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof o.onClick == "function" && (r.onclick = sl);
            }
            r = l, t.updateQueue = r, r !== null && (t.flags |= 4);
          } else {
            i = l.nodeType === 9 ? l : l.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = tr(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = i.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = i.createElement(n, { is: r.is }) : (e = i.createElement(n), n === "select" && (i = e, r.multiple ? i.multiple = !0 : r.size && (i.size = r.size))) : e = i.createElementNS(e, n), e[Et] = t, e[xr] = r, ea(e, t, !1, !1), t.stateNode = e;
            e: {
              switch (i = Jl(n, r), n) {
                case "dialog":
                  se("cancel", e), se("close", e), l = r;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  se("load", e), l = r;
                  break;
                case "video":
                case "audio":
                  for (l = 0; l < kr.length; l++) se(kr[l], e);
                  l = r;
                  break;
                case "source":
                  se("error", e), l = r;
                  break;
                case "img":
                case "image":
                case "link":
                  se(
                    "error",
                    e
                  ), se("load", e), l = r;
                  break;
                case "details":
                  se("toggle", e), l = r;
                  break;
                case "input":
                  Ut(e, r), l = En(e, r), se("invalid", e);
                  break;
                case "option":
                  l = r;
                  break;
                case "select":
                  e._wrapperState = { wasMultiple: !!r.multiple }, l = g({}, r, { value: void 0 }), se("invalid", e);
                  break;
                case "textarea":
                  bn(e, r), l = At(e, r), se("invalid", e);
                  break;
                default:
                  l = r;
              }
              Zl(n, l), u = l;
              for (o in u) if (u.hasOwnProperty(o)) {
                var s = u[o];
                o === "style" ? Wi(e, s) : o === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, s != null && M(e, s)) : o === "children" ? typeof s == "string" ? (n !== "textarea" || s !== "") && G(e, s) : typeof s == "number" && G(e, "" + s) : o !== "suppressContentEditableWarning" && o !== "suppressHydrationWarning" && o !== "autoFocus" && (le.hasOwnProperty(o) ? s != null && o === "onScroll" && se("scroll", e) : s != null && We(e, o, s, i));
              }
              switch (n) {
                case "input":
                  xn(e), qn(e, r, !1);
                  break;
                case "textarea":
                  xn(e), er(e);
                  break;
                case "option":
                  r.value != null && e.setAttribute("value", "" + q(r.value));
                  break;
                case "select":
                  e.multiple = !!r.multiple, o = r.value, o != null ? jt(e, !!r.multiple, o, !1) : r.defaultValue != null && jt(
                    e,
                    !!r.multiple,
                    r.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof l.onClick == "function" && (e.onclick = sl);
              }
              switch (n) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  r = !!r.autoFocus;
                  break e;
                case "img":
                  r = !0;
                  break e;
                default:
                  r = !1;
              }
            }
            r && (t.flags |= 4);
          }
          t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
        }
        return Ue(t), null;
      case 6:
        if (e && t.stateNode != null) na(e, t, e.memoizedProps, r);
        else {
          if (typeof r != "string" && t.stateNode === null) throw Error(f(166));
          if (n = hn(jr.current), hn(Ct.current), hl(t)) {
            if (r = t.stateNode, n = t.memoizedProps, r[Et] = t, (o = r.nodeValue !== n) && (e = et, e !== null)) switch (e.tag) {
              case 3:
                ul(r.nodeValue, n, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 && ul(r.nodeValue, n, (e.mode & 1) !== 0);
            }
            o && (t.flags |= 4);
          } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[Et] = t, t.stateNode = r;
        }
        return Ue(t), null;
      case 13:
        if (ae(fe), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (ce && tt !== null && (t.mode & 1) !== 0 && (t.flags & 128) === 0) os(), An(), t.flags |= 98560, o = !1;
          else if (o = hl(t), r !== null && r.dehydrated !== null) {
            if (e === null) {
              if (!o) throw Error(f(318));
              if (o = t.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(f(317));
              o[Et] = t;
            } else An(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            Ue(t), o = !1;
          } else ht !== null && (Pi(ht), ht = null), o = !0;
          if (!o) return t.flags & 65536 ? t : null;
        }
        return (t.flags & 128) !== 0 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, (t.mode & 1) !== 0 && (e === null || (fe.current & 1) !== 0 ? xe === 0 && (xe = 3) : Li())), t.updateQueue !== null && (t.flags |= 4), Ue(t), null);
      case 4:
        return Hn(), yi(e, t), e === null && wr(t.stateNode.containerInfo), Ue(t), null;
      case 10:
        return Wo(t.type._context), Ue(t), null;
      case 17:
        return Xe(t.type) && cl(), Ue(t), null;
      case 19:
        if (ae(fe), o = t.memoizedState, o === null) return Ue(t), null;
        if (r = (t.flags & 128) !== 0, i = o.rendering, i === null) if (r) Tr(o, !1);
        else {
          if (xe !== 0 || e !== null && (e.flags & 128) !== 0) for (e = t.child; e !== null; ) {
            if (i = Sl(e), i !== null) {
              for (t.flags |= 128, Tr(o, !1), r = i.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) o = n, e = r, o.flags &= 14680066, i = o.alternate, i === null ? (o.childLanes = 0, o.lanes = e, o.child = null, o.subtreeFlags = 0, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = i.childLanes, o.lanes = i.lanes, o.child = i.child, o.subtreeFlags = 0, o.deletions = null, o.memoizedProps = i.memoizedProps, o.memoizedState = i.memoizedState, o.updateQueue = i.updateQueue, o.type = i.type, e = i.dependencies, o.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
              return ue(fe, fe.current & 1 | 2), t.child;
            }
            e = e.sibling;
          }
          o.tail !== null && he() > Yn && (t.flags |= 128, r = !0, Tr(o, !1), t.lanes = 4194304);
        }
        else {
          if (!r) if (e = Sl(i), e !== null) {
            if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), Tr(o, !0), o.tail === null && o.tailMode === "hidden" && !i.alternate && !ce) return Ue(t), null;
          } else 2 * he() - o.renderingStartTime > Yn && n !== 1073741824 && (t.flags |= 128, r = !0, Tr(o, !1), t.lanes = 4194304);
          o.isBackwards ? (i.sibling = t.child, t.child = i) : (n = o.last, n !== null ? n.sibling = i : t.child = i, o.last = i);
        }
        return o.tail !== null ? (t = o.tail, o.rendering = t, o.tail = t.sibling, o.renderingStartTime = he(), t.sibling = null, n = fe.current, ue(fe, r ? n & 1 | 2 : n & 1), t) : (Ue(t), null);
      case 22:
      case 23:
        return Ri(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && (t.mode & 1) !== 0 ? (nt & 1073741824) !== 0 && (Ue(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Ue(t), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(f(156, t.tag));
  }
  function vf(e, t) {
    switch (Ao(t), t.tag) {
      case 1:
        return Xe(t.type) && cl(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 3:
        return Hn(), ae(Ye), ae(De), qo(), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
      case 5:
        return Zo(t), null;
      case 13:
        if (ae(fe), e = t.memoizedState, e !== null && e.dehydrated !== null) {
          if (t.alternate === null) throw Error(f(340));
          An();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 19:
        return ae(fe), null;
      case 4:
        return Hn(), null;
      case 10:
        return Wo(t.type._context), null;
      case 22:
      case 23:
        return Ri(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Rl = !1, Ae = !1, yf = typeof WeakSet == "function" ? WeakSet : Set, j = null;
  function Wn(e, t) {
    var n = e.ref;
    if (n !== null) if (typeof n == "function") try {
      n(null);
    } catch (r) {
      me(e, t, r);
    }
    else n.current = null;
  }
  function gi(e, t, n) {
    try {
      n();
    } catch (r) {
      me(e, t, r);
    }
  }
  var ra = !1;
  function gf(e, t) {
    if (Ro = Zr, e = Ou(), xo(e)) {
      if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
      else e: {
        n = (n = e.ownerDocument) && n.defaultView || window;
        var r = n.getSelection && n.getSelection();
        if (r && r.rangeCount !== 0) {
          n = r.anchorNode;
          var l = r.anchorOffset, o = r.focusNode;
          r = r.focusOffset;
          try {
            n.nodeType, o.nodeType;
          } catch {
            n = null;
            break e;
          }
          var i = 0, u = -1, s = -1, m = 0, k = 0, w = e, y = null;
          t: for (; ; ) {
            for (var _; w !== n || l !== 0 && w.nodeType !== 3 || (u = i + l), w !== o || r !== 0 && w.nodeType !== 3 || (s = i + r), w.nodeType === 3 && (i += w.nodeValue.length), (_ = w.firstChild) !== null; )
              y = w, w = _;
            for (; ; ) {
              if (w === e) break t;
              if (y === n && ++m === l && (u = i), y === o && ++k === r && (s = i), (_ = w.nextSibling) !== null) break;
              w = y, y = w.parentNode;
            }
            w = _;
          }
          n = u === -1 || s === -1 ? null : { start: u, end: s };
        } else n = null;
      }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (Lo = { focusedElem: e, selectionRange: n }, Zr = !1, j = t; j !== null; ) if (t = j, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, j = e;
    else for (; j !== null; ) {
      t = j;
      try {
        var P = t.alternate;
        if ((t.flags & 1024) !== 0) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (P !== null) {
              var z = P.memoizedProps, ve = P.memoizedState, d = t.stateNode, a = d.getSnapshotBeforeUpdate(t.elementType === t.type ? z : vt(t.type, z), ve);
              d.__reactInternalSnapshotBeforeUpdate = a;
            }
            break;
          case 3:
            var p = t.stateNode.containerInfo;
            p.nodeType === 1 ? p.textContent = "" : p.nodeType === 9 && p.documentElement && p.removeChild(p.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(f(163));
        }
      } catch (E) {
        me(t, t.return, E);
      }
      if (e = t.sibling, e !== null) {
        e.return = t.return, j = e;
        break;
      }
      j = t.return;
    }
    return P = ra, ra = !1, P;
  }
  function Mr(e, t, n) {
    var r = t.updateQueue;
    if (r = r !== null ? r.lastEffect : null, r !== null) {
      var l = r = r.next;
      do {
        if ((l.tag & e) === e) {
          var o = l.destroy;
          l.destroy = void 0, o !== void 0 && gi(t, n, o);
        }
        l = l.next;
      } while (l !== r);
    }
  }
  function Ll(e, t) {
    if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
      var n = t = t.next;
      do {
        if ((n.tag & e) === e) {
          var r = n.create;
          n.destroy = r();
        }
        n = n.next;
      } while (n !== t);
    }
  }
  function ki(e) {
    var t = e.ref;
    if (t !== null) {
      var n = e.stateNode;
      switch (e.tag) {
        case 5:
          e = n;
          break;
        default:
          e = n;
      }
      typeof t == "function" ? t(e) : t.current = e;
    }
  }
  function la(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, la(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[Et], delete t[xr], delete t[Oo], delete t[bc], delete t[ef])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  function oa(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 4;
  }
  function ia(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || oa(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function wi(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = sl));
    else if (r !== 4 && (e = e.child, e !== null)) for (wi(e, t, n), e = e.sibling; e !== null; ) wi(e, t, n), e = e.sibling;
  }
  function Si(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
    else if (r !== 4 && (e = e.child, e !== null)) for (Si(e, t, n), e = e.sibling; e !== null; ) Si(e, t, n), e = e.sibling;
  }
  var Te = null, yt = !1;
  function qt(e, t, n) {
    for (n = n.child; n !== null; ) ua(e, t, n), n = n.sibling;
  }
  function ua(e, t, n) {
    if (xt && typeof xt.onCommitFiberUnmount == "function") try {
      xt.onCommitFiberUnmount(Qr, n);
    } catch {
    }
    switch (n.tag) {
      case 5:
        Ae || Wn(n, t);
      case 6:
        var r = Te, l = yt;
        Te = null, qt(e, t, n), Te = r, yt = l, Te !== null && (yt ? (e = Te, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : Te.removeChild(n.stateNode));
        break;
      case 18:
        Te !== null && (yt ? (e = Te, n = n.stateNode, e.nodeType === 8 ? Io(e.parentNode, n) : e.nodeType === 1 && Io(e, n), fr(e)) : Io(Te, n.stateNode));
        break;
      case 4:
        r = Te, l = yt, Te = n.stateNode.containerInfo, yt = !0, qt(e, t, n), Te = r, yt = l;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Ae && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
          l = r = r.next;
          do {
            var o = l, i = o.destroy;
            o = o.tag, i !== void 0 && ((o & 2) !== 0 || (o & 4) !== 0) && gi(n, t, i), l = l.next;
          } while (l !== r);
        }
        qt(e, t, n);
        break;
      case 1:
        if (!Ae && (Wn(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
          r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
        } catch (u) {
          me(n, t, u);
        }
        qt(e, t, n);
        break;
      case 21:
        qt(e, t, n);
        break;
      case 22:
        n.mode & 1 ? (Ae = (r = Ae) || n.memoizedState !== null, qt(e, t, n), Ae = r) : qt(e, t, n);
        break;
      default:
        qt(e, t, n);
    }
  }
  function sa(e) {
    var t = e.updateQueue;
    if (t !== null) {
      e.updateQueue = null;
      var n = e.stateNode;
      n === null && (n = e.stateNode = new yf()), t.forEach(function(r) {
        var l = jf.bind(null, e, r);
        n.has(r) || (n.add(r), r.then(l, l));
      });
    }
  }
  function gt(e, t) {
    var n = t.deletions;
    if (n !== null) for (var r = 0; r < n.length; r++) {
      var l = n[r];
      try {
        var o = e, i = t, u = i;
        e: for (; u !== null; ) {
          switch (u.tag) {
            case 5:
              Te = u.stateNode, yt = !1;
              break e;
            case 3:
              Te = u.stateNode.containerInfo, yt = !0;
              break e;
            case 4:
              Te = u.stateNode.containerInfo, yt = !0;
              break e;
          }
          u = u.return;
        }
        if (Te === null) throw Error(f(160));
        ua(o, i, l), Te = null, yt = !1;
        var s = l.alternate;
        s !== null && (s.return = null), l.return = null;
      } catch (m) {
        me(l, t, m);
      }
    }
    if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) aa(t, e), t = t.sibling;
  }
  function aa(e, t) {
    var n = e.alternate, r = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (gt(t, e), _t(e), r & 4) {
          try {
            Mr(3, e, e.return), Ll(3, e);
          } catch (z) {
            me(e, e.return, z);
          }
          try {
            Mr(5, e, e.return);
          } catch (z) {
            me(e, e.return, z);
          }
        }
        break;
      case 1:
        gt(t, e), _t(e), r & 512 && n !== null && Wn(n, n.return);
        break;
      case 5:
        if (gt(t, e), _t(e), r & 512 && n !== null && Wn(n, n.return), e.flags & 32) {
          var l = e.stateNode;
          try {
            G(l, "");
          } catch (z) {
            me(e, e.return, z);
          }
        }
        if (r & 4 && (l = e.stateNode, l != null)) {
          var o = e.memoizedProps, i = n !== null ? n.memoizedProps : o, u = e.type, s = e.updateQueue;
          if (e.updateQueue = null, s !== null) try {
            u === "input" && o.type === "radio" && o.name != null && Ar(l, o), Jl(u, i);
            var m = Jl(u, o);
            for (i = 0; i < s.length; i += 2) {
              var k = s[i], w = s[i + 1];
              k === "style" ? Wi(l, w) : k === "dangerouslySetInnerHTML" ? M(l, w) : k === "children" ? G(l, w) : We(l, k, w, m);
            }
            switch (u) {
              case "input":
                Jn(l, o);
                break;
              case "textarea":
                Br(l, o);
                break;
              case "select":
                var y = l._wrapperState.wasMultiple;
                l._wrapperState.wasMultiple = !!o.multiple;
                var _ = o.value;
                _ != null ? jt(l, !!o.multiple, _, !1) : y !== !!o.multiple && (o.defaultValue != null ? jt(
                  l,
                  !!o.multiple,
                  o.defaultValue,
                  !0
                ) : jt(l, !!o.multiple, o.multiple ? [] : "", !1));
            }
            l[xr] = o;
          } catch (z) {
            me(e, e.return, z);
          }
        }
        break;
      case 6:
        if (gt(t, e), _t(e), r & 4) {
          if (e.stateNode === null) throw Error(f(162));
          l = e.stateNode, o = e.memoizedProps;
          try {
            l.nodeValue = o;
          } catch (z) {
            me(e, e.return, z);
          }
        }
        break;
      case 3:
        if (gt(t, e), _t(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
          fr(t.containerInfo);
        } catch (z) {
          me(e, e.return, z);
        }
        break;
      case 4:
        gt(t, e), _t(e);
        break;
      case 13:
        gt(t, e), _t(e), l = e.child, l.flags & 8192 && (o = l.memoizedState !== null, l.stateNode.isHidden = o, !o || l.alternate !== null && l.alternate.memoizedState !== null || (Ci = he())), r & 4 && sa(e);
        break;
      case 22:
        if (k = n !== null && n.memoizedState !== null, e.mode & 1 ? (Ae = (m = Ae) || k, gt(t, e), Ae = m) : gt(t, e), _t(e), r & 8192) {
          if (m = e.memoizedState !== null, (e.stateNode.isHidden = m) && !k && (e.mode & 1) !== 0) for (j = e, k = e.child; k !== null; ) {
            for (w = j = k; j !== null; ) {
              switch (y = j, _ = y.child, y.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Mr(4, y, y.return);
                  break;
                case 1:
                  Wn(y, y.return);
                  var P = y.stateNode;
                  if (typeof P.componentWillUnmount == "function") {
                    r = y, n = y.return;
                    try {
                      t = r, P.props = t.memoizedProps, P.state = t.memoizedState, P.componentWillUnmount();
                    } catch (z) {
                      me(r, n, z);
                    }
                  }
                  break;
                case 5:
                  Wn(y, y.return);
                  break;
                case 22:
                  if (y.memoizedState !== null) {
                    da(w);
                    continue;
                  }
              }
              _ !== null ? (_.return = y, j = _) : da(w);
            }
            k = k.sibling;
          }
          e: for (k = null, w = e; ; ) {
            if (w.tag === 5) {
              if (k === null) {
                k = w;
                try {
                  l = w.stateNode, m ? (o = l.style, typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none") : (u = w.stateNode, s = w.memoizedProps.style, i = s != null && s.hasOwnProperty("display") ? s.display : null, u.style.display = sn("display", i));
                } catch (z) {
                  me(e, e.return, z);
                }
              }
            } else if (w.tag === 6) {
              if (k === null) try {
                w.stateNode.nodeValue = m ? "" : w.memoizedProps;
              } catch (z) {
                me(e, e.return, z);
              }
            } else if ((w.tag !== 22 && w.tag !== 23 || w.memoizedState === null || w === e) && w.child !== null) {
              w.child.return = w, w = w.child;
              continue;
            }
            if (w === e) break e;
            for (; w.sibling === null; ) {
              if (w.return === null || w.return === e) break e;
              k === w && (k = null), w = w.return;
            }
            k === w && (k = null), w.sibling.return = w.return, w = w.sibling;
          }
        }
        break;
      case 19:
        gt(t, e), _t(e), r & 4 && sa(e);
        break;
      case 21:
        break;
      default:
        gt(
          t,
          e
        ), _t(e);
    }
  }
  function _t(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        e: {
          for (var n = e.return; n !== null; ) {
            if (oa(n)) {
              var r = n;
              break e;
            }
            n = n.return;
          }
          throw Error(f(160));
        }
        switch (r.tag) {
          case 5:
            var l = r.stateNode;
            r.flags & 32 && (G(l, ""), r.flags &= -33);
            var o = ia(e);
            Si(e, o, l);
            break;
          case 3:
          case 4:
            var i = r.stateNode.containerInfo, u = ia(e);
            wi(e, u, i);
            break;
          default:
            throw Error(f(161));
        }
      } catch (s) {
        me(e, e.return, s);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function kf(e, t, n) {
    j = e, ca(e);
  }
  function ca(e, t, n) {
    for (var r = (e.mode & 1) !== 0; j !== null; ) {
      var l = j, o = l.child;
      if (l.tag === 22 && r) {
        var i = l.memoizedState !== null || Rl;
        if (!i) {
          var u = l.alternate, s = u !== null && u.memoizedState !== null || Ae;
          u = Rl;
          var m = Ae;
          if (Rl = i, (Ae = s) && !m) for (j = l; j !== null; ) i = j, s = i.child, i.tag === 22 && i.memoizedState !== null ? pa(l) : s !== null ? (s.return = i, j = s) : pa(l);
          for (; o !== null; ) j = o, ca(o), o = o.sibling;
          j = l, Rl = u, Ae = m;
        }
        fa(e);
      } else (l.subtreeFlags & 8772) !== 0 && o !== null ? (o.return = l, j = o) : fa(e);
    }
  }
  function fa(e) {
    for (; j !== null; ) {
      var t = j;
      if ((t.flags & 8772) !== 0) {
        var n = t.alternate;
        try {
          if ((t.flags & 8772) !== 0) switch (t.tag) {
            case 0:
            case 11:
            case 15:
              Ae || Ll(5, t);
              break;
            case 1:
              var r = t.stateNode;
              if (t.flags & 4 && !Ae) if (n === null) r.componentDidMount();
              else {
                var l = t.elementType === t.type ? n.memoizedProps : vt(t.type, n.memoizedProps);
                r.componentDidUpdate(l, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
              }
              var o = t.updateQueue;
              o !== null && ds(t, o, r);
              break;
            case 3:
              var i = t.updateQueue;
              if (i !== null) {
                if (n = null, t.child !== null) switch (t.child.tag) {
                  case 5:
                    n = t.child.stateNode;
                    break;
                  case 1:
                    n = t.child.stateNode;
                }
                ds(t, i, n);
              }
              break;
            case 5:
              var u = t.stateNode;
              if (n === null && t.flags & 4) {
                n = u;
                var s = t.memoizedProps;
                switch (t.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    s.autoFocus && n.focus();
                    break;
                  case "img":
                    s.src && (n.src = s.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (t.memoizedState === null) {
                var m = t.alternate;
                if (m !== null) {
                  var k = m.memoizedState;
                  if (k !== null) {
                    var w = k.dehydrated;
                    w !== null && fr(w);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(f(163));
          }
          Ae || t.flags & 512 && ki(t);
        } catch (y) {
          me(t, t.return, y);
        }
      }
      if (t === e) {
        j = null;
        break;
      }
      if (n = t.sibling, n !== null) {
        n.return = t.return, j = n;
        break;
      }
      j = t.return;
    }
  }
  function da(e) {
    for (; j !== null; ) {
      var t = j;
      if (t === e) {
        j = null;
        break;
      }
      var n = t.sibling;
      if (n !== null) {
        n.return = t.return, j = n;
        break;
      }
      j = t.return;
    }
  }
  function pa(e) {
    for (; j !== null; ) {
      var t = j;
      try {
        switch (t.tag) {
          case 0:
          case 11:
          case 15:
            var n = t.return;
            try {
              Ll(4, t);
            } catch (s) {
              me(t, n, s);
            }
            break;
          case 1:
            var r = t.stateNode;
            if (typeof r.componentDidMount == "function") {
              var l = t.return;
              try {
                r.componentDidMount();
              } catch (s) {
                me(t, l, s);
              }
            }
            var o = t.return;
            try {
              ki(t);
            } catch (s) {
              me(t, o, s);
            }
            break;
          case 5:
            var i = t.return;
            try {
              ki(t);
            } catch (s) {
              me(t, i, s);
            }
        }
      } catch (s) {
        me(t, t.return, s);
      }
      if (t === e) {
        j = null;
        break;
      }
      var u = t.sibling;
      if (u !== null) {
        u.return = t.return, j = u;
        break;
      }
      j = t.return;
    }
  }
  var wf = Math.ceil, Tl = ye.ReactCurrentDispatcher, xi = ye.ReactCurrentOwner, at = ye.ReactCurrentBatchConfig, Z = 0, _e = null, ke = null, Me = 0, nt = 0, Kn = Yt(0), xe = 0, Ir = null, yn = 0, Ml = 0, Ei = 0, Or = null, Ze = null, Ci = 0, Yn = 1 / 0, Ot = null, Il = !1, Ni = null, bt = null, Ol = !1, en = null, Dl = 0, Dr = 0, _i = null, Fl = -1, Ul = 0;
  function Qe() {
    return (Z & 6) !== 0 ? he() : Fl !== -1 ? Fl : Fl = he();
  }
  function tn(e) {
    return (e.mode & 1) === 0 ? 1 : (Z & 2) !== 0 && Me !== 0 ? Me & -Me : nf.transition !== null ? (Ul === 0 && (Ul = iu()), Ul) : (e = re, e !== 0 || (e = window.event, e = e === void 0 ? 16 : hu(e.type)), e);
  }
  function kt(e, t, n, r) {
    if (50 < Dr) throw Dr = 0, _i = null, Error(f(185));
    ir(e, n, r), ((Z & 2) === 0 || e !== _e) && (e === _e && ((Z & 2) === 0 && (Ml |= n), xe === 4 && nn(e, Me)), Je(e, r), n === 1 && Z === 0 && (t.mode & 1) === 0 && (Yn = he() + 500, dl && Gt()));
  }
  function Je(e, t) {
    var n = e.callbackNode;
    nc(e, t);
    var r = Yr(e, e === _e ? Me : 0);
    if (r === 0) n !== null && ru(n), e.callbackNode = null, e.callbackPriority = 0;
    else if (t = r & -r, e.callbackPriority !== t) {
      if (n != null && ru(n), t === 1) e.tag === 0 ? tf(ha.bind(null, e)) : es(ha.bind(null, e)), Jc(function() {
        (Z & 6) === 0 && Gt();
      }), n = null;
      else {
        switch (uu(r)) {
          case 1:
            n = lo;
            break;
          case 4:
            n = lu;
            break;
          case 16:
            n = Hr;
            break;
          case 536870912:
            n = ou;
            break;
          default:
            n = Hr;
        }
        n = Ea(n, ma.bind(null, e));
      }
      e.callbackPriority = t, e.callbackNode = n;
    }
  }
  function ma(e, t) {
    if (Fl = -1, Ul = 0, (Z & 6) !== 0) throw Error(f(327));
    var n = e.callbackNode;
    if (Xn() && e.callbackNode !== n) return null;
    var r = Yr(e, e === _e ? Me : 0);
    if (r === 0) return null;
    if ((r & 30) !== 0 || (r & e.expiredLanes) !== 0 || t) t = Al(e, r);
    else {
      t = r;
      var l = Z;
      Z |= 2;
      var o = ya();
      (_e !== e || Me !== t) && (Ot = null, Yn = he() + 500, kn(e, t));
      do
        try {
          Ef();
          break;
        } catch (u) {
          va(e, u);
        }
      while (!0);
      Qo(), Tl.current = o, Z = l, ke !== null ? t = 0 : (_e = null, Me = 0, t = xe);
    }
    if (t !== 0) {
      if (t === 2 && (l = oo(e), l !== 0 && (r = l, t = ji(e, l))), t === 1) throw n = Ir, kn(e, 0), nn(e, r), Je(e, he()), n;
      if (t === 6) nn(e, r);
      else {
        if (l = e.current.alternate, (r & 30) === 0 && !Sf(l) && (t = Al(e, r), t === 2 && (o = oo(e), o !== 0 && (r = o, t = ji(e, o))), t === 1)) throw n = Ir, kn(e, 0), nn(e, r), Je(e, he()), n;
        switch (e.finishedWork = l, e.finishedLanes = r, t) {
          case 0:
          case 1:
            throw Error(f(345));
          case 2:
            wn(e, Ze, Ot);
            break;
          case 3:
            if (nn(e, r), (r & 130023424) === r && (t = Ci + 500 - he(), 10 < t)) {
              if (Yr(e, 0) !== 0) break;
              if (l = e.suspendedLanes, (l & r) !== r) {
                Qe(), e.pingedLanes |= e.suspendedLanes & l;
                break;
              }
              e.timeoutHandle = Mo(wn.bind(null, e, Ze, Ot), t);
              break;
            }
            wn(e, Ze, Ot);
            break;
          case 4:
            if (nn(e, r), (r & 4194240) === r) break;
            for (t = e.eventTimes, l = -1; 0 < r; ) {
              var i = 31 - pt(r);
              o = 1 << i, i = t[i], i > l && (l = i), r &= ~o;
            }
            if (r = l, r = he() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * wf(r / 1960)) - r, 10 < r) {
              e.timeoutHandle = Mo(wn.bind(null, e, Ze, Ot), r);
              break;
            }
            wn(e, Ze, Ot);
            break;
          case 5:
            wn(e, Ze, Ot);
            break;
          default:
            throw Error(f(329));
        }
      }
    }
    return Je(e, he()), e.callbackNode === n ? ma.bind(null, e) : null;
  }
  function ji(e, t) {
    var n = Or;
    return e.current.memoizedState.isDehydrated && (kn(e, t).flags |= 256), e = Al(e, t), e !== 2 && (t = Ze, Ze = n, t !== null && Pi(t)), e;
  }
  function Pi(e) {
    Ze === null ? Ze = e : Ze.push.apply(Ze, e);
  }
  function Sf(e) {
    for (var t = e; ; ) {
      if (t.flags & 16384) {
        var n = t.updateQueue;
        if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
          var l = n[r], o = l.getSnapshot;
          l = l.value;
          try {
            if (!mt(o(), l)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
      else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function nn(e, t) {
    for (t &= ~Ei, t &= ~Ml, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
      var n = 31 - pt(t), r = 1 << n;
      e[n] = -1, t &= ~r;
    }
  }
  function ha(e) {
    if ((Z & 6) !== 0) throw Error(f(327));
    Xn();
    var t = Yr(e, 0);
    if ((t & 1) === 0) return Je(e, he()), null;
    var n = Al(e, t);
    if (e.tag !== 0 && n === 2) {
      var r = oo(e);
      r !== 0 && (t = r, n = ji(e, r));
    }
    if (n === 1) throw n = Ir, kn(e, 0), nn(e, t), Je(e, he()), n;
    if (n === 6) throw Error(f(345));
    return e.finishedWork = e.current.alternate, e.finishedLanes = t, wn(e, Ze, Ot), Je(e, he()), null;
  }
  function zi(e, t) {
    var n = Z;
    Z |= 1;
    try {
      return e(t);
    } finally {
      Z = n, Z === 0 && (Yn = he() + 500, dl && Gt());
    }
  }
  function gn(e) {
    en !== null && en.tag === 0 && (Z & 6) === 0 && Xn();
    var t = Z;
    Z |= 1;
    var n = at.transition, r = re;
    try {
      if (at.transition = null, re = 1, e) return e();
    } finally {
      re = r, at.transition = n, Z = t, (Z & 6) === 0 && Gt();
    }
  }
  function Ri() {
    nt = Kn.current, ae(Kn);
  }
  function kn(e, t) {
    e.finishedWork = null, e.finishedLanes = 0;
    var n = e.timeoutHandle;
    if (n !== -1 && (e.timeoutHandle = -1, Zc(n)), ke !== null) for (n = ke.return; n !== null; ) {
      var r = n;
      switch (Ao(r), r.tag) {
        case 1:
          r = r.type.childContextTypes, r != null && cl();
          break;
        case 3:
          Hn(), ae(Ye), ae(De), qo();
          break;
        case 5:
          Zo(r);
          break;
        case 4:
          Hn();
          break;
        case 13:
          ae(fe);
          break;
        case 19:
          ae(fe);
          break;
        case 10:
          Wo(r.type._context);
          break;
        case 22:
        case 23:
          Ri();
      }
      n = n.return;
    }
    if (_e = e, ke = e = rn(e.current, null), Me = nt = t, xe = 0, Ir = null, Ei = Ml = yn = 0, Ze = Or = null, mn !== null) {
      for (t = 0; t < mn.length; t++) if (n = mn[t], r = n.interleaved, r !== null) {
        n.interleaved = null;
        var l = r.next, o = n.pending;
        if (o !== null) {
          var i = o.next;
          o.next = l, r.next = i;
        }
        n.pending = r;
      }
      mn = null;
    }
    return e;
  }
  function va(e, t) {
    do {
      var n = ke;
      try {
        if (Qo(), xl.current = _l, El) {
          for (var r = de.memoizedState; r !== null; ) {
            var l = r.queue;
            l !== null && (l.pending = null), r = r.next;
          }
          El = !1;
        }
        if (vn = 0, Ne = Se = de = null, Pr = !1, zr = 0, xi.current = null, n === null || n.return === null) {
          xe = 1, Ir = t, ke = null;
          break;
        }
        e: {
          var o = e, i = n.return, u = n, s = t;
          if (t = Me, u.flags |= 32768, s !== null && typeof s == "object" && typeof s.then == "function") {
            var m = s, k = u, w = k.tag;
            if ((k.mode & 1) === 0 && (w === 0 || w === 11 || w === 15)) {
              var y = k.alternate;
              y ? (k.updateQueue = y.updateQueue, k.memoizedState = y.memoizedState, k.lanes = y.lanes) : (k.updateQueue = null, k.memoizedState = null);
            }
            var _ = Vs(i);
            if (_ !== null) {
              _.flags &= -257, $s(_, i, u, o, t), _.mode & 1 && Bs(o, m, t), t = _, s = m;
              var P = t.updateQueue;
              if (P === null) {
                var z = /* @__PURE__ */ new Set();
                z.add(s), t.updateQueue = z;
              } else P.add(s);
              break e;
            } else {
              if ((t & 1) === 0) {
                Bs(o, m, t), Li();
                break e;
              }
              s = Error(f(426));
            }
          } else if (ce && u.mode & 1) {
            var ve = Vs(i);
            if (ve !== null) {
              (ve.flags & 65536) === 0 && (ve.flags |= 256), $s(ve, i, u, o, t), $o(Qn(s, u));
              break e;
            }
          }
          o = s = Qn(s, u), xe !== 4 && (xe = 2), Or === null ? Or = [o] : Or.push(o), o = i;
          do {
            switch (o.tag) {
              case 3:
                o.flags |= 65536, t &= -t, o.lanes |= t;
                var d = Us(o, s, t);
                fs(o, d);
                break e;
              case 1:
                u = s;
                var a = o.type, p = o.stateNode;
                if ((o.flags & 128) === 0 && (typeof a.getDerivedStateFromError == "function" || p !== null && typeof p.componentDidCatch == "function" && (bt === null || !bt.has(p)))) {
                  o.flags |= 65536, t &= -t, o.lanes |= t;
                  var E = As(o, u, t);
                  fs(o, E);
                  break e;
                }
            }
            o = o.return;
          } while (o !== null);
        }
        ka(n);
      } catch (R) {
        t = R, ke === n && n !== null && (ke = n = n.return);
        continue;
      }
      break;
    } while (!0);
  }
  function ya() {
    var e = Tl.current;
    return Tl.current = _l, e === null ? _l : e;
  }
  function Li() {
    (xe === 0 || xe === 3 || xe === 2) && (xe = 4), _e === null || (yn & 268435455) === 0 && (Ml & 268435455) === 0 || nn(_e, Me);
  }
  function Al(e, t) {
    var n = Z;
    Z |= 2;
    var r = ya();
    (_e !== e || Me !== t) && (Ot = null, kn(e, t));
    do
      try {
        xf();
        break;
      } catch (l) {
        va(e, l);
      }
    while (!0);
    if (Qo(), Z = n, Tl.current = r, ke !== null) throw Error(f(261));
    return _e = null, Me = 0, xe;
  }
  function xf() {
    for (; ke !== null; ) ga(ke);
  }
  function Ef() {
    for (; ke !== null && !Ya(); ) ga(ke);
  }
  function ga(e) {
    var t = xa(e.alternate, e, nt);
    e.memoizedProps = e.pendingProps, t === null ? ka(e) : ke = t, xi.current = null;
  }
  function ka(e) {
    var t = e;
    do {
      var n = t.alternate;
      if (e = t.return, (t.flags & 32768) === 0) {
        if (n = hf(n, t, nt), n !== null) {
          ke = n;
          return;
        }
      } else {
        if (n = vf(n, t), n !== null) {
          n.flags &= 32767, ke = n;
          return;
        }
        if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
        else {
          xe = 6, ke = null;
          return;
        }
      }
      if (t = t.sibling, t !== null) {
        ke = t;
        return;
      }
      ke = t = e;
    } while (t !== null);
    xe === 0 && (xe = 5);
  }
  function wn(e, t, n) {
    var r = re, l = at.transition;
    try {
      at.transition = null, re = 1, Cf(e, t, n, r);
    } finally {
      at.transition = l, re = r;
    }
    return null;
  }
  function Cf(e, t, n, r) {
    do
      Xn();
    while (en !== null);
    if ((Z & 6) !== 0) throw Error(f(327));
    n = e.finishedWork;
    var l = e.finishedLanes;
    if (n === null) return null;
    if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(f(177));
    e.callbackNode = null, e.callbackPriority = 0;
    var o = n.lanes | n.childLanes;
    if (rc(e, o), e === _e && (ke = _e = null, Me = 0), (n.subtreeFlags & 2064) === 0 && (n.flags & 2064) === 0 || Ol || (Ol = !0, Ea(Hr, function() {
      return Xn(), null;
    })), o = (n.flags & 15990) !== 0, (n.subtreeFlags & 15990) !== 0 || o) {
      o = at.transition, at.transition = null;
      var i = re;
      re = 1;
      var u = Z;
      Z |= 4, xi.current = null, gf(e, n), aa(n, e), Hc(Lo), Zr = !!Ro, Lo = Ro = null, e.current = n, kf(n), Xa(), Z = u, re = i, at.transition = o;
    } else e.current = n;
    if (Ol && (Ol = !1, en = e, Dl = l), o = e.pendingLanes, o === 0 && (bt = null), Ja(n.stateNode), Je(e, he()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) l = t[n], r(l.value, { componentStack: l.stack, digest: l.digest });
    if (Il) throw Il = !1, e = Ni, Ni = null, e;
    return (Dl & 1) !== 0 && e.tag !== 0 && Xn(), o = e.pendingLanes, (o & 1) !== 0 ? e === _i ? Dr++ : (Dr = 0, _i = e) : Dr = 0, Gt(), null;
  }
  function Xn() {
    if (en !== null) {
      var e = uu(Dl), t = at.transition, n = re;
      try {
        if (at.transition = null, re = 16 > e ? 16 : e, en === null) var r = !1;
        else {
          if (e = en, en = null, Dl = 0, (Z & 6) !== 0) throw Error(f(331));
          var l = Z;
          for (Z |= 4, j = e.current; j !== null; ) {
            var o = j, i = o.child;
            if ((j.flags & 16) !== 0) {
              var u = o.deletions;
              if (u !== null) {
                for (var s = 0; s < u.length; s++) {
                  var m = u[s];
                  for (j = m; j !== null; ) {
                    var k = j;
                    switch (k.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Mr(8, k, o);
                    }
                    var w = k.child;
                    if (w !== null) w.return = k, j = w;
                    else for (; j !== null; ) {
                      k = j;
                      var y = k.sibling, _ = k.return;
                      if (la(k), k === m) {
                        j = null;
                        break;
                      }
                      if (y !== null) {
                        y.return = _, j = y;
                        break;
                      }
                      j = _;
                    }
                  }
                }
                var P = o.alternate;
                if (P !== null) {
                  var z = P.child;
                  if (z !== null) {
                    P.child = null;
                    do {
                      var ve = z.sibling;
                      z.sibling = null, z = ve;
                    } while (z !== null);
                  }
                }
                j = o;
              }
            }
            if ((o.subtreeFlags & 2064) !== 0 && i !== null) i.return = o, j = i;
            else e: for (; j !== null; ) {
              if (o = j, (o.flags & 2048) !== 0) switch (o.tag) {
                case 0:
                case 11:
                case 15:
                  Mr(9, o, o.return);
              }
              var d = o.sibling;
              if (d !== null) {
                d.return = o.return, j = d;
                break e;
              }
              j = o.return;
            }
          }
          var a = e.current;
          for (j = a; j !== null; ) {
            i = j;
            var p = i.child;
            if ((i.subtreeFlags & 2064) !== 0 && p !== null) p.return = i, j = p;
            else e: for (i = a; j !== null; ) {
              if (u = j, (u.flags & 2048) !== 0) try {
                switch (u.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Ll(9, u);
                }
              } catch (R) {
                me(u, u.return, R);
              }
              if (u === i) {
                j = null;
                break e;
              }
              var E = u.sibling;
              if (E !== null) {
                E.return = u.return, j = E;
                break e;
              }
              j = u.return;
            }
          }
          if (Z = l, Gt(), xt && typeof xt.onPostCommitFiberRoot == "function") try {
            xt.onPostCommitFiberRoot(Qr, e);
          } catch {
          }
          r = !0;
        }
        return r;
      } finally {
        re = n, at.transition = t;
      }
    }
    return !1;
  }
  function wa(e, t, n) {
    t = Qn(n, t), t = Us(e, t, 1), e = Jt(e, t, 1), t = Qe(), e !== null && (ir(e, 1, t), Je(e, t));
  }
  function me(e, t, n) {
    if (e.tag === 3) wa(e, e, n);
    else for (; t !== null; ) {
      if (t.tag === 3) {
        wa(t, e, n);
        break;
      } else if (t.tag === 1) {
        var r = t.stateNode;
        if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (bt === null || !bt.has(r))) {
          e = Qn(n, e), e = As(t, e, 1), t = Jt(t, e, 1), e = Qe(), t !== null && (ir(t, 1, e), Je(t, e));
          break;
        }
      }
      t = t.return;
    }
  }
  function Nf(e, t, n) {
    var r = e.pingCache;
    r !== null && r.delete(t), t = Qe(), e.pingedLanes |= e.suspendedLanes & n, _e === e && (Me & n) === n && (xe === 4 || xe === 3 && (Me & 130023424) === Me && 500 > he() - Ci ? kn(e, 0) : Ei |= n), Je(e, t);
  }
  function Sa(e, t) {
    t === 0 && ((e.mode & 1) === 0 ? t = 1 : (t = Kr, Kr <<= 1, (Kr & 130023424) === 0 && (Kr = 4194304)));
    var n = Qe();
    e = Tt(e, t), e !== null && (ir(e, t, n), Je(e, n));
  }
  function _f(e) {
    var t = e.memoizedState, n = 0;
    t !== null && (n = t.retryLane), Sa(e, n);
  }
  function jf(e, t) {
    var n = 0;
    switch (e.tag) {
      case 13:
        var r = e.stateNode, l = e.memoizedState;
        l !== null && (n = l.retryLane);
        break;
      case 19:
        r = e.stateNode;
        break;
      default:
        throw Error(f(314));
    }
    r !== null && r.delete(t), Sa(e, n);
  }
  var xa;
  xa = function(e, t, n) {
    if (e !== null) if (e.memoizedProps !== t.pendingProps || Ye.current) Ge = !0;
    else {
      if ((e.lanes & n) === 0 && (t.flags & 128) === 0) return Ge = !1, mf(e, t, n);
      Ge = (e.flags & 131072) !== 0;
    }
    else Ge = !1, ce && (t.flags & 1048576) !== 0 && ts(t, ml, t.index);
    switch (t.lanes = 0, t.tag) {
      case 2:
        var r = t.type;
        zl(e, t), e = t.pendingProps;
        var l = Dn(t, De.current);
        $n(t, n), l = ti(null, t, r, e, l, n);
        var o = ni();
        return t.flags |= 1, typeof l == "object" && l !== null && typeof l.render == "function" && l.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, Xe(r) ? (o = !0, fl(t)) : o = !1, t.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, Xo(t), l.updater = jl, t.stateNode = l, l._reactInternals = t, si(t, r, e, n), t = di(null, t, r, !0, o, n)) : (t.tag = 0, ce && o && Uo(t), He(null, t, l, n), t = t.child), t;
      case 16:
        r = t.elementType;
        e: {
          switch (zl(e, t), e = t.pendingProps, l = r._init, r = l(r._payload), t.type = r, l = t.tag = zf(r), e = vt(r, e), l) {
            case 0:
              t = fi(null, t, r, e, n);
              break e;
            case 1:
              t = Xs(null, t, r, e, n);
              break e;
            case 11:
              t = Hs(null, t, r, e, n);
              break e;
            case 14:
              t = Qs(null, t, r, vt(r.type, e), n);
              break e;
          }
          throw Error(f(
            306,
            r,
            ""
          ));
        }
        return t;
      case 0:
        return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : vt(r, l), fi(e, t, r, l, n);
      case 1:
        return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : vt(r, l), Xs(e, t, r, l, n);
      case 3:
        e: {
          if (Gs(t), e === null) throw Error(f(387));
          r = t.pendingProps, o = t.memoizedState, l = o.element, cs(e, t), wl(t, r, null, n);
          var i = t.memoizedState;
          if (r = i.element, o.isDehydrated) if (o = { element: r, isDehydrated: !1, cache: i.cache, pendingSuspenseBoundaries: i.pendingSuspenseBoundaries, transitions: i.transitions }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
            l = Qn(Error(f(423)), t), t = Zs(e, t, r, n, l);
            break e;
          } else if (r !== l) {
            l = Qn(Error(f(424)), t), t = Zs(e, t, r, n, l);
            break e;
          } else for (tt = Kt(t.stateNode.containerInfo.firstChild), et = t, ce = !0, ht = null, n = ss(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
          else {
            if (An(), r === l) {
              t = It(e, t, n);
              break e;
            }
            He(e, t, r, n);
          }
          t = t.child;
        }
        return t;
      case 5:
        return ps(t), e === null && Vo(t), r = t.type, l = t.pendingProps, o = e !== null ? e.memoizedProps : null, i = l.children, To(r, l) ? i = null : o !== null && To(r, o) && (t.flags |= 32), Ys(e, t), He(e, t, i, n), t.child;
      case 6:
        return e === null && Vo(t), null;
      case 13:
        return Js(e, t, n);
      case 4:
        return Go(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Bn(t, null, r, n) : He(e, t, r, n), t.child;
      case 11:
        return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : vt(r, l), Hs(e, t, r, l, n);
      case 7:
        return He(e, t, t.pendingProps, n), t.child;
      case 8:
        return He(e, t, t.pendingProps.children, n), t.child;
      case 12:
        return He(e, t, t.pendingProps.children, n), t.child;
      case 10:
        e: {
          if (r = t.type._context, l = t.pendingProps, o = t.memoizedProps, i = l.value, ue(yl, r._currentValue), r._currentValue = i, o !== null) if (mt(o.value, i)) {
            if (o.children === l.children && !Ye.current) {
              t = It(e, t, n);
              break e;
            }
          } else for (o = t.child, o !== null && (o.return = t); o !== null; ) {
            var u = o.dependencies;
            if (u !== null) {
              i = o.child;
              for (var s = u.firstContext; s !== null; ) {
                if (s.context === r) {
                  if (o.tag === 1) {
                    s = Mt(-1, n & -n), s.tag = 2;
                    var m = o.updateQueue;
                    if (m !== null) {
                      m = m.shared;
                      var k = m.pending;
                      k === null ? s.next = s : (s.next = k.next, k.next = s), m.pending = s;
                    }
                  }
                  o.lanes |= n, s = o.alternate, s !== null && (s.lanes |= n), Ko(
                    o.return,
                    n,
                    t
                  ), u.lanes |= n;
                  break;
                }
                s = s.next;
              }
            } else if (o.tag === 10) i = o.type === t.type ? null : o.child;
            else if (o.tag === 18) {
              if (i = o.return, i === null) throw Error(f(341));
              i.lanes |= n, u = i.alternate, u !== null && (u.lanes |= n), Ko(i, n, t), i = o.sibling;
            } else i = o.child;
            if (i !== null) i.return = o;
            else for (i = o; i !== null; ) {
              if (i === t) {
                i = null;
                break;
              }
              if (o = i.sibling, o !== null) {
                o.return = i.return, i = o;
                break;
              }
              i = i.return;
            }
            o = i;
          }
          He(e, t, l.children, n), t = t.child;
        }
        return t;
      case 9:
        return l = t.type, r = t.pendingProps.children, $n(t, n), l = ut(l), r = r(l), t.flags |= 1, He(e, t, r, n), t.child;
      case 14:
        return r = t.type, l = vt(r, t.pendingProps), l = vt(r.type, l), Qs(e, t, r, l, n);
      case 15:
        return Ws(e, t, t.type, t.pendingProps, n);
      case 17:
        return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : vt(r, l), zl(e, t), t.tag = 1, Xe(r) ? (e = !0, fl(t)) : e = !1, $n(t, n), Ds(t, r, l), si(t, r, l, n), di(null, t, r, !0, e, n);
      case 19:
        return bs(e, t, n);
      case 22:
        return Ks(e, t, n);
    }
    throw Error(f(156, t.tag));
  };
  function Ea(e, t) {
    return nu(e, t);
  }
  function Pf(e, t, n, r) {
    this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ct(e, t, n, r) {
    return new Pf(e, t, n, r);
  }
  function Ti(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function zf(e) {
    if (typeof e == "function") return Ti(e) ? 1 : 0;
    if (e != null) {
      if (e = e.$$typeof, e === Ve) return 11;
      if (e === $e) return 14;
    }
    return 2;
  }
  function rn(e, t) {
    var n = e.alternate;
    return n === null ? (n = ct(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
  }
  function Bl(e, t, n, r, l, o) {
    var i = 2;
    if (r = e, typeof e == "function") Ti(e) && (i = 1);
    else if (typeof e == "string") i = 5;
    else e: switch (e) {
      case ze:
        return Sn(n.children, l, o, t);
      case Ie:
        i = 8, l |= 8;
        break;
      case wt:
        return e = ct(12, n, t, l | 2), e.elementType = wt, e.lanes = o, e;
      case Oe:
        return e = ct(13, n, t, l), e.elementType = Oe, e.lanes = o, e;
      case Re:
        return e = ct(19, n, t, l), e.elementType = Re, e.lanes = o, e;
      case ne:
        return Vl(n, l, o, t);
      default:
        if (typeof e == "object" && e !== null) switch (e.$$typeof) {
          case lt:
            i = 10;
            break e;
          case Ke:
            i = 9;
            break e;
          case Ve:
            i = 11;
            break e;
          case $e:
            i = 14;
            break e;
          case Le:
            i = 16, r = null;
            break e;
        }
        throw Error(f(130, e == null ? e : typeof e, ""));
    }
    return t = ct(i, n, t, l), t.elementType = e, t.type = r, t.lanes = o, t;
  }
  function Sn(e, t, n, r) {
    return e = ct(7, e, r, t), e.lanes = n, e;
  }
  function Vl(e, t, n, r) {
    return e = ct(22, e, r, t), e.elementType = ne, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
  }
  function Mi(e, t, n) {
    return e = ct(6, e, null, t), e.lanes = n, e;
  }
  function Ii(e, t, n) {
    return t = ct(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
  }
  function Rf(e, t, n, r, l) {
    this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = io(0), this.expirationTimes = io(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = io(0), this.identifierPrefix = r, this.onRecoverableError = l, this.mutableSourceEagerHydrationData = null;
  }
  function Oi(e, t, n, r, l, o, i, u, s) {
    return e = new Rf(e, t, n, u, s), t === 1 ? (t = 1, o === !0 && (t |= 8)) : t = 0, o = ct(3, null, null, t), e.current = o, o.stateNode = e, o.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Xo(o), e;
  }
  function Lf(e, t, n) {
    var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: Pe, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
  }
  function Ca(e) {
    if (!e) return Xt;
    e = e._reactInternals;
    e: {
      if (an(e) !== e || e.tag !== 1) throw Error(f(170));
      var t = e;
      do {
        switch (t.tag) {
          case 3:
            t = t.stateNode.context;
            break e;
          case 1:
            if (Xe(t.type)) {
              t = t.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        t = t.return;
      } while (t !== null);
      throw Error(f(171));
    }
    if (e.tag === 1) {
      var n = e.type;
      if (Xe(n)) return qu(e, n, t);
    }
    return t;
  }
  function Na(e, t, n, r, l, o, i, u, s) {
    return e = Oi(n, r, !0, e, l, o, i, u, s), e.context = Ca(null), n = e.current, r = Qe(), l = tn(n), o = Mt(r, l), o.callback = t ?? null, Jt(n, o, l), e.current.lanes = l, ir(e, l, r), Je(e, r), e;
  }
  function $l(e, t, n, r) {
    var l = t.current, o = Qe(), i = tn(l);
    return n = Ca(n), t.context === null ? t.context = n : t.pendingContext = n, t = Mt(o, i), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = Jt(l, t, i), e !== null && (kt(e, l, i, o), kl(e, l, i)), i;
  }
  function Hl(e) {
    if (e = e.current, !e.child) return null;
    switch (e.child.tag) {
      case 5:
        return e.child.stateNode;
      default:
        return e.child.stateNode;
    }
  }
  function _a(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var n = e.retryLane;
      e.retryLane = n !== 0 && n < t ? n : t;
    }
  }
  function Di(e, t) {
    _a(e, t), (e = e.alternate) && _a(e, t);
  }
  function Tf() {
    return null;
  }
  var ja = typeof reportError == "function" ? reportError : function(e) {
    console.error(e);
  };
  function Fi(e) {
    this._internalRoot = e;
  }
  Ql.prototype.render = Fi.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error(f(409));
    $l(e, t, null, null);
  }, Ql.prototype.unmount = Fi.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      gn(function() {
        $l(null, e, null, null);
      }), t[Pt] = null;
    }
  };
  function Ql(e) {
    this._internalRoot = e;
  }
  Ql.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var t = cu();
      e = { blockedOn: null, target: e, priority: t };
      for (var n = 0; n < Ht.length && t !== 0 && t < Ht[n].priority; n++) ;
      Ht.splice(n, 0, e), n === 0 && pu(e);
    }
  };
  function Ui(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function Wl(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
  }
  function Pa() {
  }
  function Mf(e, t, n, r, l) {
    if (l) {
      if (typeof r == "function") {
        var o = r;
        r = function() {
          var m = Hl(i);
          o.call(m);
        };
      }
      var i = Na(t, r, e, 0, null, !1, !1, "", Pa);
      return e._reactRootContainer = i, e[Pt] = i.current, wr(e.nodeType === 8 ? e.parentNode : e), gn(), i;
    }
    for (; l = e.lastChild; ) e.removeChild(l);
    if (typeof r == "function") {
      var u = r;
      r = function() {
        var m = Hl(s);
        u.call(m);
      };
    }
    var s = Oi(e, 0, !1, null, null, !1, !1, "", Pa);
    return e._reactRootContainer = s, e[Pt] = s.current, wr(e.nodeType === 8 ? e.parentNode : e), gn(function() {
      $l(t, s, n, r);
    }), s;
  }
  function Kl(e, t, n, r, l) {
    var o = n._reactRootContainer;
    if (o) {
      var i = o;
      if (typeof l == "function") {
        var u = l;
        l = function() {
          var s = Hl(i);
          u.call(s);
        };
      }
      $l(t, i, e, l);
    } else i = Mf(n, t, e, l, r);
    return Hl(i);
  }
  su = function(e) {
    switch (e.tag) {
      case 3:
        var t = e.stateNode;
        if (t.current.memoizedState.isDehydrated) {
          var n = or(t.pendingLanes);
          n !== 0 && (uo(t, n | 1), Je(t, he()), (Z & 6) === 0 && (Yn = he() + 500, Gt()));
        }
        break;
      case 13:
        gn(function() {
          var r = Tt(e, 1);
          if (r !== null) {
            var l = Qe();
            kt(r, e, 1, l);
          }
        }), Di(e, 1);
    }
  }, so = function(e) {
    if (e.tag === 13) {
      var t = Tt(e, 134217728);
      if (t !== null) {
        var n = Qe();
        kt(t, e, 134217728, n);
      }
      Di(e, 134217728);
    }
  }, au = function(e) {
    if (e.tag === 13) {
      var t = tn(e), n = Tt(e, t);
      if (n !== null) {
        var r = Qe();
        kt(n, e, t, r);
      }
      Di(e, t);
    }
  }, cu = function() {
    return re;
  }, fu = function(e, t) {
    var n = re;
    try {
      return re = e, t();
    } finally {
      re = n;
    }
  }, eo = function(e, t, n) {
    switch (t) {
      case "input":
        if (Jn(e, n), t = n.name, n.type === "radio" && t != null) {
          for (n = e; n.parentNode; ) n = n.parentNode;
          for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
            var r = n[t];
            if (r !== e && r.form === e.form) {
              var l = al(r);
              if (!l) throw Error(f(90));
              Ft(r), Jn(r, l);
            }
          }
        }
        break;
      case "textarea":
        Br(e, n);
        break;
      case "select":
        t = n.value, t != null && jt(e, !!n.multiple, t, !1);
    }
  }, Gi = zi, Zi = gn;
  var If = { usingClientEntryPoint: !1, Events: [Er, In, al, Yi, Xi, zi] }, Fr = { findFiberByHostInstance: cn, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Of = { bundleType: Fr.bundleType, version: Fr.version, rendererPackageName: Fr.rendererPackageName, rendererConfig: Fr.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ye.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
    return e = eu(e), e === null ? null : e.stateNode;
  }, findFiberByHostInstance: Fr.findFiberByHostInstance || Tf, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Yl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Yl.isDisabled && Yl.supportsFiber) try {
      Qr = Yl.inject(Of), xt = Yl;
    } catch {
    }
  }
  return qe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = If, qe.createPortal = function(e, t) {
    var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Ui(t)) throw Error(f(200));
    return Lf(e, t, null, n);
  }, qe.createRoot = function(e, t) {
    if (!Ui(e)) throw Error(f(299));
    var n = !1, r = "", l = ja;
    return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (l = t.onRecoverableError)), t = Oi(e, 1, !1, null, null, n, !1, r, l), e[Pt] = t.current, wr(e.nodeType === 8 ? e.parentNode : e), new Fi(t);
  }, qe.findDOMNode = function(e) {
    if (e == null) return null;
    if (e.nodeType === 1) return e;
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function" ? Error(f(188)) : (e = Object.keys(e).join(","), Error(f(268, e)));
    return e = eu(t), e = e === null ? null : e.stateNode, e;
  }, qe.flushSync = function(e) {
    return gn(e);
  }, qe.hydrate = function(e, t, n) {
    if (!Wl(t)) throw Error(f(200));
    return Kl(null, e, t, !0, n);
  }, qe.hydrateRoot = function(e, t, n) {
    if (!Ui(e)) throw Error(f(405));
    var r = n != null && n.hydratedSources || null, l = !1, o = "", i = ja;
    if (n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onRecoverableError !== void 0 && (i = n.onRecoverableError)), t = Na(t, null, e, 1, n ?? null, l, !1, o, i), e[Pt] = t.current, wr(e), r) for (e = 0; e < r.length; e++) n = r[e], l = n._getVersion, l = l(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, l] : t.mutableSourceEagerHydrationData.push(
      n,
      l
    );
    return new Ql(t);
  }, qe.render = function(e, t, n) {
    if (!Wl(t)) throw Error(f(200));
    return Kl(null, e, t, !1, n);
  }, qe.unmountComponentAtNode = function(e) {
    if (!Wl(e)) throw Error(f(40));
    return e._reactRootContainer ? (gn(function() {
      Kl(null, null, e, !1, function() {
        e._reactRootContainer = null, e[Pt] = null;
      });
    }), !0) : !1;
  }, qe.unstable_batchedUpdates = zi, qe.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
    if (!Wl(n)) throw Error(f(200));
    if (e == null || e._reactInternals === void 0) throw Error(f(38));
    return Kl(e, t, n, !1, r);
  }, qe.version = "18.3.1-next-f1338f8080-20240426", qe;
}
var Da;
function Hf() {
  if (Da) return Vi.exports;
  Da = 1;
  function S() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(S);
      } catch (C) {
        console.error(C);
      }
  }
  return S(), Vi.exports = $f(), Vi.exports;
}
var Fa;
function Qf() {
  if (Fa) return Xl;
  Fa = 1;
  var S = Hf();
  return Xl.createRoot = S.createRoot, Xl.hydrateRoot = S.hydrateRoot, Xl;
}
var Wf = Qf(), H = Qi();
const Ba = "metraink-private-basket-v1";
function Kf() {
  try {
    const S = JSON.parse(sessionStorage.getItem(Ba) ?? "[]");
    if (!Array.isArray(S) || S.length > 100) return [];
    const C = S.filter((f) => f && /^[A-Za-z0-9_-]{24,80}$/.test(f.token) && typeof f.label == "string" && f.label.length <= 100 && Number.isSafeInteger(f.metres) && f.metres > 0 && ["shipping", "pickup"].includes(f.delivery));
    return [...new Map(C.map((f) => [f.token, f])).values()];
  } catch {
    return [];
  }
}
function Gn(S) {
  sessionStorage.setItem(Ba, JSON.stringify(S)), typeof window < "u" && typeof window.dispatchEvent == "function" && window.dispatchEvent(new Event("metraink:basket-change"));
}
function Yf(S) {
  if (!S || typeof S != "object" || Array.isArray(S)) throw new Error("Respuesta de bono no válida.");
  const C = S;
  if (!["quote", "reserved", "released"].includes(String(C.status)) || typeof C.revision != "string" || !/^[a-f0-9]{64}$/.test(C.revision) || typeof C.metres != "number" || !Number.isSafeInteger(C.metres) || C.metres <= 0 || ![0, 1].includes(C.shipments) || C.printingCents !== 0 || typeof C.professionalCents != "number" || !Number.isSafeInteger(C.professionalCents) || C.professionalCents < 0 || !["shipping", "pickup"].includes(String(C.delivery)) || C.orderCreated !== !1 || C.paymentRequiredMayRemain !== !0) throw new Error("No se pudo comprobar la solicitud de bono.");
  return {
    status: C.status,
    revision: C.revision,
    metres: C.metres,
    shipments: C.shipments,
    printingCents: 0,
    professionalCents: C.professionalCents,
    delivery: C.delivery,
    orderCreated: !1,
    paymentRequiredMayRemain: !0
  };
}
async function Xf(S, C, f, Y = fetch) {
  if (!/^\/(?:[a-zA-Z0-9_-]+\/)*$/.test(S)) throw new Error("Ruta de tienda no válida.");
  const le = await Y(`${S}apps/metraink/api/manual-bonus/${C}`, {
    method: "POST",
    credentials: "same-origin",
    cache: "no-store",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      token: f.token,
      csrf: f.csrf,
      ...C === "reserve" ? { revision: f.revision, montageApproved: f.montageApproved === !0 } : {}
    })
  });
  if (!le.ok) throw new Error("No se ha podido confirmar la solicitud. Comprueba el bono antes de intentar pagar este montaje.");
  return Yf(await le.json());
}
function Gf({ root: S, token: C, csrf: f, busy: Y, onBusy: le, onResolved: pe }) {
  const [X, ee] = H.useState(null), [A, oe] = H.useState(!1), [Q, V] = H.useState(""), b = H.useRef(!1);
  async function Ee(we) {
    if (!(Y || b.current || we === "reserve" && (!X || !A))) {
      b.current = !0, le(!0), V("");
      try {
        const W = await Xf(S, we, { token: C, csrf: f, revision: X == null ? void 0 : X.revision, montageApproved: A });
        if (W.status !== "quote") {
          pe(W);
          return;
        }
        ee(W), oe(!1);
      } catch (W) {
        V(W instanceof Error ? W.message : "No se pudo comprobar la solicitud."), ee(null), oe(!1);
      } finally {
        b.current = !1, le(!1);
      }
    }
  }
  return /* @__PURE__ */ h.jsxs("div", { className: "mk-private-bonus-request", children: [
    /* @__PURE__ */ h.jsx("button", { type: "button", className: "secondary", disabled: Y, onClick: () => void Ee("quote"), children: "Usar mi bono · comprobar metros" }),
    X && /* @__PURE__ */ h.jsxs("div", { "aria-live": "polite", children: [
      /* @__PURE__ */ h.jsxs("p", { children: [
        /* @__PURE__ */ h.jsxs("strong", { children: [
          X.metres,
          " m cubiertos por tu bono."
        ] }),
        " No vuelves a pagar esa impresión."
      ] }),
      /* @__PURE__ */ h.jsx("p", { children: X.delivery === "pickup" ? "Recogida: no consume un envío del bono." : X.shipments ? "Se reservará un envío incluido, pendiente de comprobar el destino." : "No quedan envíos incluidos: el transporte se confirmará aparte." }),
      X.professionalCents > 0 && /* @__PURE__ */ h.jsxs("p", { children: [
        "Control profesional: ",
        (X.professionalCents / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" }),
        " + IVA, pendiente de cobro."
      ] }),
      /* @__PURE__ */ h.jsx("p", { children: "Metraink revisará la solicitud y confirmará los servicios y la entrega. Esto reserva metros; todavía no crea un pedido ni confirma producción." }),
      /* @__PURE__ */ h.jsxs("label", { className: "mk-private-check", children: [
        /* @__PURE__ */ h.jsx(
          "input",
          {
            type: "checkbox",
            checked: A,
            disabled: Y,
            onChange: (we) => oe(we.target.checked)
          }
        ),
        " Confirmo este montaje y solicito reservar sus metros del bono."
      ] }),
      /* @__PURE__ */ h.jsx("button", { type: "button", className: "primary", disabled: Y || !A, onClick: () => void Ee("reserve"), children: "Solicitar trabajo con mi bono" })
    ] }),
    Q && /* @__PURE__ */ h.jsx("p", { role: "alert", className: "mk-private-error", children: Q })
  ] });
}
const Zf = (S) => S.filter((C) => ["pending", "approved", "checkout", "review"].includes(C.status));
function Jf(S) {
  const C = S == null ? void 0 : S.requests;
  if (!Array.isArray(C) || C.length > 50) throw new Error("No se pudieron comprobar las solicitudes.");
  return C.map((f) => {
    if (!f || !/^[A-Za-z0-9_-]{24,80}$/.test(f.token) || typeof f.label != "string" || f.label.length > 100 || !Number.isSafeInteger(f.metres) || f.metres < 1 || !["shipping", "pickup"].includes(f.delivery) || !["pending", "approved", "checkout", "released", "consumed", "restored", "review"].includes(f.status)) throw new Error("Solicitud no válida.");
    return { token: f.token, label: f.label, metres: f.metres, delivery: f.delivery, status: f.status, manualBonus: !0 };
  });
}
function qf({ root: S, refresh: C, busy: f, onSelect: Y, onResume: le }) {
  const [pe, X] = H.useState([]), [ee, A] = H.useState("");
  H.useEffect(() => {
    const Q = new AbortController();
    return X([]), A(""), fetch(`${S}apps/metraink/api/manual-bonus/requests`, { credentials: "same-origin", cache: "no-store", signal: Q.signal }).then(async (V) => {
      if (!V.ok) throw new Error("No se pudieron consultar tus solicitudes.");
      return Jf(await V.json());
    }).then(X).catch((V) => {
      Q.signal.aborted || A(V.message);
    }), () => Q.abort();
  }, [S, C]);
  const oe = Zf(pe);
  return !oe.length && !ee ? null : /* @__PURE__ */ h.jsxs("section", { className: "mk-private-pending", "aria-label": "Solicitudes de bono pendientes", children: [
    /* @__PURE__ */ h.jsx("h3", { children: "Solicitudes de bono pendientes" }),
    /* @__PURE__ */ h.jsx("p", { children: "La revisión del montaje no inicia la producción. Después debes confirmar entrega y extras." }),
    ee && /* @__PURE__ */ h.jsx("p", { role: "alert", children: ee }),
    oe.map((Q) => /* @__PURE__ */ h.jsxs("article", { children: [
      /* @__PURE__ */ h.jsxs("strong", { children: [
        Q.label,
        " · ",
        Q.metres,
        " m"
      ] }),
      /* @__PURE__ */ h.jsx("p", { children: {
        pending: "Pendiente de revisión por Metraink",
        approved: "Montaje aprobado: falta confirmar el pedido",
        checkout: "Checkout ya preparado con los datos y condiciones que confirmaste",
        released: "Cancelada · metros liberados",
        consumed: "Metros aplicados al pedido",
        restored: "Metros restituidos",
        review: "Hay una devolución o cancelación en revisión. Contacta con Metraink antes de continuar."
      }[Q.status] }),
      Q.status === "approved" && /* @__PURE__ */ h.jsx(
        "button",
        {
          type: "button",
          className: "secondary",
          disabled: f,
          onClick: () => Y(Q),
          children: "Confirmar entrega y extras"
        }
      ),
      Q.status === "checkout" && /* @__PURE__ */ h.jsx(
        "button",
        {
          type: "button",
          className: "secondary",
          disabled: f,
          onClick: () => le(Q.token),
          children: "Retomar mi checkout confirmado"
        }
      )
    ] }, Q.token))
  ] });
}
function bf(S) {
  return S.some((C) => C.requestedPayment === "balance" && !C.manualBonus);
}
const Ua = () => ({ firstName: "", lastName: "", address1: "", address2: "", city: "", zip: "", countryCode: "ES" }), Zn = (S) => S === void 0 ? "—" : new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(S / 100), Dt = () => {
  var S, C;
  return ((C = (S = window.Shopify) == null ? void 0 : S.routes) == null ? void 0 : C.root) ?? "/";
};
function Aa({ value: S, onChange: C, label: f }) {
  return /* @__PURE__ */ h.jsxs("fieldset", { className: "mk-private-address", children: [
    /* @__PURE__ */ h.jsx("legend", { children: f }),
    [
      ["firstName", "Nombre", !1],
      ["lastName", "Apellidos / razón social", !0],
      ["address1", "Dirección", !0],
      ["address2", "Piso, puerta…", !1],
      ["city", "Población", !0],
      ["zip", "Código postal", !0],
      ["countryCode", "País (ES, PT…)", !0]
    ].map(([Y, le, pe]) => /* @__PURE__ */ h.jsxs("label", { children: [
      le,
      /* @__PURE__ */ h.jsx(
        "input",
        {
          value: S[Y],
          required: pe,
          maxLength: Y === "countryCode" ? 2 : 150,
          autoComplete: Y === "address1" ? "address-line1" : void 0,
          onChange: (X) => C({ ...S, [Y]: Y === "countryCode" ? X.target.value.toUpperCase() : X.target.value })
        }
      )
    ] }, Y))
  ] });
}
function ed({ onBack: S, initialProfile: C }) {
  var tr, Cn;
  const [f, Y] = H.useState(Kf), le = bf(f), [pe, X] = H.useState((C == null ? void 0 : C.email) ?? ""), [ee, A] = H.useState((C == null ? void 0 : C.legalName) ?? ""), [oe, Q] = H.useState(""), [V, b] = H.useState((C == null ? void 0 : C.address) ?? Ua()), [Ee, we] = H.useState(Ua), [W, te] = H.useState(""), [ft, rt] = H.useState(null), [We, ye] = H.useState(""), [Be, Pe] = H.useState(!0), [ze, Ie] = H.useState(!1), [wt, lt] = H.useState(0), [Ke, Ve] = H.useState("loading"), Oe = H.useRef(!1), [Re, $e] = H.useState("online"), [Le, ne] = H.useState(""), [N, L] = H.useState(!1), [g, c] = H.useState(null), [v, F] = H.useState([]), [T, U] = H.useState(!1), [$, K] = H.useState(""), [q, ie] = H.useState(!1), [ge, xn] = H.useState(""), [Ft, on] = H.useState(""), En = H.useRef(null), Ut = H.useRef(null);
  H.useEffect(() => {
    const x = requestAnimationFrame(() => {
      var M, G;
      (M = Ut.current) == null || M.scrollIntoView({ behavior: "auto", block: "start" }), (G = Ut.current) == null || G.focus({ preventScroll: !0 });
    });
    return () => cancelAnimationFrame(x);
  }, []);
  function Ar(x) {
    if (T) return;
    if (f.length && !(f.length === 1 && f[0].token === x.token)) {
      K("Finaliza o vacía la cesta actual antes de confirmar esta solicitud con bono.");
      return;
    }
    const M = [{ token: x.token, label: x.label, metres: x.metres, delivery: x.delivery, manualBonus: !0 }];
    Gn(M), Y(M), ne(""), c(null), L(!1), K("");
  }
  async function Jn(x) {
    if (!(T || !ge)) {
      U(!0), K("");
      try {
        const M = await fetch(`${Dt()}apps/metraink/api/manual-bonus/resume`, {
          method: "POST",
          credentials: "same-origin",
          cache: "no-store",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: x, csrf: ge, confirmed: !0 })
        }), G = await M.json();
        if (!M.ok || G.ok !== !0) throw new Error("No se pudo retomar el checkout. No prepares un duplicado; contacta con Metraink.");
        if (G.completed) {
          on("Esta solicitud ya tiene un pedido registrado. Puedes consultarlo en tus pedidos.");
          return;
        }
        const Ce = new URL(G.invoiceUrl);
        if (Ce.protocol !== "https:" || Ce.username || Ce.password) throw new Error("Enlace de pago no válido.");
        window.location.assign(Ce.href);
      } catch (M) {
        K(M instanceof Error ? M.message : "No se pudo retomar la compra.");
      } finally {
        U(!1);
      }
    }
  }
  const qn = ge && /* @__PURE__ */ h.jsx(qf, { root: Dt(), refresh: Ft, busy: T, onSelect: Ar, onResume: Jn }), dt = ((tr = f[0]) == null ? void 0 : tr.delivery) ?? "shipping";
  function un(x) {
    if (T || f.some((G) => G.manualBonus) || g != null && g.reserved) return;
    const M = f.map((G) => ({ ...G, delivery: x }));
    Gn(M), Y(M), ne(""), F([]), c(null), L(!1);
  }
  const jt = {
    tokens: f.map((x) => x.token),
    email: pe,
    billing: { legalName: ee, taxId: oe, country: V.countryCode },
    billingAddress: V,
    shippingAddress: Be ? V : Ee,
    delivery: dt,
    payment: Re,
    handle: Le
  }, At = JSON.stringify(jt), bn = H.useRef(At);
  bn.current = At, H.useEffect(() => {
    c(null), L(!1), K("");
  }, [At]), H.useEffect(() => {
    const x = new AbortController();
    return Ve("loading"), fetch(`${Dt()}apps/metraink/api/billing-profile`, { credentials: "same-origin", cache: "no-store", signal: x.signal }).then((M) => {
      if (!M.ok) throw new Error("PROFILE_UNAVAILABLE");
      return M.json();
    }).then((M) => {
      if (x.signal.aborted) return;
      if ((M == null ? void 0 : M.authenticated) === !1) {
        Ie(!1), $e("online"), Ve("guest");
        return;
      }
      if ((M == null ? void 0 : M.authenticated) !== !0 || !Array.isArray(M.methods)) throw new Error("PROFILE_INVALID");
      const G = M.methods.includes("habitual");
      Ie(G), G || $e("online"), Ve("ready"), te(typeof M.csrf == "string" ? M.csrf : ""), rt(typeof M.digest == "string" ? M.digest : null), M.manualBonosEnabled === !0 && typeof M.csrf == "string" && xn(M.csrf), M.billing && !Oe.current && (A(M.billing.legalName ?? ""), Q(M.billing.taxId ?? ""), Oe.current = !0);
    }).catch(() => {
      x.signal.aborted || (Ie(!1), $e("online"), Ve("error"));
    }), () => x.abort();
  }, [wt]);
  async function Br() {
    if (!(T || !W)) {
      U(!0), ye("");
      try {
        const x = await fetch(`${Dt()}apps/metraink/api/billing-profile`, {
          method: "POST",
          credentials: "same-origin",
          cache: "no-store",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ csrf: W, digest: ft, billing: { version: 1, legalName: ee, taxId: oe, country: V.countryCode } })
        }), M = await x.json();
        if (!x.ok || M.ok !== !0) throw new Error("No se guardaron los datos fiscales. Actualiza tus condiciones y vuelve a intentarlo.");
        ye("Nombre fiscal, NIF y país guardados en tu cuenta. La dirección habitual se gestiona desde tu cuenta."), lt((G) => G + 1);
      } catch (x) {
        ye(x instanceof Error ? x.message : "No se pudieron guardar los datos fiscales.");
      } finally {
        U(!1);
      }
    }
  }
  async function er(x) {
    var G;
    if (le) {
      K("Has elegido pagar con bono. Comprueba y confirma la reserva de sus metros, o cambia expresamente a pago por metro.");
      return;
    }
    if (T || !f.length || !((G = En.current) != null && G.reportValidity())) return;
    const M = At;
    U(!0), K("");
    try {
      const Ce = await fetch(`${Dt()}apps/metraink/api/private-checkout/${x}`, {
        method: "POST",
        credentials: "same-origin",
        cache: "no-store",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ ...jt, montageApproved: N, ticket: g == null ? void 0 : g.ticket })
      }), St = await Ce.json();
      if (!Ce.ok || St.ok === !1) throw new Error(St.message || "No se pudo comprobar la compra.");
      if (bn.current !== M) return;
      if (x === "quote") {
        c(St), St.deliveryOptions && F(St.deliveryOptions);
        return;
      }
      if (St.completed) {
        Gn([]), ie(!0);
        return;
      }
      if (typeof St.invoiceUrl != "string") throw new Error("No se recibió el enlace de pago.");
      const sn = new URL(St.invoiceUrl);
      if (sn.protocol !== "https:" || sn.username || sn.password) throw new Error("Enlace de pago no válido.");
      window.location.assign(sn.href);
    } catch (Ce) {
      K(Ce instanceof Error ? Ce.message : "No se pudo continuar.");
    } finally {
      U(!1);
    }
  }
  return q ? /* @__PURE__ */ h.jsx("section", { id: "cesta-metraink", ref: Ut, tabIndex: -1, className: "mk-private-cart mk-private-complete", "aria-labelledby": "mk-order-complete-title", children: /* @__PURE__ */ h.jsxs("div", { className: "mk-private-confirmation", role: "status", children: [
    /* @__PURE__ */ h.jsx("span", { className: "mk-private-confirmation-icon", "aria-hidden": "true", children: "✓" }),
    /* @__PURE__ */ h.jsx("span", { className: "mk-private-eyebrow", children: "Metraink" }),
    /* @__PURE__ */ h.jsx("h2", { id: "mk-order-complete-title", children: "Pedido registrado" }),
    /* @__PURE__ */ h.jsx("p", { children: Re === "habitual" ? "Queda registrado con tu forma de pago habitual. No se ha cobrado online." : "Puedes consultar su estado en tu historial de pedidos." }),
    /* @__PURE__ */ h.jsx("button", { type: "button", className: "primary", onClick: S, children: "Volver al configurador" })
  ] }) }) : f.length ? /* @__PURE__ */ h.jsxs("section", { id: "cesta-metraink", ref: Ut, tabIndex: -1, className: "mk-private-cart", "aria-label": "Cesta y confirmación del pedido", children: [
    /* @__PURE__ */ h.jsxs("header", { children: [
      /* @__PURE__ */ h.jsx("span", { className: "mk-private-eyebrow", children: "Pedido preparado" }),
      /* @__PURE__ */ h.jsxs("h2", { children: [
        "Tu producción ",
        /* @__PURE__ */ h.jsx("em", { children: "lista para imprimir." })
      ] }),
      /* @__PURE__ */ h.jsx("p", { children: "Revisa los metros, servicios y detalles técnicos antes de continuar al pago seguro de Shopify." })
    ] }),
    Ft && /* @__PURE__ */ h.jsx("p", { role: "status", children: Ft }),
    qn,
    /* @__PURE__ */ h.jsxs("div", { className: "mk-private-grid", children: [
      /* @__PURE__ */ h.jsxs("div", { children: [
        /* @__PURE__ */ h.jsx("div", { className: "mk-private-jobs", children: f.map((x) => /* @__PURE__ */ h.jsxs("article", { children: [
          /* @__PURE__ */ h.jsx("img", { src: `${Dt()}apps/metraink/api/jobs/${encodeURIComponent(x.token)}/preview`, alt: `Montaje aprobado · ${x.label}` }),
          /* @__PURE__ */ h.jsxs("div", { children: [
            /* @__PURE__ */ h.jsx("strong", { children: x.label }),
            /* @__PURE__ */ h.jsxs("p", { children: [
              "Montaje preparado · ",
              x.delivery === "pickup" ? "Recogida" : "Envío"
            ] }),
            /* @__PURE__ */ h.jsx("p", { children: "Los metros reales y facturados se muestran en el resumen al comprobar el importe." }),
            /* @__PURE__ */ h.jsx("button", { type: "button", className: "text-button", disabled: T, onClick: () => {
              const M = f.filter((G) => G.token !== x.token);
              Gn(M), Y(M);
            }, children: "Quitar de esta cesta" }),
            x.manualBonus && /* @__PURE__ */ h.jsx("p", { children: "Impresión cubierta con tu bono. Se comprobarán servicios y entrega antes de confirmar." }),
            x.requestedPayment === "balance" && !x.manualBonus && /* @__PURE__ */ h.jsxs("div", { role: "status", children: [
              /* @__PURE__ */ h.jsxs("p", { children: [
                /* @__PURE__ */ h.jsx("strong", { children: "Has elegido pagar con bono." }),
                " Aún no se ha descontado saldo. Confirma la reserva con el botón de abajo; no cobraremos este trabajo como metros sueltos."
              ] }),
              !ge && /* @__PURE__ */ h.jsx("p", { children: "Esperando comprobar tu sesión y el acceso al bono. Si no se habilita, actualiza las condiciones de pago." }),
              /* @__PURE__ */ h.jsx("button", { type: "button", className: "secondary", disabled: T, onClick: () => {
                const M = f.map((G) => G.token === x.token ? { ...G, requestedPayment: "metres" } : G);
                Gn(M), Y(M), c(null), L(!1);
              }, children: "Cambiar a pagar por metro y conservar mi bono" })
            ] }),
            ge && !x.manualBonus && /* @__PURE__ */ h.jsx(Gf, { root: Dt(), token: x.token, csrf: ge, busy: T, onBusy: U, onResolved: (M) => {
              const G = f.filter((Ce) => Ce.token !== x.token);
              Gn(G), Y(G), c(null), L(!1), on(M.status === "reserved" ? `Solicitud de ${M.metres} m registrada para revisión. Los metros están reservados; no se ha creado ni cobrado un pedido. Metraink debe confirmar servicios y entrega.` : "Esta solicitud fue cancelada y sus metros liberados. El montaje queda fuera de esta cesta; prepara una nueva solicitud para volver a utilizarlo.");
            } })
          ] })
        ] }, x.token)) }),
        /* @__PURE__ */ h.jsx("button", { type: "button", className: "secondary", disabled: T, onClick: S, children: "Añadir otro trabajo" }),
        !f.length && /* @__PURE__ */ h.jsx("p", { children: "La cesta está vacía. Prepara y aprueba un montaje para continuar." }),
        f.length > 0 && /* @__PURE__ */ h.jsx("form", { ref: En, onSubmit: (x) => {
          x.preventDefault(), er("quote");
        }, children: /* @__PURE__ */ h.jsxs("fieldset", { disabled: T, className: "mk-private-form", children: [
          /* @__PURE__ */ h.jsx("legend", { children: "Facturación" }),
          /* @__PURE__ */ h.jsxs("label", { children: [
            "Correo electrónico",
            /* @__PURE__ */ h.jsx("input", { type: "email", value: pe, required: !0, maxLength: 254, autoComplete: "email", onChange: (x) => X(x.target.value) })
          ] }),
          /* @__PURE__ */ h.jsxs("label", { children: [
            "Nombre fiscal / razón social",
            /* @__PURE__ */ h.jsx("input", { value: ee, required: !0, minLength: 2, maxLength: 160, onChange: (x) => A(x.target.value) })
          ] }),
          /* @__PURE__ */ h.jsxs("label", { children: [
            "DNI / NIF / NIE",
            /* @__PURE__ */ h.jsx("input", { value: oe, required: !0, minLength: 3, maxLength: 30, onChange: (x) => Q(x.target.value) })
          ] }),
          /* @__PURE__ */ h.jsx(Aa, { label: "Dirección de facturación", value: V, onChange: (x) => {
            b(x), ne("");
          } }),
          (C == null ? void 0 : C.accountUrl) && /* @__PURE__ */ h.jsxs("p", { children: [
            "Usamos los datos disponibles en tu cuenta. Puedes modificarlos para este pedido. ",
            /* @__PURE__ */ h.jsx("a", { href: C.accountUrl, target: "_blank", rel: "noopener", children: "Gestionar la dirección habitual en mi cuenta" }),
            "."
          ] }),
          W && /* @__PURE__ */ h.jsx("button", { type: "button", className: "secondary", disabled: T || Ke === "loading", onClick: () => void Br(), children: "Guardar nombre fiscal y NIF para próximas compras" }),
          We && /* @__PURE__ */ h.jsx("p", { role: "status", children: We }),
          dt === "shipping" && /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
            /* @__PURE__ */ h.jsxs("label", { className: "mk-private-check", children: [
              /* @__PURE__ */ h.jsx("input", { type: "checkbox", checked: Be, onChange: (x) => {
                Pe(x.target.checked), ne("");
              } }),
              " Enviar a esta misma dirección"
            ] }),
            !Be && /* @__PURE__ */ h.jsx(Aa, { label: "Dirección de entrega", value: Ee, onChange: (x) => {
              we(x), ne("");
            } })
          ] }),
          /* @__PURE__ */ h.jsxs("label", { children: [
            "Cómo quieres recibir el pedido",
            /* @__PURE__ */ h.jsxs("select", { value: dt, disabled: f.some((x) => x.manualBonus) || (g == null ? void 0 : g.reserved) === !0, onChange: (x) => un(x.target.value), children: [
              /* @__PURE__ */ h.jsx("option", { value: "shipping", children: "Envío a domicilio" }),
              /* @__PURE__ */ h.jsx("option", { value: "pickup", children: "Recogida en tienda" })
            ] })
          ] }),
          f.some((x) => x.manualBonus) && /* @__PURE__ */ h.jsx("p", { children: "La entrega está vinculada a la reserva de tu bono. Contacta con Metraink para cambiarla sin alterar tus envíos reservados." }),
          /* @__PURE__ */ h.jsxs("label", { children: [
            "Forma de pago",
            /* @__PURE__ */ h.jsxs("select", { value: Re, onChange: (x) => $e(x.target.value), children: [
              /* @__PURE__ */ h.jsx("option", { value: "online", children: "Pago online en Shopify" }),
              ze && /* @__PURE__ */ h.jsx("option", { value: "habitual", children: "Forma de pago habitual" })
            ] })
          ] }),
          /* @__PURE__ */ h.jsxs("div", { role: "status", children: [
            Ke === "loading" && /* @__PURE__ */ h.jsx("p", { children: "Comprobando tus condiciones de pago…" }),
            Ke === "error" && /* @__PURE__ */ h.jsx("p", { children: "No hemos podido comprobar tu pago habitual. No significa que no esté autorizado. Reintenta la consulta antes de continuar." }),
            Ke === "guest" && /* @__PURE__ */ h.jsxs("p", { children: [
              "Para usar el pago habitual, ",
              /* @__PURE__ */ h.jsx("a", { href: `${Dt()}account/login?return_url=${encodeURIComponent(`${Dt()}cart`)}`, children: "inicia sesión con tu cuenta autorizada" }),
              "."
            ] }),
            Ke === "ready" && /* @__PURE__ */ h.jsx("p", { children: ze ? "Tu pago habitual está autorizado. Puedes seleccionarlo arriba." : "No se ha recibido autorización de pago habitual para esta cuenta. Si acabamos de activártelo, actualiza la consulta." }),
            /* @__PURE__ */ h.jsx("button", { type: "button", className: "text-button", disabled: T || Ke === "loading", onClick: () => lt((x) => x + 1), children: "Actualizar condiciones de pago" })
          ] }),
          /* @__PURE__ */ h.jsxs("p", { children: [
            "¿Trabajas habitualmente con nosotros? ",
            /* @__PURE__ */ h.jsx("a", { href: "mailto:info@metraink.com", children: "Consulta tus condiciones de pago." })
          ] }),
          v.length > 0 && /* @__PURE__ */ h.jsxs("label", { children: [
            dt === "pickup" ? "Punto de recogida" : "Entrega",
            /* @__PURE__ */ h.jsxs(
              "select",
              {
                value: Le,
                onChange: (x) => {
                  ne(x.target.value);
                },
                children: [
                  /* @__PURE__ */ h.jsx("option", { value: "", children: "Selecciona una opción" }),
                  v.filter((x) => x.kind === dt).map((x) => /* @__PURE__ */ h.jsxs("option", { value: x.handle, children: [
                    x.title,
                    " · ",
                    Zn(x.cents)
                  ] }, x.handle))
                ]
              }
            )
          ] }),
          v.length > 0 && !v.some((x) => x.kind === dt) && /* @__PURE__ */ h.jsx("p", { role: "alert", children: "Shopify no ha devuelto opciones para esta entrega. Contacta con Metraink antes de continuar." }),
          /* @__PURE__ */ h.jsx("button", { type: "submit", className: "secondary", children: T ? "Comprobando…" : "Comprobar importe y entrega" })
        ] }) })
      ] }),
      /* @__PURE__ */ h.jsxs("aside", { className: "mk-private-summary", "aria-live": "polite", children: [
        /* @__PURE__ */ h.jsx("h3", { children: "Resumen del pedido" }),
        /* @__PURE__ */ h.jsxs("dl", { children: [
          /* @__PURE__ */ h.jsxs("div", { children: [
            /* @__PURE__ */ h.jsx("dt", { children: "Impresión" }),
            /* @__PURE__ */ h.jsx("dd", { children: Zn(g == null ? void 0 : g.printingCents) })
          ] }),
          /* @__PURE__ */ h.jsxs("div", { children: [
            /* @__PURE__ */ h.jsx("dt", { children: "Control profesional" }),
            /* @__PURE__ */ h.jsx("dd", { children: Zn(g == null ? void 0 : g.servicesCents) })
          ] }),
          /* @__PURE__ */ h.jsxs("div", { children: [
            /* @__PURE__ */ h.jsx("dt", { children: dt === "pickup" ? "Recogida" : "Envío" }),
            /* @__PURE__ */ h.jsx("dd", { children: Zn(g == null ? void 0 : g.shippingCents) })
          ] }),
          /* @__PURE__ */ h.jsxs("div", { children: [
            /* @__PURE__ */ h.jsx("dt", { children: "IVA" }),
            /* @__PURE__ */ h.jsx("dd", { children: Zn(g == null ? void 0 : g.taxCents) })
          ] }),
          /* @__PURE__ */ h.jsxs("div", { className: "mk-private-total", children: [
            /* @__PURE__ */ h.jsx("dt", { children: "Total" }),
            /* @__PURE__ */ h.jsx("dd", { children: Zn(g == null ? void 0 : g.totalCents) })
          ] })
        ] }),
        (Cn = g == null ? void 0 : g.roundingGroups) == null ? void 0 : Cn.map((x) => /* @__PURE__ */ h.jsxs("p", { children: [
          { dti56: "DTI Textil", dtf75: "DTF Textil", uv56: "DTF UV" }[x.productCode] ?? x.productCode,
          ": ",
          x.productionLengthM.toLocaleString("es-ES", { maximumFractionDigits: 4 }),
          " m reales · ",
          x.quote.boughtMetres,
          " m facturados",
          x.quote.giftMetres > 0 ? ` + ${x.quote.giftMetres} m de regalo` : "",
          ".",
          x.waivedLengthM > 0 ? " Exceso final dentro de 6 cm incluido sin coste." : ""
        ] }, x.productCode)),
        /* @__PURE__ */ h.jsxs("label", { className: "mk-private-check", children: [
          /* @__PURE__ */ h.jsx(
            "input",
            {
              type: "checkbox",
              checked: N,
              disabled: T || (g == null ? void 0 : g.totalCents) === void 0,
              onChange: (x) => L(x.target.checked)
            }
          ),
          " Confirmo los montajes, los datos y el importe de esta compra."
        ] }),
        /* @__PURE__ */ h.jsx("button", { type: "button", className: "primary", disabled: T || le || !N || !(g != null && g.ticket) && !(g != null && g.reserved), onClick: () => void er("create"), children: T ? "Preparando…" : Re === "habitual" ? "Confirmar con pago habitual" : "Continuar al pago seguro" }),
        /* @__PURE__ */ h.jsx("p", { children: Re === "habitual" ? "Se registrará pendiente de cobro según vuestro acuerdo." : "El pago se realiza en el checkout de Shopify." }),
        $ && /* @__PURE__ */ h.jsx("p", { role: "alert", className: "mk-private-error", children: $ })
      ] })
    ] })
  ] }) : /* @__PURE__ */ h.jsx("section", { id: "cesta-metraink", ref: Ut, tabIndex: -1, className: "mk-private-cart", "aria-label": "Cesta vacía", children: /* @__PURE__ */ h.jsxs("div", { className: "mk-private-empty", children: [
    Ft && /* @__PURE__ */ h.jsx("p", { role: "status", children: Ft }),
    $ && /* @__PURE__ */ h.jsx("p", { role: "alert", children: $ }),
    /* @__PURE__ */ h.jsx("span", { className: "mk-private-eyebrow", children: "Tu producción DTF" }),
    /* @__PURE__ */ h.jsxs("h2", { children: [
      "Tu próximo pedido ",
      /* @__PURE__ */ h.jsx("em", { children: "empieza aquí." })
    ] }),
    /* @__PURE__ */ h.jsx("p", { children: "Sube tus archivos y calcularemos automáticamente los metros que necesitas." }),
    /* @__PURE__ */ h.jsxs("button", { type: "button", className: "primary", onClick: S, children: [
      "Preparar mi pedido ",
      /* @__PURE__ */ h.jsx("span", { "aria-hidden": "true", children: "↗" })
    ] }),
    qn
  ] }) });
}
const Gl = document.querySelector("[data-metraink-cart-page]");
if (Gl) {
  const S = Gl.dataset, C = S.customerEmail ? {
    email: S.customerEmail,
    legalName: S.customerCompany || "",
    accountUrl: S.accountUrl || "/account",
    address: { firstName: S.customerFirstName || "", lastName: S.customerLastName || "", address1: S.customerAddress1 || "", address2: S.customerAddress2 || "", city: S.customerCity || "", zip: S.customerZip || "", countryCode: S.customerCountry || "ES" }
  } : void 0;
  Wf.createRoot(Gl).render(/* @__PURE__ */ h.jsx(ed, { initialProfile: C, onBack: () => {
    window.location.assign(Gl.dataset.configuratorUrl || "/#configurador");
  } }));
}
